// source: proto/mdds/v1/mdds.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.proto.mdds.v1.BoardEvent', null, global);
goog.exportSymbol('proto.proto.mdds.v1.BoardEventID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.BoardID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ChangeOfContract', null, global);
goog.exportSymbol('proto.proto.mdds.v1.CouponPaymentDate', null, global);
goog.exportSymbol('proto.proto.mdds.v1.DeemTradePrice', null, global);
goog.exportSymbol('proto.proto.mdds.v1.DelistedInstrument', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Disclosure', null, global);
goog.exportSymbol('proto.proto.mdds.v1.DrvProductEvent', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ELWUnderlyingAssets', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ETFIndexComposition', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ETFTrackingError', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ETFiIndex', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ETFiNav', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ForeignerOrderLimit', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Holiday', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Index', null, global);
goog.exportSymbol('proto.proto.mdds.v1.IndexConstituentsInformation', null, global);
goog.exportSymbol('proto.proto.mdds.v1.InstrumentDerivatives', null, global);
goog.exportSymbol('proto.proto.mdds.v1.InstrumentSBR', null, global);
goog.exportSymbol('proto.proto.mdds.v1.InvestorPerIndustry', null, global);
goog.exportSymbol('proto.proto.mdds.v1.InvestorPerSymbol', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ListSectorVolatility', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ListStockVolatility', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MDEntry', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MDEntryRecovery', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MarketID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MarketIndex', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MarketIndexClass', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MarketMakerInformation', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MarketMakingContract', null, global);
goog.exportSymbol('proto.proto.mdds.v1.MemberTrader', null, global);
goog.exportSymbol('proto.proto.mdds.v1.OpenInterest', null, global);
goog.exportSymbol('proto.proto.mdds.v1.OrderMini', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Price', null, global);
goog.exportSymbol('proto.proto.mdds.v1.PriceLimitExpansion', null, global);
goog.exportSymbol('proto.proto.mdds.v1.PriceRecovery', null, global);
goog.exportSymbol('proto.proto.mdds.v1.ProductGrpID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.PutOrCall', null, global);
goog.exportSymbol('proto.proto.mdds.v1.RandomEnd', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SIExerciseStyle', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SISecurityStatus', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SectorTypeCode', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SectorVolatility', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SecurityDefinition', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SecurityGroupID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SecurityInformationNotification', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SecurityStatus', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SettleMethod', null, global);
goog.exportSymbol('proto.proto.mdds.v1.StockInfo', null, global);
goog.exportSymbol('proto.proto.mdds.v1.StockVolatility', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SymbolAdminStatusCode', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SymbolBoardEvent', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SymbolClosingInformation', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SymbolEvent', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SymbolTradingMethodStatusCode', null, global);
goog.exportSymbol('proto.proto.mdds.v1.SymbolTradingSanctionStatusCode', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Tick', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Tick.Side', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Timestamp', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TopNMembersPerSymbol', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TopPrice', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TradingResultOfForeignInvestor', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TradingSchedule', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TradingSessionID', null, global);
goog.exportSymbol('proto.proto.mdds.v1.TscProdGrpId', null, global);
goog.exportSymbol('proto.proto.mdds.v1.VolatilityInterruption', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Wrapper', null, global);
goog.exportSymbol('proto.proto.mdds.v1.Wrapper.KindCase', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.Wrapper = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.proto.mdds.v1.Wrapper.oneofGroups_);
};
goog.inherits(proto.proto.mdds.v1.Wrapper, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.Wrapper.displayName = 'proto.proto.mdds.v1.Wrapper';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.SecurityDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.SecurityDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.SecurityDefinition.displayName = 'proto.proto.mdds.v1.SecurityDefinition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.SecurityStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.SecurityStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.SecurityStatus.displayName = 'proto.proto.mdds.v1.SecurityStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.SecurityInformationNotification = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.SecurityInformationNotification, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.SecurityInformationNotification.displayName = 'proto.proto.mdds.v1.SecurityInformationNotification';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.SymbolClosingInformation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.SymbolClosingInformation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.SymbolClosingInformation.displayName = 'proto.proto.mdds.v1.SymbolClosingInformation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.VolatilityInterruption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.VolatilityInterruption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.VolatilityInterruption.displayName = 'proto.proto.mdds.v1.VolatilityInterruption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.MarketMakerInformation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.MarketMakerInformation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.MarketMakerInformation.displayName = 'proto.proto.mdds.v1.MarketMakerInformation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.SymbolEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.SymbolEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.SymbolEvent.displayName = 'proto.proto.mdds.v1.SymbolEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.DrvProductEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.DrvProductEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.DrvProductEvent.displayName = 'proto.proto.mdds.v1.DrvProductEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.IndexConstituentsInformation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.IndexConstituentsInformation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.IndexConstituentsInformation.displayName = 'proto.proto.mdds.v1.IndexConstituentsInformation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.RandomEnd = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.RandomEnd, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.RandomEnd.displayName = 'proto.proto.mdds.v1.RandomEnd';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.Price = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, proto.proto.mdds.v1.Price.repeatedFields_, null);
};
goog.inherits(proto.proto.mdds.v1.Price, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.Price.displayName = 'proto.proto.mdds.v1.Price';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.MDEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.MDEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.MDEntry.displayName = 'proto.proto.mdds.v1.MDEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.PriceRecovery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, proto.proto.mdds.v1.PriceRecovery.repeatedFields_, null);
};
goog.inherits(proto.proto.mdds.v1.PriceRecovery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.PriceRecovery.displayName = 'proto.proto.mdds.v1.PriceRecovery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.MDEntryRecovery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.MDEntryRecovery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.MDEntryRecovery.displayName = 'proto.proto.mdds.v1.MDEntryRecovery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.Index = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.Index, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.Index.displayName = 'proto.proto.mdds.v1.Index';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.InvestorPerIndustry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.InvestorPerIndustry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.InvestorPerIndustry.displayName = 'proto.proto.mdds.v1.InvestorPerIndustry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.InvestorPerSymbol = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.InvestorPerSymbol, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.InvestorPerSymbol.displayName = 'proto.proto.mdds.v1.InvestorPerSymbol';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.TopNMembersPerSymbol = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.TopNMembersPerSymbol, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.TopNMembersPerSymbol.displayName = 'proto.proto.mdds.v1.TopNMembersPerSymbol';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.OpenInterest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.OpenInterest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.OpenInterest.displayName = 'proto.proto.mdds.v1.OpenInterest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.DeemTradePrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.DeemTradePrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.DeemTradePrice.displayName = 'proto.proto.mdds.v1.DeemTradePrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.ForeignerOrderLimit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.ForeignerOrderLimit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.ForeignerOrderLimit.displayName = 'proto.proto.mdds.v1.ForeignerOrderLimit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.PriceLimitExpansion = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.PriceLimitExpansion, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.PriceLimitExpansion.displayName = 'proto.proto.mdds.v1.PriceLimitExpansion';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.ETFiNav = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.ETFiNav, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.ETFiNav.displayName = 'proto.proto.mdds.v1.ETFiNav';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.ETFiIndex = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.ETFiIndex, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.ETFiIndex.displayName = 'proto.proto.mdds.v1.ETFiIndex';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.ETFTrackingError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.ETFTrackingError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.ETFTrackingError.displayName = 'proto.proto.mdds.v1.ETFTrackingError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.displayName = 'proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.displayName = 'proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.displayName = 'proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.displayName = 'proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.TradingResultOfForeignInvestor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.TradingResultOfForeignInvestor.displayName = 'proto.proto.mdds.v1.TradingResultOfForeignInvestor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.Disclosure = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.Disclosure, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.Disclosure.displayName = 'proto.proto.mdds.v1.Disclosure';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.Timestamp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, 500, null, null);
};
goog.inherits(proto.proto.mdds.v1.Timestamp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.Timestamp.displayName = 'proto.proto.mdds.v1.Timestamp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.DelistedInstrument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.DelistedInstrument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.DelistedInstrument.displayName = 'proto.proto.mdds.v1.DelistedInstrument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.CouponPaymentDate = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.CouponPaymentDate, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.CouponPaymentDate.displayName = 'proto.proto.mdds.v1.CouponPaymentDate';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.ChangeOfContract = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.ChangeOfContract, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.ChangeOfContract.displayName = 'proto.proto.mdds.v1.ChangeOfContract';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.InstrumentDerivatives = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.InstrumentDerivatives, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.InstrumentDerivatives.displayName = 'proto.proto.mdds.v1.InstrumentDerivatives';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.InstrumentSBR = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.InstrumentSBR, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.InstrumentSBR.displayName = 'proto.proto.mdds.v1.InstrumentSBR';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.TradingSchedule = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.TradingSchedule, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.TradingSchedule.displayName = 'proto.proto.mdds.v1.TradingSchedule';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.Holiday = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.Holiday, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.Holiday.displayName = 'proto.proto.mdds.v1.Holiday';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.MemberTrader = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.MemberTrader, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.MemberTrader.displayName = 'proto.proto.mdds.v1.MemberTrader';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.MarketMakingContract = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.MarketMakingContract, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.MarketMakingContract.displayName = 'proto.proto.mdds.v1.MarketMakingContract';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.ETFIndexComposition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.ETFIndexComposition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.ETFIndexComposition.displayName = 'proto.proto.mdds.v1.ETFIndexComposition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.ELWUnderlyingAssets = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.ELWUnderlyingAssets, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.ELWUnderlyingAssets.displayName = 'proto.proto.mdds.v1.ELWUnderlyingAssets';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.ListSectorVolatility = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.mdds.v1.ListSectorVolatility.repeatedFields_, null);
};
goog.inherits(proto.proto.mdds.v1.ListSectorVolatility, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.ListSectorVolatility.displayName = 'proto.proto.mdds.v1.ListSectorVolatility';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.SectorVolatility = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.mdds.v1.SectorVolatility.repeatedFields_, null);
};
goog.inherits(proto.proto.mdds.v1.SectorVolatility, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.SectorVolatility.displayName = 'proto.proto.mdds.v1.SectorVolatility';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.ListStockVolatility = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.mdds.v1.ListStockVolatility.repeatedFields_, null);
};
goog.inherits(proto.proto.mdds.v1.ListStockVolatility, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.ListStockVolatility.displayName = 'proto.proto.mdds.v1.ListStockVolatility';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.StockVolatility = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.StockVolatility, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.StockVolatility.displayName = 'proto.proto.mdds.v1.StockVolatility';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.StockInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.StockInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.StockInfo.displayName = 'proto.proto.mdds.v1.StockInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.BoardEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.BoardEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.BoardEvent.displayName = 'proto.proto.mdds.v1.BoardEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.SymbolBoardEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.SymbolBoardEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.SymbolBoardEvent.displayName = 'proto.proto.mdds.v1.SymbolBoardEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.MarketIndex = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.MarketIndex, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.MarketIndex.displayName = 'proto.proto.mdds.v1.MarketIndex';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.Tick = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.Tick, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.Tick.displayName = 'proto.proto.mdds.v1.Tick';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.TopPrice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.proto.mdds.v1.TopPrice.repeatedFields_, null);
};
goog.inherits(proto.proto.mdds.v1.TopPrice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.TopPrice.displayName = 'proto.proto.mdds.v1.TopPrice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.mdds.v1.OrderMini = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.mdds.v1.OrderMini, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.mdds.v1.OrderMini.displayName = 'proto.proto.mdds.v1.OrderMini';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.proto.mdds.v1.Wrapper.oneofGroups_ = [[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49]];

/**
 * @enum {number}
 */
proto.proto.mdds.v1.Wrapper.KindCase = {
  KIND_NOT_SET: 0,
  SECURITY_DEFINITION: 1,
  SECURITY_STATUS: 2,
  SECURITY_INFORMATION_NOTIFICATION: 3,
  SYMBOL_CLOSING_INFORMATION: 4,
  VOLATILITY_INTERRUPTION: 5,
  MARKET_MAKER_INFORMATION: 6,
  SYMBOL_EVENT: 7,
  INDEX_CONSTITUENTS_INFORMATION: 8,
  RANDOM_END: 9,
  PRICE: 10,
  PRICE_RECOVERY: 11,
  INDEX: 12,
  INVESTOR_PER_INDUSTRY: 13,
  INVESTOR_PER_SYMBOL: 14,
  TOP_N_MEMBERS_PER_SYMBOL: 15,
  OPEN_INTEREST: 16,
  DEEM_TRADE_PRICE: 17,
  FOREIGNER_ORDER_LIMIT: 18,
  PRICE_LIMIT_EXPANSION: 19,
  ETF_I_NAV: 20,
  ETF_I_INDEX: 21,
  ETF_TRACKING_ERROR: 22,
  TOP_N_SYMBOLS_WITH_TRADING_QUANTITY: 23,
  TOP_N_SYMBOLS_WITH_CURRENT_PRICE: 24,
  TOP_N_SYMBOLS_WITH_HIGH_RATIO_OF_PRICE: 25,
  TOP_N_SYMBOLS_WITH_LOW_RATIO_OF_PRICE: 26,
  TRADING_RESULT_OF_FOREIGN_INVESTOR: 27,
  DISCLOSURE: 28,
  TIMESTAMP: 29,
  DELISTED_INSTRUMENT: 30,
  COUPON_PAYMENT_DATE: 31,
  CHANGE_OF_CONTRACT: 32,
  INSTRUMENT_DERIVATIVES: 33,
  INSTRUMENT_SBR: 34,
  TRADING_SCHEDULE: 35,
  HOLIDAY: 36,
  MEMBER_TRADER: 37,
  MARKET_MAKING_CONTRACT: 38,
  ETF_INDEX_COMPOSITION: 39,
  ELW_UNDERLYING_ASSETS: 40,
  STOCK_INFO: 41,
  MARKET_INDEX: 42,
  BOARD_EVENT: 43,
  SYMBOL_BOARD_EVENT: 44,
  TICK: 45,
  TOP_PRICE: 46,
  DRV_PRODUCT_EVENT: 47,
  LIST_SECTOR_VOLATILITY: 48,
  LIST_STOCK_VOLATILITY: 49
};

/**
 * @return {proto.proto.mdds.v1.Wrapper.KindCase}
 */
proto.proto.mdds.v1.Wrapper.prototype.getKindCase = function() {
  return /** @type {proto.proto.mdds.v1.Wrapper.KindCase} */(jspb.Message.computeOneofCase(this, proto.proto.mdds.v1.Wrapper.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.Wrapper.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.Wrapper.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.Wrapper} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Wrapper.toObject = function(includeInstance, msg) {
  var f, obj = {
    securityDefinition: (f = msg.getSecurityDefinition()) && proto.proto.mdds.v1.SecurityDefinition.toObject(includeInstance, f),
    securityStatus: (f = msg.getSecurityStatus()) && proto.proto.mdds.v1.SecurityStatus.toObject(includeInstance, f),
    securityInformationNotification: (f = msg.getSecurityInformationNotification()) && proto.proto.mdds.v1.SecurityInformationNotification.toObject(includeInstance, f),
    symbolClosingInformation: (f = msg.getSymbolClosingInformation()) && proto.proto.mdds.v1.SymbolClosingInformation.toObject(includeInstance, f),
    volatilityInterruption: (f = msg.getVolatilityInterruption()) && proto.proto.mdds.v1.VolatilityInterruption.toObject(includeInstance, f),
    marketMakerInformation: (f = msg.getMarketMakerInformation()) && proto.proto.mdds.v1.MarketMakerInformation.toObject(includeInstance, f),
    symbolEvent: (f = msg.getSymbolEvent()) && proto.proto.mdds.v1.SymbolEvent.toObject(includeInstance, f),
    indexConstituentsInformation: (f = msg.getIndexConstituentsInformation()) && proto.proto.mdds.v1.IndexConstituentsInformation.toObject(includeInstance, f),
    randomEnd: (f = msg.getRandomEnd()) && proto.proto.mdds.v1.RandomEnd.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && proto.proto.mdds.v1.Price.toObject(includeInstance, f),
    priceRecovery: (f = msg.getPriceRecovery()) && proto.proto.mdds.v1.PriceRecovery.toObject(includeInstance, f),
    index: (f = msg.getIndex()) && proto.proto.mdds.v1.Index.toObject(includeInstance, f),
    investorPerIndustry: (f = msg.getInvestorPerIndustry()) && proto.proto.mdds.v1.InvestorPerIndustry.toObject(includeInstance, f),
    investorPerSymbol: (f = msg.getInvestorPerSymbol()) && proto.proto.mdds.v1.InvestorPerSymbol.toObject(includeInstance, f),
    topNMembersPerSymbol: (f = msg.getTopNMembersPerSymbol()) && proto.proto.mdds.v1.TopNMembersPerSymbol.toObject(includeInstance, f),
    openInterest: (f = msg.getOpenInterest()) && proto.proto.mdds.v1.OpenInterest.toObject(includeInstance, f),
    deemTradePrice: (f = msg.getDeemTradePrice()) && proto.proto.mdds.v1.DeemTradePrice.toObject(includeInstance, f),
    foreignerOrderLimit: (f = msg.getForeignerOrderLimit()) && proto.proto.mdds.v1.ForeignerOrderLimit.toObject(includeInstance, f),
    priceLimitExpansion: (f = msg.getPriceLimitExpansion()) && proto.proto.mdds.v1.PriceLimitExpansion.toObject(includeInstance, f),
    etfINav: (f = msg.getEtfINav()) && proto.proto.mdds.v1.ETFiNav.toObject(includeInstance, f),
    etfIIndex: (f = msg.getEtfIIndex()) && proto.proto.mdds.v1.ETFiIndex.toObject(includeInstance, f),
    etfTrackingError: (f = msg.getEtfTrackingError()) && proto.proto.mdds.v1.ETFTrackingError.toObject(includeInstance, f),
    topNSymbolsWithTradingQuantity: (f = msg.getTopNSymbolsWithTradingQuantity()) && proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.toObject(includeInstance, f),
    topNSymbolsWithCurrentPrice: (f = msg.getTopNSymbolsWithCurrentPrice()) && proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.toObject(includeInstance, f),
    topNSymbolsWithHighRatioOfPrice: (f = msg.getTopNSymbolsWithHighRatioOfPrice()) && proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.toObject(includeInstance, f),
    topNSymbolsWithLowRatioOfPrice: (f = msg.getTopNSymbolsWithLowRatioOfPrice()) && proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.toObject(includeInstance, f),
    tradingResultOfForeignInvestor: (f = msg.getTradingResultOfForeignInvestor()) && proto.proto.mdds.v1.TradingResultOfForeignInvestor.toObject(includeInstance, f),
    disclosure: (f = msg.getDisclosure()) && proto.proto.mdds.v1.Disclosure.toObject(includeInstance, f),
    timestamp: (f = msg.getTimestamp()) && proto.proto.mdds.v1.Timestamp.toObject(includeInstance, f),
    delistedInstrument: (f = msg.getDelistedInstrument()) && proto.proto.mdds.v1.DelistedInstrument.toObject(includeInstance, f),
    couponPaymentDate: (f = msg.getCouponPaymentDate()) && proto.proto.mdds.v1.CouponPaymentDate.toObject(includeInstance, f),
    changeOfContract: (f = msg.getChangeOfContract()) && proto.proto.mdds.v1.ChangeOfContract.toObject(includeInstance, f),
    instrumentDerivatives: (f = msg.getInstrumentDerivatives()) && proto.proto.mdds.v1.InstrumentDerivatives.toObject(includeInstance, f),
    instrumentSbr: (f = msg.getInstrumentSbr()) && proto.proto.mdds.v1.InstrumentSBR.toObject(includeInstance, f),
    tradingSchedule: (f = msg.getTradingSchedule()) && proto.proto.mdds.v1.TradingSchedule.toObject(includeInstance, f),
    holiday: (f = msg.getHoliday()) && proto.proto.mdds.v1.Holiday.toObject(includeInstance, f),
    memberTrader: (f = msg.getMemberTrader()) && proto.proto.mdds.v1.MemberTrader.toObject(includeInstance, f),
    marketMakingContract: (f = msg.getMarketMakingContract()) && proto.proto.mdds.v1.MarketMakingContract.toObject(includeInstance, f),
    etfIndexComposition: (f = msg.getEtfIndexComposition()) && proto.proto.mdds.v1.ETFIndexComposition.toObject(includeInstance, f),
    elwUnderlyingAssets: (f = msg.getElwUnderlyingAssets()) && proto.proto.mdds.v1.ELWUnderlyingAssets.toObject(includeInstance, f),
    stockInfo: (f = msg.getStockInfo()) && proto.proto.mdds.v1.StockInfo.toObject(includeInstance, f),
    marketIndex: (f = msg.getMarketIndex()) && proto.proto.mdds.v1.MarketIndex.toObject(includeInstance, f),
    boardEvent: (f = msg.getBoardEvent()) && proto.proto.mdds.v1.BoardEvent.toObject(includeInstance, f),
    symbolBoardEvent: (f = msg.getSymbolBoardEvent()) && proto.proto.mdds.v1.SymbolBoardEvent.toObject(includeInstance, f),
    tick: (f = msg.getTick()) && proto.proto.mdds.v1.Tick.toObject(includeInstance, f),
    topPrice: (f = msg.getTopPrice()) && proto.proto.mdds.v1.TopPrice.toObject(includeInstance, f),
    drvProductEvent: (f = msg.getDrvProductEvent()) && proto.proto.mdds.v1.DrvProductEvent.toObject(includeInstance, f),
    listSectorVolatility: (f = msg.getListSectorVolatility()) && proto.proto.mdds.v1.ListSectorVolatility.toObject(includeInstance, f),
    listStockVolatility: (f = msg.getListStockVolatility()) && proto.proto.mdds.v1.ListStockVolatility.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.Wrapper}
 */
proto.proto.mdds.v1.Wrapper.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.Wrapper;
  return proto.proto.mdds.v1.Wrapper.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.Wrapper} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.Wrapper}
 */
proto.proto.mdds.v1.Wrapper.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.mdds.v1.SecurityDefinition;
      reader.readMessage(value,proto.proto.mdds.v1.SecurityDefinition.deserializeBinaryFromReader);
      msg.setSecurityDefinition(value);
      break;
    case 2:
      var value = new proto.proto.mdds.v1.SecurityStatus;
      reader.readMessage(value,proto.proto.mdds.v1.SecurityStatus.deserializeBinaryFromReader);
      msg.setSecurityStatus(value);
      break;
    case 3:
      var value = new proto.proto.mdds.v1.SecurityInformationNotification;
      reader.readMessage(value,proto.proto.mdds.v1.SecurityInformationNotification.deserializeBinaryFromReader);
      msg.setSecurityInformationNotification(value);
      break;
    case 4:
      var value = new proto.proto.mdds.v1.SymbolClosingInformation;
      reader.readMessage(value,proto.proto.mdds.v1.SymbolClosingInformation.deserializeBinaryFromReader);
      msg.setSymbolClosingInformation(value);
      break;
    case 5:
      var value = new proto.proto.mdds.v1.VolatilityInterruption;
      reader.readMessage(value,proto.proto.mdds.v1.VolatilityInterruption.deserializeBinaryFromReader);
      msg.setVolatilityInterruption(value);
      break;
    case 6:
      var value = new proto.proto.mdds.v1.MarketMakerInformation;
      reader.readMessage(value,proto.proto.mdds.v1.MarketMakerInformation.deserializeBinaryFromReader);
      msg.setMarketMakerInformation(value);
      break;
    case 7:
      var value = new proto.proto.mdds.v1.SymbolEvent;
      reader.readMessage(value,proto.proto.mdds.v1.SymbolEvent.deserializeBinaryFromReader);
      msg.setSymbolEvent(value);
      break;
    case 8:
      var value = new proto.proto.mdds.v1.IndexConstituentsInformation;
      reader.readMessage(value,proto.proto.mdds.v1.IndexConstituentsInformation.deserializeBinaryFromReader);
      msg.setIndexConstituentsInformation(value);
      break;
    case 9:
      var value = new proto.proto.mdds.v1.RandomEnd;
      reader.readMessage(value,proto.proto.mdds.v1.RandomEnd.deserializeBinaryFromReader);
      msg.setRandomEnd(value);
      break;
    case 10:
      var value = new proto.proto.mdds.v1.Price;
      reader.readMessage(value,proto.proto.mdds.v1.Price.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 11:
      var value = new proto.proto.mdds.v1.PriceRecovery;
      reader.readMessage(value,proto.proto.mdds.v1.PriceRecovery.deserializeBinaryFromReader);
      msg.setPriceRecovery(value);
      break;
    case 12:
      var value = new proto.proto.mdds.v1.Index;
      reader.readMessage(value,proto.proto.mdds.v1.Index.deserializeBinaryFromReader);
      msg.setIndex(value);
      break;
    case 13:
      var value = new proto.proto.mdds.v1.InvestorPerIndustry;
      reader.readMessage(value,proto.proto.mdds.v1.InvestorPerIndustry.deserializeBinaryFromReader);
      msg.setInvestorPerIndustry(value);
      break;
    case 14:
      var value = new proto.proto.mdds.v1.InvestorPerSymbol;
      reader.readMessage(value,proto.proto.mdds.v1.InvestorPerSymbol.deserializeBinaryFromReader);
      msg.setInvestorPerSymbol(value);
      break;
    case 15:
      var value = new proto.proto.mdds.v1.TopNMembersPerSymbol;
      reader.readMessage(value,proto.proto.mdds.v1.TopNMembersPerSymbol.deserializeBinaryFromReader);
      msg.setTopNMembersPerSymbol(value);
      break;
    case 16:
      var value = new proto.proto.mdds.v1.OpenInterest;
      reader.readMessage(value,proto.proto.mdds.v1.OpenInterest.deserializeBinaryFromReader);
      msg.setOpenInterest(value);
      break;
    case 17:
      var value = new proto.proto.mdds.v1.DeemTradePrice;
      reader.readMessage(value,proto.proto.mdds.v1.DeemTradePrice.deserializeBinaryFromReader);
      msg.setDeemTradePrice(value);
      break;
    case 18:
      var value = new proto.proto.mdds.v1.ForeignerOrderLimit;
      reader.readMessage(value,proto.proto.mdds.v1.ForeignerOrderLimit.deserializeBinaryFromReader);
      msg.setForeignerOrderLimit(value);
      break;
    case 19:
      var value = new proto.proto.mdds.v1.PriceLimitExpansion;
      reader.readMessage(value,proto.proto.mdds.v1.PriceLimitExpansion.deserializeBinaryFromReader);
      msg.setPriceLimitExpansion(value);
      break;
    case 20:
      var value = new proto.proto.mdds.v1.ETFiNav;
      reader.readMessage(value,proto.proto.mdds.v1.ETFiNav.deserializeBinaryFromReader);
      msg.setEtfINav(value);
      break;
    case 21:
      var value = new proto.proto.mdds.v1.ETFiIndex;
      reader.readMessage(value,proto.proto.mdds.v1.ETFiIndex.deserializeBinaryFromReader);
      msg.setEtfIIndex(value);
      break;
    case 22:
      var value = new proto.proto.mdds.v1.ETFTrackingError;
      reader.readMessage(value,proto.proto.mdds.v1.ETFTrackingError.deserializeBinaryFromReader);
      msg.setEtfTrackingError(value);
      break;
    case 23:
      var value = new proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity;
      reader.readMessage(value,proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.deserializeBinaryFromReader);
      msg.setTopNSymbolsWithTradingQuantity(value);
      break;
    case 24:
      var value = new proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice;
      reader.readMessage(value,proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.deserializeBinaryFromReader);
      msg.setTopNSymbolsWithCurrentPrice(value);
      break;
    case 25:
      var value = new proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice;
      reader.readMessage(value,proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.deserializeBinaryFromReader);
      msg.setTopNSymbolsWithHighRatioOfPrice(value);
      break;
    case 26:
      var value = new proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice;
      reader.readMessage(value,proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.deserializeBinaryFromReader);
      msg.setTopNSymbolsWithLowRatioOfPrice(value);
      break;
    case 27:
      var value = new proto.proto.mdds.v1.TradingResultOfForeignInvestor;
      reader.readMessage(value,proto.proto.mdds.v1.TradingResultOfForeignInvestor.deserializeBinaryFromReader);
      msg.setTradingResultOfForeignInvestor(value);
      break;
    case 28:
      var value = new proto.proto.mdds.v1.Disclosure;
      reader.readMessage(value,proto.proto.mdds.v1.Disclosure.deserializeBinaryFromReader);
      msg.setDisclosure(value);
      break;
    case 29:
      var value = new proto.proto.mdds.v1.Timestamp;
      reader.readMessage(value,proto.proto.mdds.v1.Timestamp.deserializeBinaryFromReader);
      msg.setTimestamp(value);
      break;
    case 30:
      var value = new proto.proto.mdds.v1.DelistedInstrument;
      reader.readMessage(value,proto.proto.mdds.v1.DelistedInstrument.deserializeBinaryFromReader);
      msg.setDelistedInstrument(value);
      break;
    case 31:
      var value = new proto.proto.mdds.v1.CouponPaymentDate;
      reader.readMessage(value,proto.proto.mdds.v1.CouponPaymentDate.deserializeBinaryFromReader);
      msg.setCouponPaymentDate(value);
      break;
    case 32:
      var value = new proto.proto.mdds.v1.ChangeOfContract;
      reader.readMessage(value,proto.proto.mdds.v1.ChangeOfContract.deserializeBinaryFromReader);
      msg.setChangeOfContract(value);
      break;
    case 33:
      var value = new proto.proto.mdds.v1.InstrumentDerivatives;
      reader.readMessage(value,proto.proto.mdds.v1.InstrumentDerivatives.deserializeBinaryFromReader);
      msg.setInstrumentDerivatives(value);
      break;
    case 34:
      var value = new proto.proto.mdds.v1.InstrumentSBR;
      reader.readMessage(value,proto.proto.mdds.v1.InstrumentSBR.deserializeBinaryFromReader);
      msg.setInstrumentSbr(value);
      break;
    case 35:
      var value = new proto.proto.mdds.v1.TradingSchedule;
      reader.readMessage(value,proto.proto.mdds.v1.TradingSchedule.deserializeBinaryFromReader);
      msg.setTradingSchedule(value);
      break;
    case 36:
      var value = new proto.proto.mdds.v1.Holiday;
      reader.readMessage(value,proto.proto.mdds.v1.Holiday.deserializeBinaryFromReader);
      msg.setHoliday(value);
      break;
    case 37:
      var value = new proto.proto.mdds.v1.MemberTrader;
      reader.readMessage(value,proto.proto.mdds.v1.MemberTrader.deserializeBinaryFromReader);
      msg.setMemberTrader(value);
      break;
    case 38:
      var value = new proto.proto.mdds.v1.MarketMakingContract;
      reader.readMessage(value,proto.proto.mdds.v1.MarketMakingContract.deserializeBinaryFromReader);
      msg.setMarketMakingContract(value);
      break;
    case 39:
      var value = new proto.proto.mdds.v1.ETFIndexComposition;
      reader.readMessage(value,proto.proto.mdds.v1.ETFIndexComposition.deserializeBinaryFromReader);
      msg.setEtfIndexComposition(value);
      break;
    case 40:
      var value = new proto.proto.mdds.v1.ELWUnderlyingAssets;
      reader.readMessage(value,proto.proto.mdds.v1.ELWUnderlyingAssets.deserializeBinaryFromReader);
      msg.setElwUnderlyingAssets(value);
      break;
    case 41:
      var value = new proto.proto.mdds.v1.StockInfo;
      reader.readMessage(value,proto.proto.mdds.v1.StockInfo.deserializeBinaryFromReader);
      msg.setStockInfo(value);
      break;
    case 42:
      var value = new proto.proto.mdds.v1.MarketIndex;
      reader.readMessage(value,proto.proto.mdds.v1.MarketIndex.deserializeBinaryFromReader);
      msg.setMarketIndex(value);
      break;
    case 43:
      var value = new proto.proto.mdds.v1.BoardEvent;
      reader.readMessage(value,proto.proto.mdds.v1.BoardEvent.deserializeBinaryFromReader);
      msg.setBoardEvent(value);
      break;
    case 44:
      var value = new proto.proto.mdds.v1.SymbolBoardEvent;
      reader.readMessage(value,proto.proto.mdds.v1.SymbolBoardEvent.deserializeBinaryFromReader);
      msg.setSymbolBoardEvent(value);
      break;
    case 45:
      var value = new proto.proto.mdds.v1.Tick;
      reader.readMessage(value,proto.proto.mdds.v1.Tick.deserializeBinaryFromReader);
      msg.setTick(value);
      break;
    case 46:
      var value = new proto.proto.mdds.v1.TopPrice;
      reader.readMessage(value,proto.proto.mdds.v1.TopPrice.deserializeBinaryFromReader);
      msg.setTopPrice(value);
      break;
    case 47:
      var value = new proto.proto.mdds.v1.DrvProductEvent;
      reader.readMessage(value,proto.proto.mdds.v1.DrvProductEvent.deserializeBinaryFromReader);
      msg.setDrvProductEvent(value);
      break;
    case 48:
      var value = new proto.proto.mdds.v1.ListSectorVolatility;
      reader.readMessage(value,proto.proto.mdds.v1.ListSectorVolatility.deserializeBinaryFromReader);
      msg.setListSectorVolatility(value);
      break;
    case 49:
      var value = new proto.proto.mdds.v1.ListStockVolatility;
      reader.readMessage(value,proto.proto.mdds.v1.ListStockVolatility.deserializeBinaryFromReader);
      msg.setListStockVolatility(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.Wrapper.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.Wrapper.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.Wrapper} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Wrapper.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecurityDefinition();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.mdds.v1.SecurityDefinition.serializeBinaryToWriter
    );
  }
  f = message.getSecurityStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.proto.mdds.v1.SecurityStatus.serializeBinaryToWriter
    );
  }
  f = message.getSecurityInformationNotification();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.proto.mdds.v1.SecurityInformationNotification.serializeBinaryToWriter
    );
  }
  f = message.getSymbolClosingInformation();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.proto.mdds.v1.SymbolClosingInformation.serializeBinaryToWriter
    );
  }
  f = message.getVolatilityInterruption();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.proto.mdds.v1.VolatilityInterruption.serializeBinaryToWriter
    );
  }
  f = message.getMarketMakerInformation();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.proto.mdds.v1.MarketMakerInformation.serializeBinaryToWriter
    );
  }
  f = message.getSymbolEvent();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.proto.mdds.v1.SymbolEvent.serializeBinaryToWriter
    );
  }
  f = message.getIndexConstituentsInformation();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.proto.mdds.v1.IndexConstituentsInformation.serializeBinaryToWriter
    );
  }
  f = message.getRandomEnd();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.proto.mdds.v1.RandomEnd.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.proto.mdds.v1.Price.serializeBinaryToWriter
    );
  }
  f = message.getPriceRecovery();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.proto.mdds.v1.PriceRecovery.serializeBinaryToWriter
    );
  }
  f = message.getIndex();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.proto.mdds.v1.Index.serializeBinaryToWriter
    );
  }
  f = message.getInvestorPerIndustry();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.proto.mdds.v1.InvestorPerIndustry.serializeBinaryToWriter
    );
  }
  f = message.getInvestorPerSymbol();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.proto.mdds.v1.InvestorPerSymbol.serializeBinaryToWriter
    );
  }
  f = message.getTopNMembersPerSymbol();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.proto.mdds.v1.TopNMembersPerSymbol.serializeBinaryToWriter
    );
  }
  f = message.getOpenInterest();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.proto.mdds.v1.OpenInterest.serializeBinaryToWriter
    );
  }
  f = message.getDeemTradePrice();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      proto.proto.mdds.v1.DeemTradePrice.serializeBinaryToWriter
    );
  }
  f = message.getForeignerOrderLimit();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      proto.proto.mdds.v1.ForeignerOrderLimit.serializeBinaryToWriter
    );
  }
  f = message.getPriceLimitExpansion();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      proto.proto.mdds.v1.PriceLimitExpansion.serializeBinaryToWriter
    );
  }
  f = message.getEtfINav();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      proto.proto.mdds.v1.ETFiNav.serializeBinaryToWriter
    );
  }
  f = message.getEtfIIndex();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.proto.mdds.v1.ETFiIndex.serializeBinaryToWriter
    );
  }
  f = message.getEtfTrackingError();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.proto.mdds.v1.ETFTrackingError.serializeBinaryToWriter
    );
  }
  f = message.getTopNSymbolsWithTradingQuantity();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.serializeBinaryToWriter
    );
  }
  f = message.getTopNSymbolsWithCurrentPrice();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.serializeBinaryToWriter
    );
  }
  f = message.getTopNSymbolsWithHighRatioOfPrice();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.serializeBinaryToWriter
    );
  }
  f = message.getTopNSymbolsWithLowRatioOfPrice();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.serializeBinaryToWriter
    );
  }
  f = message.getTradingResultOfForeignInvestor();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      proto.proto.mdds.v1.TradingResultOfForeignInvestor.serializeBinaryToWriter
    );
  }
  f = message.getDisclosure();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      proto.proto.mdds.v1.Disclosure.serializeBinaryToWriter
    );
  }
  f = message.getTimestamp();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      proto.proto.mdds.v1.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDelistedInstrument();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      proto.proto.mdds.v1.DelistedInstrument.serializeBinaryToWriter
    );
  }
  f = message.getCouponPaymentDate();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      proto.proto.mdds.v1.CouponPaymentDate.serializeBinaryToWriter
    );
  }
  f = message.getChangeOfContract();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      proto.proto.mdds.v1.ChangeOfContract.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentDerivatives();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      proto.proto.mdds.v1.InstrumentDerivatives.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentSbr();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      proto.proto.mdds.v1.InstrumentSBR.serializeBinaryToWriter
    );
  }
  f = message.getTradingSchedule();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      proto.proto.mdds.v1.TradingSchedule.serializeBinaryToWriter
    );
  }
  f = message.getHoliday();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      proto.proto.mdds.v1.Holiday.serializeBinaryToWriter
    );
  }
  f = message.getMemberTrader();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      proto.proto.mdds.v1.MemberTrader.serializeBinaryToWriter
    );
  }
  f = message.getMarketMakingContract();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      proto.proto.mdds.v1.MarketMakingContract.serializeBinaryToWriter
    );
  }
  f = message.getEtfIndexComposition();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      proto.proto.mdds.v1.ETFIndexComposition.serializeBinaryToWriter
    );
  }
  f = message.getElwUnderlyingAssets();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      proto.proto.mdds.v1.ELWUnderlyingAssets.serializeBinaryToWriter
    );
  }
  f = message.getStockInfo();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      proto.proto.mdds.v1.StockInfo.serializeBinaryToWriter
    );
  }
  f = message.getMarketIndex();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      proto.proto.mdds.v1.MarketIndex.serializeBinaryToWriter
    );
  }
  f = message.getBoardEvent();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      proto.proto.mdds.v1.BoardEvent.serializeBinaryToWriter
    );
  }
  f = message.getSymbolBoardEvent();
  if (f != null) {
    writer.writeMessage(
      44,
      f,
      proto.proto.mdds.v1.SymbolBoardEvent.serializeBinaryToWriter
    );
  }
  f = message.getTick();
  if (f != null) {
    writer.writeMessage(
      45,
      f,
      proto.proto.mdds.v1.Tick.serializeBinaryToWriter
    );
  }
  f = message.getTopPrice();
  if (f != null) {
    writer.writeMessage(
      46,
      f,
      proto.proto.mdds.v1.TopPrice.serializeBinaryToWriter
    );
  }
  f = message.getDrvProductEvent();
  if (f != null) {
    writer.writeMessage(
      47,
      f,
      proto.proto.mdds.v1.DrvProductEvent.serializeBinaryToWriter
    );
  }
  f = message.getListSectorVolatility();
  if (f != null) {
    writer.writeMessage(
      48,
      f,
      proto.proto.mdds.v1.ListSectorVolatility.serializeBinaryToWriter
    );
  }
  f = message.getListStockVolatility();
  if (f != null) {
    writer.writeMessage(
      49,
      f,
      proto.proto.mdds.v1.ListStockVolatility.serializeBinaryToWriter
    );
  }
};


/**
 * optional SecurityDefinition security_definition = 1;
 * @return {?proto.proto.mdds.v1.SecurityDefinition}
 */
proto.proto.mdds.v1.Wrapper.prototype.getSecurityDefinition = function() {
  return /** @type{?proto.proto.mdds.v1.SecurityDefinition} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.SecurityDefinition, 1));
};


/**
 * @param {?proto.proto.mdds.v1.SecurityDefinition|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setSecurityDefinition = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearSecurityDefinition = function() {
  return this.setSecurityDefinition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasSecurityDefinition = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SecurityStatus security_status = 2;
 * @return {?proto.proto.mdds.v1.SecurityStatus}
 */
proto.proto.mdds.v1.Wrapper.prototype.getSecurityStatus = function() {
  return /** @type{?proto.proto.mdds.v1.SecurityStatus} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.SecurityStatus, 2));
};


/**
 * @param {?proto.proto.mdds.v1.SecurityStatus|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setSecurityStatus = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearSecurityStatus = function() {
  return this.setSecurityStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasSecurityStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SecurityInformationNotification security_information_notification = 3;
 * @return {?proto.proto.mdds.v1.SecurityInformationNotification}
 */
proto.proto.mdds.v1.Wrapper.prototype.getSecurityInformationNotification = function() {
  return /** @type{?proto.proto.mdds.v1.SecurityInformationNotification} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.SecurityInformationNotification, 3));
};


/**
 * @param {?proto.proto.mdds.v1.SecurityInformationNotification|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setSecurityInformationNotification = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearSecurityInformationNotification = function() {
  return this.setSecurityInformationNotification(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasSecurityInformationNotification = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional SymbolClosingInformation symbol_closing_information = 4;
 * @return {?proto.proto.mdds.v1.SymbolClosingInformation}
 */
proto.proto.mdds.v1.Wrapper.prototype.getSymbolClosingInformation = function() {
  return /** @type{?proto.proto.mdds.v1.SymbolClosingInformation} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.SymbolClosingInformation, 4));
};


/**
 * @param {?proto.proto.mdds.v1.SymbolClosingInformation|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setSymbolClosingInformation = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearSymbolClosingInformation = function() {
  return this.setSymbolClosingInformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasSymbolClosingInformation = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional VolatilityInterruption volatility_interruption = 5;
 * @return {?proto.proto.mdds.v1.VolatilityInterruption}
 */
proto.proto.mdds.v1.Wrapper.prototype.getVolatilityInterruption = function() {
  return /** @type{?proto.proto.mdds.v1.VolatilityInterruption} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.VolatilityInterruption, 5));
};


/**
 * @param {?proto.proto.mdds.v1.VolatilityInterruption|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setVolatilityInterruption = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearVolatilityInterruption = function() {
  return this.setVolatilityInterruption(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasVolatilityInterruption = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional MarketMakerInformation market_maker_information = 6;
 * @return {?proto.proto.mdds.v1.MarketMakerInformation}
 */
proto.proto.mdds.v1.Wrapper.prototype.getMarketMakerInformation = function() {
  return /** @type{?proto.proto.mdds.v1.MarketMakerInformation} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.MarketMakerInformation, 6));
};


/**
 * @param {?proto.proto.mdds.v1.MarketMakerInformation|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setMarketMakerInformation = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearMarketMakerInformation = function() {
  return this.setMarketMakerInformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasMarketMakerInformation = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional SymbolEvent symbol_event = 7;
 * @return {?proto.proto.mdds.v1.SymbolEvent}
 */
proto.proto.mdds.v1.Wrapper.prototype.getSymbolEvent = function() {
  return /** @type{?proto.proto.mdds.v1.SymbolEvent} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.SymbolEvent, 7));
};


/**
 * @param {?proto.proto.mdds.v1.SymbolEvent|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setSymbolEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 7, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearSymbolEvent = function() {
  return this.setSymbolEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasSymbolEvent = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional IndexConstituentsInformation index_constituents_information = 8;
 * @return {?proto.proto.mdds.v1.IndexConstituentsInformation}
 */
proto.proto.mdds.v1.Wrapper.prototype.getIndexConstituentsInformation = function() {
  return /** @type{?proto.proto.mdds.v1.IndexConstituentsInformation} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.IndexConstituentsInformation, 8));
};


/**
 * @param {?proto.proto.mdds.v1.IndexConstituentsInformation|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setIndexConstituentsInformation = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearIndexConstituentsInformation = function() {
  return this.setIndexConstituentsInformation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasIndexConstituentsInformation = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional RandomEnd random_end = 9;
 * @return {?proto.proto.mdds.v1.RandomEnd}
 */
proto.proto.mdds.v1.Wrapper.prototype.getRandomEnd = function() {
  return /** @type{?proto.proto.mdds.v1.RandomEnd} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.RandomEnd, 9));
};


/**
 * @param {?proto.proto.mdds.v1.RandomEnd|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setRandomEnd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 9, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearRandomEnd = function() {
  return this.setRandomEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasRandomEnd = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional Price price = 10;
 * @return {?proto.proto.mdds.v1.Price}
 */
proto.proto.mdds.v1.Wrapper.prototype.getPrice = function() {
  return /** @type{?proto.proto.mdds.v1.Price} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.Price, 10));
};


/**
 * @param {?proto.proto.mdds.v1.Price|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 10, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional PriceRecovery price_recovery = 11;
 * @return {?proto.proto.mdds.v1.PriceRecovery}
 */
proto.proto.mdds.v1.Wrapper.prototype.getPriceRecovery = function() {
  return /** @type{?proto.proto.mdds.v1.PriceRecovery} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.PriceRecovery, 11));
};


/**
 * @param {?proto.proto.mdds.v1.PriceRecovery|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setPriceRecovery = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearPriceRecovery = function() {
  return this.setPriceRecovery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasPriceRecovery = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional Index index = 12;
 * @return {?proto.proto.mdds.v1.Index}
 */
proto.proto.mdds.v1.Wrapper.prototype.getIndex = function() {
  return /** @type{?proto.proto.mdds.v1.Index} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.Index, 12));
};


/**
 * @param {?proto.proto.mdds.v1.Index|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setIndex = function(value) {
  return jspb.Message.setOneofWrapperField(this, 12, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearIndex = function() {
  return this.setIndex(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasIndex = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional InvestorPerIndustry investor_per_industry = 13;
 * @return {?proto.proto.mdds.v1.InvestorPerIndustry}
 */
proto.proto.mdds.v1.Wrapper.prototype.getInvestorPerIndustry = function() {
  return /** @type{?proto.proto.mdds.v1.InvestorPerIndustry} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.InvestorPerIndustry, 13));
};


/**
 * @param {?proto.proto.mdds.v1.InvestorPerIndustry|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setInvestorPerIndustry = function(value) {
  return jspb.Message.setOneofWrapperField(this, 13, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearInvestorPerIndustry = function() {
  return this.setInvestorPerIndustry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasInvestorPerIndustry = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional InvestorPerSymbol investor_per_symbol = 14;
 * @return {?proto.proto.mdds.v1.InvestorPerSymbol}
 */
proto.proto.mdds.v1.Wrapper.prototype.getInvestorPerSymbol = function() {
  return /** @type{?proto.proto.mdds.v1.InvestorPerSymbol} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.InvestorPerSymbol, 14));
};


/**
 * @param {?proto.proto.mdds.v1.InvestorPerSymbol|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setInvestorPerSymbol = function(value) {
  return jspb.Message.setOneofWrapperField(this, 14, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearInvestorPerSymbol = function() {
  return this.setInvestorPerSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasInvestorPerSymbol = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional TopNMembersPerSymbol top_n_members_per_symbol = 15;
 * @return {?proto.proto.mdds.v1.TopNMembersPerSymbol}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTopNMembersPerSymbol = function() {
  return /** @type{?proto.proto.mdds.v1.TopNMembersPerSymbol} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.TopNMembersPerSymbol, 15));
};


/**
 * @param {?proto.proto.mdds.v1.TopNMembersPerSymbol|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTopNMembersPerSymbol = function(value) {
  return jspb.Message.setOneofWrapperField(this, 15, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTopNMembersPerSymbol = function() {
  return this.setTopNMembersPerSymbol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTopNMembersPerSymbol = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional OpenInterest open_interest = 16;
 * @return {?proto.proto.mdds.v1.OpenInterest}
 */
proto.proto.mdds.v1.Wrapper.prototype.getOpenInterest = function() {
  return /** @type{?proto.proto.mdds.v1.OpenInterest} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.OpenInterest, 16));
};


/**
 * @param {?proto.proto.mdds.v1.OpenInterest|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setOpenInterest = function(value) {
  return jspb.Message.setOneofWrapperField(this, 16, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearOpenInterest = function() {
  return this.setOpenInterest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasOpenInterest = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional DeemTradePrice deem_trade_price = 17;
 * @return {?proto.proto.mdds.v1.DeemTradePrice}
 */
proto.proto.mdds.v1.Wrapper.prototype.getDeemTradePrice = function() {
  return /** @type{?proto.proto.mdds.v1.DeemTradePrice} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.DeemTradePrice, 17));
};


/**
 * @param {?proto.proto.mdds.v1.DeemTradePrice|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setDeemTradePrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 17, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearDeemTradePrice = function() {
  return this.setDeemTradePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasDeemTradePrice = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional ForeignerOrderLimit foreigner_order_limit = 18;
 * @return {?proto.proto.mdds.v1.ForeignerOrderLimit}
 */
proto.proto.mdds.v1.Wrapper.prototype.getForeignerOrderLimit = function() {
  return /** @type{?proto.proto.mdds.v1.ForeignerOrderLimit} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.ForeignerOrderLimit, 18));
};


/**
 * @param {?proto.proto.mdds.v1.ForeignerOrderLimit|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setForeignerOrderLimit = function(value) {
  return jspb.Message.setOneofWrapperField(this, 18, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearForeignerOrderLimit = function() {
  return this.setForeignerOrderLimit(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasForeignerOrderLimit = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional PriceLimitExpansion price_limit_expansion = 19;
 * @return {?proto.proto.mdds.v1.PriceLimitExpansion}
 */
proto.proto.mdds.v1.Wrapper.prototype.getPriceLimitExpansion = function() {
  return /** @type{?proto.proto.mdds.v1.PriceLimitExpansion} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.PriceLimitExpansion, 19));
};


/**
 * @param {?proto.proto.mdds.v1.PriceLimitExpansion|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setPriceLimitExpansion = function(value) {
  return jspb.Message.setOneofWrapperField(this, 19, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearPriceLimitExpansion = function() {
  return this.setPriceLimitExpansion(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasPriceLimitExpansion = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional ETFiNav etf_i_nav = 20;
 * @return {?proto.proto.mdds.v1.ETFiNav}
 */
proto.proto.mdds.v1.Wrapper.prototype.getEtfINav = function() {
  return /** @type{?proto.proto.mdds.v1.ETFiNav} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.ETFiNav, 20));
};


/**
 * @param {?proto.proto.mdds.v1.ETFiNav|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setEtfINav = function(value) {
  return jspb.Message.setOneofWrapperField(this, 20, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearEtfINav = function() {
  return this.setEtfINav(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasEtfINav = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional ETFiIndex etf_i_index = 21;
 * @return {?proto.proto.mdds.v1.ETFiIndex}
 */
proto.proto.mdds.v1.Wrapper.prototype.getEtfIIndex = function() {
  return /** @type{?proto.proto.mdds.v1.ETFiIndex} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.ETFiIndex, 21));
};


/**
 * @param {?proto.proto.mdds.v1.ETFiIndex|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setEtfIIndex = function(value) {
  return jspb.Message.setOneofWrapperField(this, 21, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearEtfIIndex = function() {
  return this.setEtfIIndex(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasEtfIIndex = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional ETFTrackingError etf_tracking_error = 22;
 * @return {?proto.proto.mdds.v1.ETFTrackingError}
 */
proto.proto.mdds.v1.Wrapper.prototype.getEtfTrackingError = function() {
  return /** @type{?proto.proto.mdds.v1.ETFTrackingError} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.ETFTrackingError, 22));
};


/**
 * @param {?proto.proto.mdds.v1.ETFTrackingError|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setEtfTrackingError = function(value) {
  return jspb.Message.setOneofWrapperField(this, 22, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearEtfTrackingError = function() {
  return this.setEtfTrackingError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasEtfTrackingError = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional TopNSymbolsWithTradingQuantity top_n_symbols_with_trading_quantity = 23;
 * @return {?proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTopNSymbolsWithTradingQuantity = function() {
  return /** @type{?proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity, 23));
};


/**
 * @param {?proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTopNSymbolsWithTradingQuantity = function(value) {
  return jspb.Message.setOneofWrapperField(this, 23, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTopNSymbolsWithTradingQuantity = function() {
  return this.setTopNSymbolsWithTradingQuantity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTopNSymbolsWithTradingQuantity = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional TopNSymbolsWithCurrentPrice top_n_symbols_with_current_price = 24;
 * @return {?proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTopNSymbolsWithCurrentPrice = function() {
  return /** @type{?proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice, 24));
};


/**
 * @param {?proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTopNSymbolsWithCurrentPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 24, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTopNSymbolsWithCurrentPrice = function() {
  return this.setTopNSymbolsWithCurrentPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTopNSymbolsWithCurrentPrice = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional TopNSymbolsWithHighRatioOfPrice top_n_symbols_with_high_ratio_of_price = 25;
 * @return {?proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTopNSymbolsWithHighRatioOfPrice = function() {
  return /** @type{?proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice, 25));
};


/**
 * @param {?proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTopNSymbolsWithHighRatioOfPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 25, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTopNSymbolsWithHighRatioOfPrice = function() {
  return this.setTopNSymbolsWithHighRatioOfPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTopNSymbolsWithHighRatioOfPrice = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional TopNSymbolsWithLowRatioOfPrice top_n_symbols_with_low_ratio_of_price = 26;
 * @return {?proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTopNSymbolsWithLowRatioOfPrice = function() {
  return /** @type{?proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice, 26));
};


/**
 * @param {?proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTopNSymbolsWithLowRatioOfPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 26, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTopNSymbolsWithLowRatioOfPrice = function() {
  return this.setTopNSymbolsWithLowRatioOfPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTopNSymbolsWithLowRatioOfPrice = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional TradingResultOfForeignInvestor trading_result_of_foreign_investor = 27;
 * @return {?proto.proto.mdds.v1.TradingResultOfForeignInvestor}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTradingResultOfForeignInvestor = function() {
  return /** @type{?proto.proto.mdds.v1.TradingResultOfForeignInvestor} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.TradingResultOfForeignInvestor, 27));
};


/**
 * @param {?proto.proto.mdds.v1.TradingResultOfForeignInvestor|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTradingResultOfForeignInvestor = function(value) {
  return jspb.Message.setOneofWrapperField(this, 27, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTradingResultOfForeignInvestor = function() {
  return this.setTradingResultOfForeignInvestor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTradingResultOfForeignInvestor = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional Disclosure disclosure = 28;
 * @return {?proto.proto.mdds.v1.Disclosure}
 */
proto.proto.mdds.v1.Wrapper.prototype.getDisclosure = function() {
  return /** @type{?proto.proto.mdds.v1.Disclosure} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.Disclosure, 28));
};


/**
 * @param {?proto.proto.mdds.v1.Disclosure|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setDisclosure = function(value) {
  return jspb.Message.setOneofWrapperField(this, 28, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearDisclosure = function() {
  return this.setDisclosure(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasDisclosure = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional Timestamp timestamp = 29;
 * @return {?proto.proto.mdds.v1.Timestamp}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTimestamp = function() {
  return /** @type{?proto.proto.mdds.v1.Timestamp} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.Timestamp, 29));
};


/**
 * @param {?proto.proto.mdds.v1.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTimestamp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 29, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTimestamp = function() {
  return this.setTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTimestamp = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional DelistedInstrument delisted_instrument = 30;
 * @return {?proto.proto.mdds.v1.DelistedInstrument}
 */
proto.proto.mdds.v1.Wrapper.prototype.getDelistedInstrument = function() {
  return /** @type{?proto.proto.mdds.v1.DelistedInstrument} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.DelistedInstrument, 30));
};


/**
 * @param {?proto.proto.mdds.v1.DelistedInstrument|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setDelistedInstrument = function(value) {
  return jspb.Message.setOneofWrapperField(this, 30, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearDelistedInstrument = function() {
  return this.setDelistedInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasDelistedInstrument = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional CouponPaymentDate coupon_payment_date = 31;
 * @return {?proto.proto.mdds.v1.CouponPaymentDate}
 */
proto.proto.mdds.v1.Wrapper.prototype.getCouponPaymentDate = function() {
  return /** @type{?proto.proto.mdds.v1.CouponPaymentDate} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.CouponPaymentDate, 31));
};


/**
 * @param {?proto.proto.mdds.v1.CouponPaymentDate|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setCouponPaymentDate = function(value) {
  return jspb.Message.setOneofWrapperField(this, 31, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearCouponPaymentDate = function() {
  return this.setCouponPaymentDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasCouponPaymentDate = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional ChangeOfContract change_of_contract = 32;
 * @return {?proto.proto.mdds.v1.ChangeOfContract}
 */
proto.proto.mdds.v1.Wrapper.prototype.getChangeOfContract = function() {
  return /** @type{?proto.proto.mdds.v1.ChangeOfContract} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.ChangeOfContract, 32));
};


/**
 * @param {?proto.proto.mdds.v1.ChangeOfContract|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setChangeOfContract = function(value) {
  return jspb.Message.setOneofWrapperField(this, 32, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearChangeOfContract = function() {
  return this.setChangeOfContract(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasChangeOfContract = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional InstrumentDerivatives instrument_derivatives = 33;
 * @return {?proto.proto.mdds.v1.InstrumentDerivatives}
 */
proto.proto.mdds.v1.Wrapper.prototype.getInstrumentDerivatives = function() {
  return /** @type{?proto.proto.mdds.v1.InstrumentDerivatives} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.InstrumentDerivatives, 33));
};


/**
 * @param {?proto.proto.mdds.v1.InstrumentDerivatives|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setInstrumentDerivatives = function(value) {
  return jspb.Message.setOneofWrapperField(this, 33, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearInstrumentDerivatives = function() {
  return this.setInstrumentDerivatives(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasInstrumentDerivatives = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional InstrumentSBR instrument_sbr = 34;
 * @return {?proto.proto.mdds.v1.InstrumentSBR}
 */
proto.proto.mdds.v1.Wrapper.prototype.getInstrumentSbr = function() {
  return /** @type{?proto.proto.mdds.v1.InstrumentSBR} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.InstrumentSBR, 34));
};


/**
 * @param {?proto.proto.mdds.v1.InstrumentSBR|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setInstrumentSbr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 34, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearInstrumentSbr = function() {
  return this.setInstrumentSbr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasInstrumentSbr = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional TradingSchedule trading_schedule = 35;
 * @return {?proto.proto.mdds.v1.TradingSchedule}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTradingSchedule = function() {
  return /** @type{?proto.proto.mdds.v1.TradingSchedule} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.TradingSchedule, 35));
};


/**
 * @param {?proto.proto.mdds.v1.TradingSchedule|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTradingSchedule = function(value) {
  return jspb.Message.setOneofWrapperField(this, 35, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTradingSchedule = function() {
  return this.setTradingSchedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTradingSchedule = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional Holiday holiday = 36;
 * @return {?proto.proto.mdds.v1.Holiday}
 */
proto.proto.mdds.v1.Wrapper.prototype.getHoliday = function() {
  return /** @type{?proto.proto.mdds.v1.Holiday} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.Holiday, 36));
};


/**
 * @param {?proto.proto.mdds.v1.Holiday|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setHoliday = function(value) {
  return jspb.Message.setOneofWrapperField(this, 36, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearHoliday = function() {
  return this.setHoliday(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasHoliday = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional MemberTrader member_trader = 37;
 * @return {?proto.proto.mdds.v1.MemberTrader}
 */
proto.proto.mdds.v1.Wrapper.prototype.getMemberTrader = function() {
  return /** @type{?proto.proto.mdds.v1.MemberTrader} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.MemberTrader, 37));
};


/**
 * @param {?proto.proto.mdds.v1.MemberTrader|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setMemberTrader = function(value) {
  return jspb.Message.setOneofWrapperField(this, 37, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearMemberTrader = function() {
  return this.setMemberTrader(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasMemberTrader = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional MarketMakingContract market_making_contract = 38;
 * @return {?proto.proto.mdds.v1.MarketMakingContract}
 */
proto.proto.mdds.v1.Wrapper.prototype.getMarketMakingContract = function() {
  return /** @type{?proto.proto.mdds.v1.MarketMakingContract} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.MarketMakingContract, 38));
};


/**
 * @param {?proto.proto.mdds.v1.MarketMakingContract|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setMarketMakingContract = function(value) {
  return jspb.Message.setOneofWrapperField(this, 38, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearMarketMakingContract = function() {
  return this.setMarketMakingContract(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasMarketMakingContract = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional ETFIndexComposition etf_index_composition = 39;
 * @return {?proto.proto.mdds.v1.ETFIndexComposition}
 */
proto.proto.mdds.v1.Wrapper.prototype.getEtfIndexComposition = function() {
  return /** @type{?proto.proto.mdds.v1.ETFIndexComposition} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.ETFIndexComposition, 39));
};


/**
 * @param {?proto.proto.mdds.v1.ETFIndexComposition|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setEtfIndexComposition = function(value) {
  return jspb.Message.setOneofWrapperField(this, 39, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearEtfIndexComposition = function() {
  return this.setEtfIndexComposition(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasEtfIndexComposition = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional ELWUnderlyingAssets elw_underlying_assets = 40;
 * @return {?proto.proto.mdds.v1.ELWUnderlyingAssets}
 */
proto.proto.mdds.v1.Wrapper.prototype.getElwUnderlyingAssets = function() {
  return /** @type{?proto.proto.mdds.v1.ELWUnderlyingAssets} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.ELWUnderlyingAssets, 40));
};


/**
 * @param {?proto.proto.mdds.v1.ELWUnderlyingAssets|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setElwUnderlyingAssets = function(value) {
  return jspb.Message.setOneofWrapperField(this, 40, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearElwUnderlyingAssets = function() {
  return this.setElwUnderlyingAssets(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasElwUnderlyingAssets = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional StockInfo stock_info = 41;
 * @return {?proto.proto.mdds.v1.StockInfo}
 */
proto.proto.mdds.v1.Wrapper.prototype.getStockInfo = function() {
  return /** @type{?proto.proto.mdds.v1.StockInfo} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.StockInfo, 41));
};


/**
 * @param {?proto.proto.mdds.v1.StockInfo|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setStockInfo = function(value) {
  return jspb.Message.setOneofWrapperField(this, 41, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearStockInfo = function() {
  return this.setStockInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasStockInfo = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional MarketIndex market_index = 42;
 * @return {?proto.proto.mdds.v1.MarketIndex}
 */
proto.proto.mdds.v1.Wrapper.prototype.getMarketIndex = function() {
  return /** @type{?proto.proto.mdds.v1.MarketIndex} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.MarketIndex, 42));
};


/**
 * @param {?proto.proto.mdds.v1.MarketIndex|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setMarketIndex = function(value) {
  return jspb.Message.setOneofWrapperField(this, 42, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearMarketIndex = function() {
  return this.setMarketIndex(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasMarketIndex = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional BoardEvent board_event = 43;
 * @return {?proto.proto.mdds.v1.BoardEvent}
 */
proto.proto.mdds.v1.Wrapper.prototype.getBoardEvent = function() {
  return /** @type{?proto.proto.mdds.v1.BoardEvent} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.BoardEvent, 43));
};


/**
 * @param {?proto.proto.mdds.v1.BoardEvent|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setBoardEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 43, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearBoardEvent = function() {
  return this.setBoardEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasBoardEvent = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional SymbolBoardEvent symbol_board_event = 44;
 * @return {?proto.proto.mdds.v1.SymbolBoardEvent}
 */
proto.proto.mdds.v1.Wrapper.prototype.getSymbolBoardEvent = function() {
  return /** @type{?proto.proto.mdds.v1.SymbolBoardEvent} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.SymbolBoardEvent, 44));
};


/**
 * @param {?proto.proto.mdds.v1.SymbolBoardEvent|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setSymbolBoardEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 44, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearSymbolBoardEvent = function() {
  return this.setSymbolBoardEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasSymbolBoardEvent = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional Tick tick = 45;
 * @return {?proto.proto.mdds.v1.Tick}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTick = function() {
  return /** @type{?proto.proto.mdds.v1.Tick} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.Tick, 45));
};


/**
 * @param {?proto.proto.mdds.v1.Tick|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTick = function(value) {
  return jspb.Message.setOneofWrapperField(this, 45, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTick = function() {
  return this.setTick(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTick = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional TopPrice top_price = 46;
 * @return {?proto.proto.mdds.v1.TopPrice}
 */
proto.proto.mdds.v1.Wrapper.prototype.getTopPrice = function() {
  return /** @type{?proto.proto.mdds.v1.TopPrice} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.TopPrice, 46));
};


/**
 * @param {?proto.proto.mdds.v1.TopPrice|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setTopPrice = function(value) {
  return jspb.Message.setOneofWrapperField(this, 46, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearTopPrice = function() {
  return this.setTopPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasTopPrice = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional DrvProductEvent drv_product_event = 47;
 * @return {?proto.proto.mdds.v1.DrvProductEvent}
 */
proto.proto.mdds.v1.Wrapper.prototype.getDrvProductEvent = function() {
  return /** @type{?proto.proto.mdds.v1.DrvProductEvent} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.DrvProductEvent, 47));
};


/**
 * @param {?proto.proto.mdds.v1.DrvProductEvent|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setDrvProductEvent = function(value) {
  return jspb.Message.setOneofWrapperField(this, 47, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearDrvProductEvent = function() {
  return this.setDrvProductEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasDrvProductEvent = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional ListSectorVolatility list_sector_volatility = 48;
 * @return {?proto.proto.mdds.v1.ListSectorVolatility}
 */
proto.proto.mdds.v1.Wrapper.prototype.getListSectorVolatility = function() {
  return /** @type{?proto.proto.mdds.v1.ListSectorVolatility} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.ListSectorVolatility, 48));
};


/**
 * @param {?proto.proto.mdds.v1.ListSectorVolatility|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setListSectorVolatility = function(value) {
  return jspb.Message.setOneofWrapperField(this, 48, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearListSectorVolatility = function() {
  return this.setListSectorVolatility(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasListSectorVolatility = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional ListStockVolatility list_stock_volatility = 49;
 * @return {?proto.proto.mdds.v1.ListStockVolatility}
 */
proto.proto.mdds.v1.Wrapper.prototype.getListStockVolatility = function() {
  return /** @type{?proto.proto.mdds.v1.ListStockVolatility} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.ListStockVolatility, 49));
};


/**
 * @param {?proto.proto.mdds.v1.ListStockVolatility|undefined} value
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
*/
proto.proto.mdds.v1.Wrapper.prototype.setListStockVolatility = function(value) {
  return jspb.Message.setOneofWrapperField(this, 49, proto.proto.mdds.v1.Wrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Wrapper} returns this
 */
proto.proto.mdds.v1.Wrapper.prototype.clearListStockVolatility = function() {
  return this.setListStockVolatility(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Wrapper.prototype.hasListStockVolatility = function() {
  return jspb.Message.getField(this, 49) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.SecurityDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.SecurityDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SecurityDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    totNumReports: jspb.Message.getFieldWithDefault(msg, 3, 0),
    securityExchange: jspb.Message.getFieldWithDefault(msg, 4, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    tickerCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    symbolShortCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    symbolName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    symbolEnglishName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    productGrpId: jspb.Message.getFieldWithDefault(msg, 11, ""),
    securityGroupId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    putOrCall: jspb.Message.getFieldWithDefault(msg, 13, ""),
    exerciseStyle: jspb.Message.getFieldWithDefault(msg, 14, ""),
    maturityMonthYear: jspb.Message.getFieldWithDefault(msg, 15, ""),
    maturityDate: jspb.Message.getFieldWithDefault(msg, 16, ""),
    issuerId: jspb.Message.getFieldWithDefault(msg, 17, ""),
    issueDate: jspb.Message.getFieldWithDefault(msg, 18, ""),
    contractMultiplier: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
    couponRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
    currency: jspb.Message.getFieldWithDefault(msg, 21, ""),
    listedShares: jspb.Message.getFieldWithDefault(msg, 22, 0),
    highLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
    lowLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
    strikePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
    securityStatus: jspb.Message.getFieldWithDefault(msg, 26, ""),
    contractSize: jspb.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0),
    settleMethod: jspb.Message.getFieldWithDefault(msg, 28, ""),
    yield: jspb.Message.getFloatingPointFieldWithDefault(msg, 29, 0.0),
    referencePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 30, 0.0),
    evaluationPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 31, 0.0),
    highestOrderPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 32, 0.0),
    lowestOrderPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 33, 0.0),
    prevClosePx: jspb.Message.getFloatingPointFieldWithDefault(msg, 34, 0.0),
    symbolCloseInfoPxType: jspb.Message.getFieldWithDefault(msg, 35, ""),
    firstTradingDate: jspb.Message.getFieldWithDefault(msg, 36, ""),
    finalTradeDate: jspb.Message.getFieldWithDefault(msg, 37, ""),
    finalSettleDate: jspb.Message.getFieldWithDefault(msg, 38, ""),
    listingDate: jspb.Message.getFieldWithDefault(msg, 39, ""),
    randomEndTriggeringConditionCode: jspb.Message.getFieldWithDefault(msg, 42, ""),
    exClassType: jspb.Message.getFieldWithDefault(msg, 43, ""),
    vwap: jspb.Message.getFloatingPointFieldWithDefault(msg, 44, 0.0),
    symbolAdminStatusCode: jspb.Message.getFieldWithDefault(msg, 45, ""),
    symbolTradingMethodStatusCode: jspb.Message.getFieldWithDefault(msg, 46, ""),
    symbolTradingSantionStatusCode: jspb.Message.getFieldWithDefault(msg, 47, ""),
    sectorTypeCode: jspb.Message.getFieldWithDefault(msg, 48, ""),
    redumptionDate: jspb.Message.getFieldWithDefault(msg, 49, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.SecurityDefinition}
 */
proto.proto.mdds.v1.SecurityDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.SecurityDefinition;
  return proto.proto.mdds.v1.SecurityDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.SecurityDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.SecurityDefinition}
 */
proto.proto.mdds.v1.SecurityDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotNumReports(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityExchange(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTickerCode(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolShortCode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolEnglishName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductGrpId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityGroupId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setPutOrCall(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setExerciseStyle(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaturityMonthYear(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaturityDate(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssuerId(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssueDate(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setContractMultiplier(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCouponRate(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setListedShares(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighLimitPrice(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowLimitPrice(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStrikePrice(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityStatus(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setContractSize(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettleMethod(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYield(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReferencePrice(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEvaluationPrice(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighestOrderPrice(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowestOrderPrice(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrevClosePx(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolCloseInfoPxType(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstTradingDate(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinalTradeDate(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinalSettleDate(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setListingDate(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setRandomEndTriggeringConditionCode(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setExClassType(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVwap(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolAdminStatusCode(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolTradingMethodStatusCode(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolTradingSantionStatusCode(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectorTypeCode(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedumptionDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.SecurityDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.SecurityDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SecurityDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotNumReports();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getSecurityExchange();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTickerCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSymbolShortCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSymbolName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSymbolEnglishName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getProductGrpId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getSecurityGroupId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeString(
      14,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeString(
      15,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeString(
      16,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeString(
      17,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getContractMultiplier();
  if (f !== 0.0) {
    writer.writeDouble(
      19,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 22));
  if (f != null) {
    writer.writeUint64(
      22,
      f
    );
  }
  f = message.getHighLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getLowLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      24,
      f
    );
  }
  f = message.getStrikePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = message.getSecurityStatus();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getContractSize();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeString(
      28,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 29));
  if (f != null) {
    writer.writeDouble(
      29,
      f
    );
  }
  f = message.getReferencePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      30,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 31));
  if (f != null) {
    writer.writeDouble(
      31,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 32));
  if (f != null) {
    writer.writeDouble(
      32,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 33));
  if (f != null) {
    writer.writeDouble(
      33,
      f
    );
  }
  f = message.getPrevClosePx();
  if (f !== 0.0) {
    writer.writeDouble(
      34,
      f
    );
  }
  f = message.getSymbolCloseInfoPxType();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 36));
  if (f != null) {
    writer.writeString(
      36,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 37));
  if (f != null) {
    writer.writeString(
      37,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 38));
  if (f != null) {
    writer.writeString(
      38,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 39));
  if (f != null) {
    writer.writeString(
      39,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 42));
  if (f != null) {
    writer.writeString(
      42,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 43));
  if (f != null) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getVwap();
  if (f !== 0.0) {
    writer.writeDouble(
      44,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 45));
  if (f != null) {
    writer.writeString(
      45,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 46));
  if (f != null) {
    writer.writeString(
      46,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 47));
  if (f != null) {
    writer.writeString(
      47,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 48));
  if (f != null) {
    writer.writeString(
      48,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 49));
  if (f != null) {
    writer.writeString(
      49,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
*/
proto.proto.mdds.v1.SecurityDefinition.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 tot_num_reports = 3;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getTotNumReports = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setTotNumReports = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string security_exchange = 4;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSecurityExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSecurityExchange = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string ticker_code = 6;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getTickerCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setTickerCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string symbol_short_code = 7;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSymbolShortCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSymbolShortCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string symbol_name = 8;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSymbolName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string symbol_english_name = 9;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSymbolEnglishName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSymbolEnglishName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string product_id = 10;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string product_grp_id = 11;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getProductGrpId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setProductGrpId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string security_group_id = 12;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSecurityGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSecurityGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string put_or_call = 13;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getPutOrCall = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setPutOrCall = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearPutOrCall = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasPutOrCall = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string exercise_style = 14;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getExerciseStyle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setExerciseStyle = function(value) {
  return jspb.Message.setField(this, 14, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearExerciseStyle = function() {
  return jspb.Message.setField(this, 14, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasExerciseStyle = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string maturity_month_year = 15;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getMaturityMonthYear = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setMaturityMonthYear = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearMaturityMonthYear = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasMaturityMonthYear = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string maturity_date = 16;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getMaturityDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setMaturityDate = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearMaturityDate = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasMaturityDate = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string issuer_id = 17;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getIssuerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setIssuerId = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearIssuerId = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasIssuerId = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional string issue_date = 18;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getIssueDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setIssueDate = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearIssueDate = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasIssueDate = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional double contract_multiplier = 19;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getContractMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setContractMultiplier = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional double coupon_rate = 20;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getCouponRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setCouponRate = function(value) {
  return jspb.Message.setField(this, 20, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearCouponRate = function() {
  return jspb.Message.setField(this, 20, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasCouponRate = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional string currency = 21;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional uint64 listed_shares = 22;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getListedShares = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setListedShares = function(value) {
  return jspb.Message.setField(this, 22, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearListedShares = function() {
  return jspb.Message.setField(this, 22, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasListedShares = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional double high_limit_price = 23;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getHighLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setHighLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional double low_limit_price = 24;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getLowLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setLowLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional double strike_price = 25;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getStrikePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setStrikePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional string security_status = 26;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSecurityStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSecurityStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional double contract_size = 27;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getContractSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setContractSize = function(value) {
  return jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional string settle_method = 28;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSettleMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSettleMethod = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearSettleMethod = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasSettleMethod = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional double yield = 29;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setYield = function(value) {
  return jspb.Message.setField(this, 29, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearYield = function() {
  return jspb.Message.setField(this, 29, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasYield = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional double reference_price = 30;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getReferencePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setReferencePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 30, value);
};


/**
 * optional double evaluation_price = 31;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getEvaluationPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 31, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setEvaluationPrice = function(value) {
  return jspb.Message.setField(this, 31, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearEvaluationPrice = function() {
  return jspb.Message.setField(this, 31, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasEvaluationPrice = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional double highest_order_price = 32;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getHighestOrderPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setHighestOrderPrice = function(value) {
  return jspb.Message.setField(this, 32, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearHighestOrderPrice = function() {
  return jspb.Message.setField(this, 32, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasHighestOrderPrice = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional double lowest_order_price = 33;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getLowestOrderPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setLowestOrderPrice = function(value) {
  return jspb.Message.setField(this, 33, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearLowestOrderPrice = function() {
  return jspb.Message.setField(this, 33, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasLowestOrderPrice = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional double prev_close_px = 34;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getPrevClosePx = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 34, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setPrevClosePx = function(value) {
  return jspb.Message.setProto3FloatField(this, 34, value);
};


/**
 * optional string symbol_close_info_px_type = 35;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSymbolCloseInfoPxType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSymbolCloseInfoPxType = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string first_trading_date = 36;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getFirstTradingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setFirstTradingDate = function(value) {
  return jspb.Message.setField(this, 36, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearFirstTradingDate = function() {
  return jspb.Message.setField(this, 36, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasFirstTradingDate = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional string final_trade_date = 37;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getFinalTradeDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setFinalTradeDate = function(value) {
  return jspb.Message.setField(this, 37, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearFinalTradeDate = function() {
  return jspb.Message.setField(this, 37, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasFinalTradeDate = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional string final_settle_date = 38;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getFinalSettleDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setFinalSettleDate = function(value) {
  return jspb.Message.setField(this, 38, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearFinalSettleDate = function() {
  return jspb.Message.setField(this, 38, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasFinalSettleDate = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional string listing_date = 39;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getListingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setListingDate = function(value) {
  return jspb.Message.setField(this, 39, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearListingDate = function() {
  return jspb.Message.setField(this, 39, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasListingDate = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional string random_end_triggering_condition_code = 42;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getRandomEndTriggeringConditionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setRandomEndTriggeringConditionCode = function(value) {
  return jspb.Message.setField(this, 42, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearRandomEndTriggeringConditionCode = function() {
  return jspb.Message.setField(this, 42, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasRandomEndTriggeringConditionCode = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional string ex_class_type = 43;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getExClassType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setExClassType = function(value) {
  return jspb.Message.setField(this, 43, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearExClassType = function() {
  return jspb.Message.setField(this, 43, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasExClassType = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional double vwap = 44;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getVwap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 44, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setVwap = function(value) {
  return jspb.Message.setProto3FloatField(this, 44, value);
};


/**
 * optional string symbol_admin_status_code = 45;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSymbolAdminStatusCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSymbolAdminStatusCode = function(value) {
  return jspb.Message.setField(this, 45, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearSymbolAdminStatusCode = function() {
  return jspb.Message.setField(this, 45, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasSymbolAdminStatusCode = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional string symbol_trading_method_status_code = 46;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSymbolTradingMethodStatusCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSymbolTradingMethodStatusCode = function(value) {
  return jspb.Message.setField(this, 46, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearSymbolTradingMethodStatusCode = function() {
  return jspb.Message.setField(this, 46, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasSymbolTradingMethodStatusCode = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional string symbol_trading_santion_status_code = 47;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSymbolTradingSantionStatusCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSymbolTradingSantionStatusCode = function(value) {
  return jspb.Message.setField(this, 47, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearSymbolTradingSantionStatusCode = function() {
  return jspb.Message.setField(this, 47, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasSymbolTradingSantionStatusCode = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional string sector_type_code = 48;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getSectorTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setSectorTypeCode = function(value) {
  return jspb.Message.setField(this, 48, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearSectorTypeCode = function() {
  return jspb.Message.setField(this, 48, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasSectorTypeCode = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional string redumption_date = 49;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.getRedumptionDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.setRedumptionDate = function(value) {
  return jspb.Message.setField(this, 49, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityDefinition} returns this
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.clearRedumptionDate = function() {
  return jspb.Message.setField(this, 49, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityDefinition.prototype.hasRedumptionDate = function() {
  return jspb.Message.getField(this, 49) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.SecurityStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.SecurityStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SecurityStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tradingScheduleControlProductGroupId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    boardEvtId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sessOpenCloseCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    haltReasonCode: jspb.Message.getFieldWithDefault(msg, 8, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.SecurityStatus}
 */
proto.proto.mdds.v1.SecurityStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.SecurityStatus;
  return proto.proto.mdds.v1.SecurityStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.SecurityStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.SecurityStatus}
 */
proto.proto.mdds.v1.SecurityStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingScheduleControlProductGroupId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardEvtId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSessOpenCloseCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingSessionId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setHaltReasonCode(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.SecurityStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.SecurityStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SecurityStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTradingScheduleControlProductGroupId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getBoardEvtId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSessOpenCloseCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeString(
      8,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
*/
proto.proto.mdds.v1.SecurityStatus.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string trading_schedule_control_product_group_id = 7;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.getTradingScheduleControlProductGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.setTradingScheduleControlProductGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string board_evt_id = 3;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.getBoardEvtId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.setBoardEvtId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string sess_open_close_code = 4;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.getSessOpenCloseCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.setSessOpenCloseCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.setSymbol = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.clearSymbol = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.hasSymbol = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string trading_session_id = 6;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.getTradingSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.clearTradingSessionId = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string halt_reason_code = 8;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.getHaltReasonCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.setHaltReasonCode = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.clearHaltReasonCode = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.hasHaltReasonCode = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string product_id = 9;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.setProductId = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityStatus} returns this
 */
proto.proto.mdds.v1.SecurityStatus.prototype.clearProductId = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityStatus.prototype.hasProductId = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.SecurityInformationNotification.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.SecurityInformationNotification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SecurityInformationNotification.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    referencePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    highLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    lowLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    evaluationPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    highestOrderPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    lowestOrderPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    listedShares: jspb.Message.getFieldWithDefault(msg, 10, 0),
    exClassType: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification}
 */
proto.proto.mdds.v1.SecurityInformationNotification.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.SecurityInformationNotification;
  return proto.proto.mdds.v1.SecurityInformationNotification.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.SecurityInformationNotification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification}
 */
proto.proto.mdds.v1.SecurityInformationNotification.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReferencePrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighLimitPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowLimitPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setEvaluationPrice(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighestOrderPrice(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowestOrderPrice(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setListedShares(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setExClassType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.SecurityInformationNotification.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.SecurityInformationNotification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SecurityInformationNotification.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
*/
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double reference_price = 4;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getReferencePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setReferencePrice = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.clearReferencePrice = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.hasReferencePrice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional double high_limit_price = 5;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getHighLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setHighLimitPrice = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.clearHighLimitPrice = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.hasHighLimitPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional double low_limit_price = 6;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getLowLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setLowLimitPrice = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.clearLowLimitPrice = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.hasLowLimitPrice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional double evaluation_price = 7;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getEvaluationPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setEvaluationPrice = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.clearEvaluationPrice = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.hasEvaluationPrice = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional double highest_order_price = 8;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getHighestOrderPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setHighestOrderPrice = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.clearHighestOrderPrice = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.hasHighestOrderPrice = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional double lowest_order_price = 9;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getLowestOrderPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setLowestOrderPrice = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.clearLowestOrderPrice = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.hasLowestOrderPrice = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional uint64 listed_shares = 10;
 * @return {number}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getListedShares = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setListedShares = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.clearListedShares = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.hasListedShares = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string ex_class_type = 11;
 * @return {string}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.getExClassType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.setExClassType = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.SecurityInformationNotification} returns this
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.clearExClassType = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SecurityInformationNotification.prototype.hasExClassType = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.SymbolClosingInformation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.SymbolClosingInformation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SymbolClosingInformation.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbolCloseInfoPx: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    symbolCloseInfoYield: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    symbolCloseInfoPxType: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.SymbolClosingInformation}
 */
proto.proto.mdds.v1.SymbolClosingInformation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.SymbolClosingInformation;
  return proto.proto.mdds.v1.SymbolClosingInformation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.SymbolClosingInformation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.SymbolClosingInformation}
 */
proto.proto.mdds.v1.SymbolClosingInformation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSymbolCloseInfoPx(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSymbolCloseInfoYield(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolCloseInfoPxType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.SymbolClosingInformation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.SymbolClosingInformation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SymbolClosingInformation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbolCloseInfoPx();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getSymbolCloseInfoYield();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getSymbolCloseInfoPxType();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.SymbolClosingInformation} returns this
*/
proto.proto.mdds.v1.SymbolClosingInformation.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.SymbolClosingInformation} returns this
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolClosingInformation} returns this
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolClosingInformation} returns this
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolClosingInformation} returns this
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double symbol_close_info_px = 4;
 * @return {number}
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.getSymbolCloseInfoPx = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SymbolClosingInformation} returns this
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.setSymbolCloseInfoPx = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double symbol_close_info_yield = 5;
 * @return {number}
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.getSymbolCloseInfoYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SymbolClosingInformation} returns this
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.setSymbolCloseInfoYield = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string symbol_close_info_px_type = 6;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.getSymbolCloseInfoPxType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolClosingInformation} returns this
 */
proto.proto.mdds.v1.SymbolClosingInformation.prototype.setSymbolCloseInfoPxType = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.VolatilityInterruption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.VolatilityInterruption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.VolatilityInterruption.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    vITypeCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    vIKindCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    staticVIBasePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    dynamicVIBasePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    vIPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    staticVIDisparityRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    dynamicVIDisparityRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.VolatilityInterruption}
 */
proto.proto.mdds.v1.VolatilityInterruption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.VolatilityInterruption;
  return proto.proto.mdds.v1.VolatilityInterruption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.VolatilityInterruption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.VolatilityInterruption}
 */
proto.proto.mdds.v1.VolatilityInterruption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setVITypeCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setVIKindCode(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStaticVIBasePrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDynamicVIBasePrice(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVIPrice(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStaticVIDisparityRatio(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDynamicVIDisparityRatio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.VolatilityInterruption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.VolatilityInterruption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.VolatilityInterruption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getVITypeCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getVIKindCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStaticVIBasePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getDynamicVIBasePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getVIPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getStaticVIDisparityRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getDynamicVIDisparityRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
*/
proto.proto.mdds.v1.VolatilityInterruption.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string v_i_type_code = 4;
 * @return {string}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getVITypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.setVITypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string v_i_kind_code = 5;
 * @return {string}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getVIKindCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.setVIKindCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double static_v_i_base_price = 6;
 * @return {number}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getStaticVIBasePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.setStaticVIBasePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double dynamic_v_i_base_price = 7;
 * @return {number}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getDynamicVIBasePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.setDynamicVIBasePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double v_i_price = 8;
 * @return {number}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getVIPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.setVIPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double static_v_i_disparity_ratio = 9;
 * @return {number}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getStaticVIDisparityRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.setStaticVIDisparityRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double dynamic_v_i_disparity_ratio = 10;
 * @return {number}
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.getDynamicVIDisparityRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.VolatilityInterruption} returns this
 */
proto.proto.mdds.v1.VolatilityInterruption.prototype.setDynamicVIDisparityRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.MarketMakerInformation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.MarketMakerInformation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MarketMakerInformation.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    marketMakerContractCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    memberNo: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.MarketMakerInformation}
 */
proto.proto.mdds.v1.MarketMakerInformation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.MarketMakerInformation;
  return proto.proto.mdds.v1.MarketMakerInformation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.MarketMakerInformation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.MarketMakerInformation}
 */
proto.proto.mdds.v1.MarketMakerInformation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketMakerContractCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberNo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.MarketMakerInformation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.MarketMakerInformation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MarketMakerInformation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMarketMakerContractCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMemberNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.MarketMakerInformation} returns this
*/
proto.proto.mdds.v1.MarketMakerInformation.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.MarketMakerInformation} returns this
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakerInformation} returns this
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string market_maker_contract_code = 2;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.getMarketMakerContractCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakerInformation} returns this
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.setMarketMakerContractCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string member_no = 3;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.getMemberNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakerInformation} returns this
 */
proto.proto.mdds.v1.MarketMakerInformation.prototype.setMemberNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.SymbolEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.SymbolEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.SymbolEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SymbolEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    eventKindCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    eventOccurrenceReasonCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    eventStartDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    eventEndDate: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.SymbolEvent}
 */
proto.proto.mdds.v1.SymbolEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.SymbolEvent;
  return proto.proto.mdds.v1.SymbolEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.SymbolEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.SymbolEvent}
 */
proto.proto.mdds.v1.SymbolEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventKindCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventOccurrenceReasonCode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventStartDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.SymbolEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.SymbolEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.SymbolEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SymbolEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEventKindCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEventOccurrenceReasonCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getEventStartDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEventEndDate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.SymbolEvent.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.SymbolEvent} returns this
*/
proto.proto.mdds.v1.SymbolEvent.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.SymbolEvent} returns this
 */
proto.proto.mdds.v1.SymbolEvent.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SymbolEvent.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolEvent.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolEvent} returns this
 */
proto.proto.mdds.v1.SymbolEvent.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolEvent.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolEvent} returns this
 */
proto.proto.mdds.v1.SymbolEvent.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string event_kind_code = 4;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolEvent.prototype.getEventKindCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolEvent} returns this
 */
proto.proto.mdds.v1.SymbolEvent.prototype.setEventKindCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string event_occurrence_reason_code = 5;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolEvent.prototype.getEventOccurrenceReasonCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolEvent} returns this
 */
proto.proto.mdds.v1.SymbolEvent.prototype.setEventOccurrenceReasonCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string event_start_date = 6;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolEvent.prototype.getEventStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolEvent} returns this
 */
proto.proto.mdds.v1.SymbolEvent.prototype.setEventStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string event_end_date = 7;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolEvent.prototype.getEventEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolEvent} returns this
 */
proto.proto.mdds.v1.SymbolEvent.prototype.setEventEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.DrvProductEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.DrvProductEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.DrvProductEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    productId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    eventKindCode: jspb.Message.getFieldWithDefault(msg, 2, ""),
    eventOccurrenceReasonCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    eventStartDate: jspb.Message.getFieldWithDefault(msg, 4, ""),
    eventEndDate: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.DrvProductEvent}
 */
proto.proto.mdds.v1.DrvProductEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.DrvProductEvent;
  return proto.proto.mdds.v1.DrvProductEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.DrvProductEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.DrvProductEvent}
 */
proto.proto.mdds.v1.DrvProductEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventKindCode(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventOccurrenceReasonCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventStartDate(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.DrvProductEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.DrvProductEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.DrvProductEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEventKindCode();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEventOccurrenceReasonCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEventStartDate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEventEndDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.DrvProductEvent} returns this
*/
proto.proto.mdds.v1.DrvProductEvent.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.DrvProductEvent} returns this
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string product_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DrvProductEvent} returns this
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string event_kind_code = 2;
 * @return {string}
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.getEventKindCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DrvProductEvent} returns this
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.setEventKindCode = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string event_occurrence_reason_code = 3;
 * @return {string}
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.getEventOccurrenceReasonCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DrvProductEvent} returns this
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.setEventOccurrenceReasonCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string event_start_date = 4;
 * @return {string}
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.getEventStartDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DrvProductEvent} returns this
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.setEventStartDate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string event_end_date = 5;
 * @return {string}
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.getEventEndDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DrvProductEvent} returns this
 */
proto.proto.mdds.v1.DrvProductEvent.prototype.setEventEndDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.IndexConstituentsInformation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.IndexConstituentsInformation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.IndexConstituentsInformation.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    marketIndexClass: jspb.Message.getFieldWithDefault(msg, 2, ""),
    indexesTypeCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 4, ""),
    idxName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    idxEnglishName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    totalMsgNo: jspb.Message.getFieldWithDefault(msg, 7, 0),
    currentMsgNo: jspb.Message.getFieldWithDefault(msg, 8, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.IndexConstituentsInformation;
  return proto.proto.mdds.v1.IndexConstituentsInformation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.IndexConstituentsInformation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketIndexClass(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexesTypeCode(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdxName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setIdxEnglishName(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalMsgNo(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCurrentMsgNo(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.IndexConstituentsInformation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.IndexConstituentsInformation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.IndexConstituentsInformation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMarketIndexClass();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIndexesTypeCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIdxName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIdxEnglishName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTotalMsgNo();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getCurrentMsgNo();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
*/
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string market_index_class = 2;
 * @return {string}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.getMarketIndexClass = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.setMarketIndexClass = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string indexes_type_code = 3;
 * @return {string}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.getIndexesTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.setIndexesTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string currency = 4;
 * @return {string}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string idx_name = 5;
 * @return {string}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.getIdxName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.setIdxName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string idx_english_name = 6;
 * @return {string}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.getIdxEnglishName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.setIdxEnglishName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint64 total_msg_no = 7;
 * @return {number}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.getTotalMsgNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.setTotalMsgNo = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional uint64 current_msg_no = 8;
 * @return {number}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.getCurrentMsgNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.setCurrentMsgNo = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string symbol = 9;
 * @return {string}
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.IndexConstituentsInformation} returns this
 */
proto.proto.mdds.v1.IndexConstituentsInformation.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.RandomEnd.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.RandomEnd.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.RandomEnd} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.RandomEnd.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    transactTime: jspb.Message.getFieldWithDefault(msg, 4, ""),
    randomEndApplyClassification: jspb.Message.getFieldWithDefault(msg, 5, ""),
    randomEndTentativeExecutionPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    randomEndEstimatedHighestPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    randomEndEstimatedHighestPriceDisparateRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    randomEndEstimatedLowestPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    randomEndEstimatedLowestPriceDisparateRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    latestPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    latestPriceDisparateRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    randomEndReleaseTime: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.RandomEnd}
 */
proto.proto.mdds.v1.RandomEnd.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.RandomEnd;
  return proto.proto.mdds.v1.RandomEnd.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.RandomEnd} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.RandomEnd}
 */
proto.proto.mdds.v1.RandomEnd.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactTime(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRandomEndApplyClassification(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRandomEndTentativeExecutionPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRandomEndEstimatedHighestPrice(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRandomEndEstimatedHighestPriceDisparateRatio(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRandomEndEstimatedLowestPrice(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRandomEndEstimatedLowestPriceDisparateRatio(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatestPrice(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLatestPriceDisparateRatio(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setRandomEndReleaseTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.RandomEnd.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.RandomEnd.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.RandomEnd} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.RandomEnd.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTransactTime();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRandomEndApplyClassification();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRandomEndTentativeExecutionPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getRandomEndEstimatedHighestPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getRandomEndEstimatedHighestPriceDisparateRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getRandomEndEstimatedLowestPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getRandomEndEstimatedLowestPriceDisparateRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getLatestPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getLatestPriceDisparateRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
*/
proto.proto.mdds.v1.RandomEnd.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.RandomEnd.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string transact_time = 4;
 * @return {string}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getTransactTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setTransactTime = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string random_end_apply_classification = 5;
 * @return {string}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getRandomEndApplyClassification = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setRandomEndApplyClassification = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional double random_end_tentative_execution_price = 6;
 * @return {number}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getRandomEndTentativeExecutionPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setRandomEndTentativeExecutionPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double random_end_estimated_highest_price = 7;
 * @return {number}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getRandomEndEstimatedHighestPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setRandomEndEstimatedHighestPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double random_end_estimated_highest_price_disparate_ratio = 8;
 * @return {number}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getRandomEndEstimatedHighestPriceDisparateRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setRandomEndEstimatedHighestPriceDisparateRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double random_end_estimated_lowest_price = 9;
 * @return {number}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getRandomEndEstimatedLowestPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setRandomEndEstimatedLowestPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double random_end_estimated_lowest_price_disparate_ratio = 10;
 * @return {number}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getRandomEndEstimatedLowestPriceDisparateRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setRandomEndEstimatedLowestPriceDisparateRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double latest_price = 11;
 * @return {number}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getLatestPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setLatestPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double latest_price_disparate_ratio = 12;
 * @return {number}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getLatestPriceDisparateRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setLatestPriceDisparateRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional string random_end_release_time = 13;
 * @return {string}
 */
proto.proto.mdds.v1.RandomEnd.prototype.getRandomEndReleaseTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.setRandomEndReleaseTime = function(value) {
  return jspb.Message.setField(this, 13, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.RandomEnd} returns this
 */
proto.proto.mdds.v1.RandomEnd.prototype.clearRandomEndReleaseTime = function() {
  return jspb.Message.setField(this, 13, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.RandomEnd.prototype.hasRandomEndReleaseTime = function() {
  return jspb.Message.getField(this, 13) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.mdds.v1.Price.repeatedFields_ = [13];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.Price.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.Price.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.Price} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Price.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tradeDate: jspb.Message.getFieldWithDefault(msg, 5, ""),
    transactTime: jspb.Message.getFieldWithDefault(msg, 6, ""),
    totalVolumeTraded: jspb.Message.getFieldWithDefault(msg, 7, 0),
    grossTradeAmt: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    sellTotOrderQty: jspb.Message.getFieldWithDefault(msg, 9, 0),
    buyTotOrderQty: jspb.Message.getFieldWithDefault(msg, 10, 0),
    sellValidOrderCnt: jspb.Message.getFieldWithDefault(msg, 11, 0),
    buyValidOrderCnt: jspb.Message.getFieldWithDefault(msg, 12, 0),
    mdEntryList: jspb.Message.toObjectList(msg.getMdEntryList(),
    proto.proto.mdds.v1.MDEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.Price}
 */
proto.proto.mdds.v1.Price.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.Price;
  return proto.proto.mdds.v1.Price.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.Price} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.Price}
 */
proto.proto.mdds.v1.Price.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingSessionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradeDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactTime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalVolumeTraded(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGrossTradeAmt(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellTotOrderQty(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyTotOrderQty(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellValidOrderCnt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyValidOrderCnt(value);
      break;
    case 13:
      var value = new proto.proto.mdds.v1.MDEntry;
      reader.readMessage(value,proto.proto.mdds.v1.MDEntry.deserializeBinaryFromReader);
      msg.addMdEntry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.Price.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.Price.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.Price} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Price.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTradeDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTransactTime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeUint64(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeUint64(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = message.getMdEntryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      13,
      f,
      proto.proto.mdds.v1.MDEntry.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.Price.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.Price} returns this
*/
proto.proto.mdds.v1.Price.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Price.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.Price.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.Price.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string trading_session_id = 3;
 * @return {string}
 */
proto.proto.mdds.v1.Price.prototype.getTradingSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.Price.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string trade_date = 5;
 * @return {string}
 */
proto.proto.mdds.v1.Price.prototype.getTradeDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setTradeDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string transact_time = 6;
 * @return {string}
 */
proto.proto.mdds.v1.Price.prototype.getTransactTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setTransactTime = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint64 total_volume_traded = 7;
 * @return {number}
 */
proto.proto.mdds.v1.Price.prototype.getTotalVolumeTraded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setTotalVolumeTraded = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.clearTotalVolumeTraded = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Price.prototype.hasTotalVolumeTraded = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional double gross_trade_amt = 8;
 * @return {number}
 */
proto.proto.mdds.v1.Price.prototype.getGrossTradeAmt = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setGrossTradeAmt = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.clearGrossTradeAmt = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Price.prototype.hasGrossTradeAmt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional uint64 sell_tot_order_qty = 9;
 * @return {number}
 */
proto.proto.mdds.v1.Price.prototype.getSellTotOrderQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setSellTotOrderQty = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.clearSellTotOrderQty = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Price.prototype.hasSellTotOrderQty = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional uint64 buy_tot_order_qty = 10;
 * @return {number}
 */
proto.proto.mdds.v1.Price.prototype.getBuyTotOrderQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setBuyTotOrderQty = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.clearBuyTotOrderQty = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Price.prototype.hasBuyTotOrderQty = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional uint64 sell_valid_order_cnt = 11;
 * @return {number}
 */
proto.proto.mdds.v1.Price.prototype.getSellValidOrderCnt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setSellValidOrderCnt = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.clearSellValidOrderCnt = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Price.prototype.hasSellValidOrderCnt = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional uint64 buy_valid_order_cnt = 12;
 * @return {number}
 */
proto.proto.mdds.v1.Price.prototype.getBuyValidOrderCnt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.setBuyValidOrderCnt = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.clearBuyValidOrderCnt = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Price.prototype.hasBuyValidOrderCnt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * repeated MDEntry md_entry = 13;
 * @return {!Array<!proto.proto.mdds.v1.MDEntry>}
 */
proto.proto.mdds.v1.Price.prototype.getMdEntryList = function() {
  return /** @type{!Array<!proto.proto.mdds.v1.MDEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.mdds.v1.MDEntry, 13));
};


/**
 * @param {!Array<!proto.proto.mdds.v1.MDEntry>} value
 * @return {!proto.proto.mdds.v1.Price} returns this
*/
proto.proto.mdds.v1.Price.prototype.setMdEntryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 13, value);
};


/**
 * @param {!proto.proto.mdds.v1.MDEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.MDEntry}
 */
proto.proto.mdds.v1.Price.prototype.addMdEntry = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.proto.mdds.v1.MDEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.Price} returns this
 */
proto.proto.mdds.v1.Price.prototype.clearMdEntryList = function() {
  return this.setMdEntryList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.MDEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.MDEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.MDEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MDEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
    rptSeq: jspb.Message.getFieldWithDefault(msg, 1, 0),
    updateAction: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, ""),
    positionNo: jspb.Message.getFieldWithDefault(msg, 4, 0),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    size: jspb.Message.getFieldWithDefault(msg, 6, 0),
    numberOfOrders: jspb.Message.getFieldWithDefault(msg, 7, 0),
    yield: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    mMSize: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.MDEntry}
 */
proto.proto.mdds.v1.MDEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.MDEntry;
  return proto.proto.mdds.v1.MDEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.MDEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.MDEntry}
 */
proto.proto.mdds.v1.MDEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRptSeq(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateAction(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPositionNo(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSize(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setNumberOfOrders(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYield(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMMSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.MDEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.MDEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.MDEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MDEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRptSeq();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getUpdateAction();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPositionNo();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeUint64(
      9,
      f
    );
  }
};


/**
 * optional uint64 rpt_seq = 1;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntry.prototype.getRptSeq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.setRptSeq = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string update_action = 2;
 * @return {string}
 */
proto.proto.mdds.v1.MDEntry.prototype.getUpdateAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.setUpdateAction = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.proto.mdds.v1.MDEntry.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 position_no = 4;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntry.prototype.getPositionNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.setPositionNo = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double price = 5;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntry.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional uint64 size = 6;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntry.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint64 number_of_orders = 7;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntry.prototype.getNumberOfOrders = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.setNumberOfOrders = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.clearNumberOfOrders = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.MDEntry.prototype.hasNumberOfOrders = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional double yield = 8;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntry.prototype.getYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.setYield = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.clearYield = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.MDEntry.prototype.hasYield = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional uint64 m_m_size = 9;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntry.prototype.getMMSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.setMMSize = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.MDEntry} returns this
 */
proto.proto.mdds.v1.MDEntry.prototype.clearMMSize = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.MDEntry.prototype.hasMMSize = function() {
  return jspb.Message.getField(this, 9) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.mdds.v1.PriceRecovery.repeatedFields_ = [19];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.PriceRecovery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.PriceRecovery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.PriceRecovery.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    openPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    tradeSessionHighPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    tradeSessionLowPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    symbolCloseInfoPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    openPriceYield: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    tradeSessionHighPriceYield: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    tradeSessionLowPriceYield: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    closePriceYield: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    totalVolumeTraded: jspb.Message.getFieldWithDefault(msg, 13, 0),
    grossTradeAmt: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
    sellTotOrderQty: jspb.Message.getFieldWithDefault(msg, 15, 0),
    buyTotOrderQty: jspb.Message.getFieldWithDefault(msg, 16, 0),
    sellValidOrderCnt: jspb.Message.getFieldWithDefault(msg, 17, 0),
    buyValidOrderCnt: jspb.Message.getFieldWithDefault(msg, 18, 0),
    mdEntryList: jspb.Message.toObjectList(msg.getMdEntryList(),
    proto.proto.mdds.v1.MDEntryRecovery.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.PriceRecovery}
 */
proto.proto.mdds.v1.PriceRecovery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.PriceRecovery;
  return proto.proto.mdds.v1.PriceRecovery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.PriceRecovery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.PriceRecovery}
 */
proto.proto.mdds.v1.PriceRecovery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingSessionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpenPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradeSessionHighPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradeSessionLowPrice(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSymbolCloseInfoPrice(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpenPriceYield(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradeSessionHighPriceYield(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradeSessionLowPriceYield(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClosePriceYield(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalVolumeTraded(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGrossTradeAmt(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellTotOrderQty(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyTotOrderQty(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellValidOrderCnt(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyValidOrderCnt(value);
      break;
    case 19:
      var value = new proto.proto.mdds.v1.MDEntryRecovery;
      reader.readMessage(value,proto.proto.mdds.v1.MDEntryRecovery.deserializeBinaryFromReader);
      msg.addMdEntry(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.PriceRecovery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.PriceRecovery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.PriceRecovery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOpenPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getTradeSessionHighPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getTradeSessionLowPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getSymbolCloseInfoPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 10));
  if (f != null) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getTotalVolumeTraded();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
  f = message.getGrossTradeAmt();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeUint64(
      15,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeUint64(
      16,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeUint64(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeUint64(
      18,
      f
    );
  }
  f = message.getMdEntryList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      19,
      f,
      proto.proto.mdds.v1.MDEntryRecovery.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
*/
proto.proto.mdds.v1.PriceRecovery.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string trading_session_id = 3;
 * @return {string}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getTradingSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double open_price = 5;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getOpenPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setOpenPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double trade_session_high_price = 6;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getTradeSessionHighPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setTradeSessionHighPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double trade_session_low_price = 7;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getTradeSessionLowPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setTradeSessionLowPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double symbol_close_info_price = 8;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getSymbolCloseInfoPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setSymbolCloseInfoPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double open_price_yield = 9;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getOpenPriceYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setOpenPriceYield = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.clearOpenPriceYield = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.hasOpenPriceYield = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional double trade_session_high_price_yield = 10;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getTradeSessionHighPriceYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setTradeSessionHighPriceYield = function(value) {
  return jspb.Message.setField(this, 10, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.clearTradeSessionHighPriceYield = function() {
  return jspb.Message.setField(this, 10, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.hasTradeSessionHighPriceYield = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional double trade_session_low_price_yield = 11;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getTradeSessionLowPriceYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setTradeSessionLowPriceYield = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.clearTradeSessionLowPriceYield = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.hasTradeSessionLowPriceYield = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional double close_price_yield = 12;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getClosePriceYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setClosePriceYield = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.clearClosePriceYield = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.hasClosePriceYield = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional uint64 total_volume_traded = 13;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getTotalVolumeTraded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setTotalVolumeTraded = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional double gross_trade_amt = 14;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getGrossTradeAmt = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setGrossTradeAmt = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional uint64 sell_tot_order_qty = 15;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getSellTotOrderQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setSellTotOrderQty = function(value) {
  return jspb.Message.setField(this, 15, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.clearSellTotOrderQty = function() {
  return jspb.Message.setField(this, 15, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.hasSellTotOrderQty = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional uint64 buy_tot_order_qty = 16;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getBuyTotOrderQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setBuyTotOrderQty = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.clearBuyTotOrderQty = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.hasBuyTotOrderQty = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional uint64 sell_valid_order_cnt = 17;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getSellValidOrderCnt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setSellValidOrderCnt = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.clearSellValidOrderCnt = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.hasSellValidOrderCnt = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional uint64 buy_valid_order_cnt = 18;
 * @return {number}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getBuyValidOrderCnt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.setBuyValidOrderCnt = function(value) {
  return jspb.Message.setField(this, 18, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.clearBuyValidOrderCnt = function() {
  return jspb.Message.setField(this, 18, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.hasBuyValidOrderCnt = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * repeated MDEntryRecovery md_entry = 19;
 * @return {!Array<!proto.proto.mdds.v1.MDEntryRecovery>}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.getMdEntryList = function() {
  return /** @type{!Array<!proto.proto.mdds.v1.MDEntryRecovery>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.mdds.v1.MDEntryRecovery, 19));
};


/**
 * @param {!Array<!proto.proto.mdds.v1.MDEntryRecovery>} value
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
*/
proto.proto.mdds.v1.PriceRecovery.prototype.setMdEntryList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 19, value);
};


/**
 * @param {!proto.proto.mdds.v1.MDEntryRecovery=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.MDEntryRecovery}
 */
proto.proto.mdds.v1.PriceRecovery.prototype.addMdEntry = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.proto.mdds.v1.MDEntryRecovery, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.PriceRecovery} returns this
 */
proto.proto.mdds.v1.PriceRecovery.prototype.clearMdEntryList = function() {
  return this.setMdEntryList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.MDEntryRecovery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.MDEntryRecovery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MDEntryRecovery.toObject = function(includeInstance, msg) {
  var f, obj = {
    rptSeq: jspb.Message.getFieldWithDefault(msg, 1, 0),
    updateAction: jspb.Message.getFieldWithDefault(msg, 2, ""),
    type: jspb.Message.getFieldWithDefault(msg, 3, ""),
    positionNo: jspb.Message.getFieldWithDefault(msg, 4, 0),
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    size: jspb.Message.getFieldWithDefault(msg, 6, 0),
    numberOfOrders: jspb.Message.getFieldWithDefault(msg, 7, 0),
    yield: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    mMSize: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.MDEntryRecovery}
 */
proto.proto.mdds.v1.MDEntryRecovery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.MDEntryRecovery;
  return proto.proto.mdds.v1.MDEntryRecovery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.MDEntryRecovery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.MDEntryRecovery}
 */
proto.proto.mdds.v1.MDEntryRecovery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setRptSeq(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdateAction(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPositionNo(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSize(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setNumberOfOrders(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYield(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMMSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.MDEntryRecovery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.MDEntryRecovery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MDEntryRecovery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRptSeq();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getUpdateAction();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPositionNo();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getMMSize();
  if (f !== 0) {
    writer.writeUint64(
      9,
      f
    );
  }
};


/**
 * optional uint64 rpt_seq = 1;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.getRptSeq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.setRptSeq = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string update_action = 2;
 * @return {string}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.getUpdateAction = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.setUpdateAction = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string type = 3;
 * @return {string}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 position_no = 4;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.getPositionNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.setPositionNo = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double price = 5;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional uint64 size = 6;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint64 number_of_orders = 7;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.getNumberOfOrders = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.setNumberOfOrders = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.clearNumberOfOrders = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.hasNumberOfOrders = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional double yield = 8;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.getYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.setYield = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.clearYield = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.hasYield = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional uint64 m_m_size = 9;
 * @return {number}
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.getMMSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MDEntryRecovery} returns this
 */
proto.proto.mdds.v1.MDEntryRecovery.prototype.setMMSize = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.Index.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.Index.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.Index} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Index.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    marketIndexClass: jspb.Message.getFieldWithDefault(msg, 3, ""),
    indexesTypeCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 5, ""),
    transactTime: jspb.Message.getFieldWithDefault(msg, 6, ""),
    valueIndexes: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    totalVolumeTraded: jspb.Message.getFieldWithDefault(msg, 8, 0),
    grossTradeAmt: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    continuousTradingAccumulativeTradingVolume: jspb.Message.getFieldWithDefault(msg, 10, 0),
    continuousTradingAccumulativeTradingValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    blockTradingAccumulativeTradingVolume: jspb.Message.getFieldWithDefault(msg, 12, 0),
    blockTradingAccumulativeTradingValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    fluctuationUpperLimitIssueCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    fluctuationUpIssueCount: jspb.Message.getFieldWithDefault(msg, 15, 0),
    fluctuationSteadinessIssueCount: jspb.Message.getFieldWithDefault(msg, 16, 0),
    fluctuationDownIssueCount: jspb.Message.getFieldWithDefault(msg, 17, 0),
    fluctuationLowerLimitIssueCount: jspb.Message.getFieldWithDefault(msg, 18, 0),
    fluctuationDownIssueVolume: jspb.Message.getFieldWithDefault(msg, 19, 0),
    fluctuationSteadinessIssueVolume: jspb.Message.getFieldWithDefault(msg, 20, 0),
    fluctuationUpIssueVolume: jspb.Message.getFieldWithDefault(msg, 21, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.Index}
 */
proto.proto.mdds.v1.Index.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.Index;
  return proto.proto.mdds.v1.Index.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.Index} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.Index}
 */
proto.proto.mdds.v1.Index.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingSessionId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketIndexClass(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexesTypeCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactTime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValueIndexes(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalVolumeTraded(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGrossTradeAmt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setContinuousTradingAccumulativeTradingVolume(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setContinuousTradingAccumulativeTradingValue(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBlockTradingAccumulativeTradingVolume(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBlockTradingAccumulativeTradingValue(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationUpperLimitIssueCount(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationUpIssueCount(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationSteadinessIssueCount(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationDownIssueCount(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationLowerLimitIssueCount(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFluctuationDownIssueVolume(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFluctuationSteadinessIssueVolume(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFluctuationUpIssueVolume(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.Index.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.Index.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.Index} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Index.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMarketIndexClass();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIndexesTypeCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTransactTime();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getValueIndexes();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getTotalVolumeTraded();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getGrossTradeAmt();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getContinuousTradingAccumulativeTradingVolume();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getContinuousTradingAccumulativeTradingValue();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getBlockTradingAccumulativeTradingVolume();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = message.getBlockTradingAccumulativeTradingValue();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getFluctuationUpperLimitIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getFluctuationUpIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getFluctuationSteadinessIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getFluctuationDownIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      17,
      f
    );
  }
  f = message.getFluctuationLowerLimitIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getFluctuationDownIssueVolume();
  if (f !== 0) {
    writer.writeUint64(
      19,
      f
    );
  }
  f = message.getFluctuationSteadinessIssueVolume();
  if (f !== 0) {
    writer.writeUint64(
      20,
      f
    );
  }
  f = message.getFluctuationUpIssueVolume();
  if (f !== 0) {
    writer.writeUint64(
      21,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.Index.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.Index} returns this
*/
proto.proto.mdds.v1.Index.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Index.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.Index.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string trading_session_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.Index.prototype.getTradingSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string market_index_class = 3;
 * @return {string}
 */
proto.proto.mdds.v1.Index.prototype.getMarketIndexClass = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setMarketIndexClass = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string indexes_type_code = 4;
 * @return {string}
 */
proto.proto.mdds.v1.Index.prototype.getIndexesTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setIndexesTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string currency = 5;
 * @return {string}
 */
proto.proto.mdds.v1.Index.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string transact_time = 6;
 * @return {string}
 */
proto.proto.mdds.v1.Index.prototype.getTransactTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setTransactTime = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional double value_indexes = 7;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getValueIndexes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setValueIndexes = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional uint64 total_volume_traded = 8;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getTotalVolumeTraded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setTotalVolumeTraded = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double gross_trade_amt = 9;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getGrossTradeAmt = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setGrossTradeAmt = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional uint64 continuous_trading_accumulative_trading_volume = 10;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getContinuousTradingAccumulativeTradingVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setContinuousTradingAccumulativeTradingVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double continuous_trading_accumulative_trading_value = 11;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getContinuousTradingAccumulativeTradingValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setContinuousTradingAccumulativeTradingValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional uint64 block_trading_accumulative_trading_volume = 12;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getBlockTradingAccumulativeTradingVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setBlockTradingAccumulativeTradingVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional double block_trading_accumulative_trading_value = 13;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getBlockTradingAccumulativeTradingValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setBlockTradingAccumulativeTradingValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional uint32 fluctuation_upper_limit_issue_count = 14;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getFluctuationUpperLimitIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setFluctuationUpperLimitIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional uint32 fluctuation_up_issue_count = 15;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getFluctuationUpIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setFluctuationUpIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional uint32 fluctuation_steadiness_issue_count = 16;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getFluctuationSteadinessIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setFluctuationSteadinessIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional uint32 fluctuation_down_issue_count = 17;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getFluctuationDownIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setFluctuationDownIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional uint32 fluctuation_lower_limit_issue_count = 18;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getFluctuationLowerLimitIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setFluctuationLowerLimitIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional uint64 fluctuation_down_issue_volume = 19;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getFluctuationDownIssueVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setFluctuationDownIssueVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional uint64 fluctuation_steadiness_issue_volume = 20;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getFluctuationSteadinessIssueVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setFluctuationSteadinessIssueVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional uint64 fluctuation_up_issue_volume = 21;
 * @return {number}
 */
proto.proto.mdds.v1.Index.prototype.getFluctuationUpIssueVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Index} returns this
 */
proto.proto.mdds.v1.Index.prototype.setFluctuationUpIssueVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.InvestorPerIndustry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.InvestorPerIndustry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.InvestorPerIndustry.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    transactTime: jspb.Message.getFieldWithDefault(msg, 2, ""),
    marketIndexClass: jspb.Message.getFieldWithDefault(msg, 3, ""),
    indexesTypeCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 5, ""),
    investCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    sellVolume: jspb.Message.getFieldWithDefault(msg, 7, 0),
    sellTradedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    buyVolume: jspb.Message.getFieldWithDefault(msg, 9, 0),
    buyTradedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    bondClassificationCode: jspb.Message.getFieldWithDefault(msg, 11, ""),
    securityGroupId: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry}
 */
proto.proto.mdds.v1.InvestorPerIndustry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.InvestorPerIndustry;
  return proto.proto.mdds.v1.InvestorPerIndustry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.InvestorPerIndustry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry}
 */
proto.proto.mdds.v1.InvestorPerIndustry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketIndexClass(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexesTypeCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvestCode(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellVolume(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSellTradedAmount(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyVolume(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBuyTradedAmount(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setBondClassificationCode(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.InvestorPerIndustry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.InvestorPerIndustry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.InvestorPerIndustry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTransactTime();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInvestCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSellVolume();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getSellTradedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getBuyVolume();
  if (f !== 0) {
    writer.writeUint64(
      9,
      f
    );
  }
  f = message.getBuyTradedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeString(
      11,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
*/
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string transact_time = 2;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getTransactTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setTransactTime = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string market_index_class = 3;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getMarketIndexClass = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setMarketIndexClass = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.clearMarketIndexClass = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.hasMarketIndexClass = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string indexes_type_code = 4;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getIndexesTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setIndexesTypeCode = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.clearIndexesTypeCode = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.hasIndexesTypeCode = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string currency = 5;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setCurrency = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.clearCurrency = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.hasCurrency = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string invest_code = 6;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getInvestCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setInvestCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint64 sell_volume = 7;
 * @return {number}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getSellVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setSellVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional double sell_traded_amount = 8;
 * @return {number}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getSellTradedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setSellTradedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional uint64 buy_volume = 9;
 * @return {number}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getBuyVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setBuyVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional double buy_traded_amount = 10;
 * @return {number}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getBuyTradedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setBuyTradedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional string bond_classification_code = 11;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getBondClassificationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setBondClassificationCode = function(value) {
  return jspb.Message.setField(this, 11, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.clearBondClassificationCode = function() {
  return jspb.Message.setField(this, 11, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.hasBondClassificationCode = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string security_group_id = 12;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.getSecurityGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.setSecurityGroupId = function(value) {
  return jspb.Message.setField(this, 12, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.InvestorPerIndustry} returns this
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.clearSecurityGroupId = function() {
  return jspb.Message.setField(this, 12, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.InvestorPerIndustry.prototype.hasSecurityGroupId = function() {
  return jspb.Message.getField(this, 12) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.InvestorPerSymbol.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.InvestorPerSymbol} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.InvestorPerSymbol.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    investCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    sellVolume: jspb.Message.getFieldWithDefault(msg, 4, 0),
    sellTradedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    buyVolume: jspb.Message.getFieldWithDefault(msg, 6, 0),
    buyTradedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol}
 */
proto.proto.mdds.v1.InvestorPerSymbol.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.InvestorPerSymbol;
  return proto.proto.mdds.v1.InvestorPerSymbol.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.InvestorPerSymbol} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol}
 */
proto.proto.mdds.v1.InvestorPerSymbol.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvestCode(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellVolume(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSellTradedAmount(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyVolume(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBuyTradedAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.InvestorPerSymbol.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.InvestorPerSymbol} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.InvestorPerSymbol.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInvestCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSellVolume();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getSellTradedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getBuyVolume();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getBuyTradedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol} returns this
*/
proto.proto.mdds.v1.InvestorPerSymbol.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol} returns this
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol} returns this
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol} returns this
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string invest_code = 3;
 * @return {string}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.getInvestCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol} returns this
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.setInvestCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 sell_volume = 4;
 * @return {number}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.getSellVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol} returns this
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.setSellVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double sell_traded_amount = 5;
 * @return {number}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.getSellTradedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol} returns this
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.setSellTradedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional uint64 buy_volume = 6;
 * @return {number}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.getBuyVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol} returns this
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.setBuyVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double buy_traded_amount = 7;
 * @return {number}
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.getBuyTradedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InvestorPerSymbol} returns this
 */
proto.proto.mdds.v1.InvestorPerSymbol.prototype.setBuyTradedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.TopNMembersPerSymbol.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.TopNMembersPerSymbol} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    totalNumberReports: jspb.Message.getFieldWithDefault(msg, 3, 0),
    sellRankSeq: jspb.Message.getFieldWithDefault(msg, 4, 0),
    sellMemberNo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    sellVolume: jspb.Message.getFieldWithDefault(msg, 6, 0),
    sellTradedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    buyRankSeq: jspb.Message.getFieldWithDefault(msg, 8, 0),
    buyMemberNo: jspb.Message.getFieldWithDefault(msg, 9, ""),
    buyVolume: jspb.Message.getFieldWithDefault(msg, 10, 0),
    buyTradedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.TopNMembersPerSymbol;
  return proto.proto.mdds.v1.TopNMembersPerSymbol.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.TopNMembersPerSymbol} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalNumberReports(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setSellRankSeq(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSellMemberNo(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellVolume(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSellTradedAmount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBuyRankSeq(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBuyMemberNo(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyVolume(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBuyTradedAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.TopNMembersPerSymbol.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.TopNMembersPerSymbol} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotalNumberReports();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getSellRankSeq();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getSellMemberNo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getSellVolume();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getSellTradedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getBuyRankSeq();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getBuyMemberNo();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getBuyVolume();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getBuyTradedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
*/
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 total_number_reports = 3;
 * @return {number}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getTotalNumberReports = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setTotalNumberReports = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint32 sell_rank_seq = 4;
 * @return {number}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getSellRankSeq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setSellRankSeq = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string sell_member_no = 5;
 * @return {string}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getSellMemberNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setSellMemberNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 sell_volume = 6;
 * @return {number}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getSellVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setSellVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional double sell_traded_amount = 7;
 * @return {number}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getSellTradedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setSellTradedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional uint32 buy_rank_seq = 8;
 * @return {number}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getBuyRankSeq = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setBuyRankSeq = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string buy_member_no = 9;
 * @return {string}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getBuyMemberNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setBuyMemberNo = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional uint64 buy_volume = 10;
 * @return {number}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getBuyVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setBuyVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double buy_traded_amount = 11;
 * @return {number}
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.getBuyTradedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNMembersPerSymbol} returns this
 */
proto.proto.mdds.v1.TopNMembersPerSymbol.prototype.setBuyTradedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.OpenInterest.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.OpenInterest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.OpenInterest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.OpenInterest.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tradeDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    openInterestQty: jspb.Message.getFieldWithDefault(msg, 4, 0),
    settlementPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.OpenInterest}
 */
proto.proto.mdds.v1.OpenInterest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.OpenInterest;
  return proto.proto.mdds.v1.OpenInterest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.OpenInterest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.OpenInterest}
 */
proto.proto.mdds.v1.OpenInterest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradeDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOpenInterestQty(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSettlementPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.OpenInterest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.OpenInterest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.OpenInterest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.OpenInterest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTradeDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOpenInterestQty();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getSettlementPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.OpenInterest.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.OpenInterest} returns this
*/
proto.proto.mdds.v1.OpenInterest.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.OpenInterest} returns this
 */
proto.proto.mdds.v1.OpenInterest.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.OpenInterest.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.OpenInterest.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.OpenInterest} returns this
 */
proto.proto.mdds.v1.OpenInterest.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.proto.mdds.v1.OpenInterest.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.OpenInterest} returns this
 */
proto.proto.mdds.v1.OpenInterest.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string trade_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.OpenInterest.prototype.getTradeDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.OpenInterest} returns this
 */
proto.proto.mdds.v1.OpenInterest.prototype.setTradeDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 open_interest_qty = 4;
 * @return {number}
 */
proto.proto.mdds.v1.OpenInterest.prototype.getOpenInterestQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.OpenInterest} returns this
 */
proto.proto.mdds.v1.OpenInterest.prototype.setOpenInterestQty = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double settlement_price = 5;
 * @return {number}
 */
proto.proto.mdds.v1.OpenInterest.prototype.getSettlementPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.OpenInterest} returns this
 */
proto.proto.mdds.v1.OpenInterest.prototype.setSettlementPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.DeemTradePrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.DeemTradePrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.DeemTradePrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    expectedTradePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    expectedTradeQty: jspb.Message.getFieldWithDefault(msg, 5, 0),
    expectedTradeYield: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.DeemTradePrice}
 */
proto.proto.mdds.v1.DeemTradePrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.DeemTradePrice;
  return proto.proto.mdds.v1.DeemTradePrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.DeemTradePrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.DeemTradePrice}
 */
proto.proto.mdds.v1.DeemTradePrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExpectedTradePrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExpectedTradeQty(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExpectedTradeYield(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.DeemTradePrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.DeemTradePrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.DeemTradePrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExpectedTradePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getExpectedTradeQty();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.DeemTradePrice} returns this
*/
proto.proto.mdds.v1.DeemTradePrice.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.DeemTradePrice} returns this
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DeemTradePrice} returns this
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DeemTradePrice} returns this
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DeemTradePrice} returns this
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double expected_trade_price = 4;
 * @return {number}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.getExpectedTradePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.DeemTradePrice} returns this
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.setExpectedTradePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional uint64 expected_trade_qty = 5;
 * @return {number}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.getExpectedTradeQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.DeemTradePrice} returns this
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.setExpectedTradeQty = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double expected_trade_yield = 6;
 * @return {number}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.getExpectedTradeYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.DeemTradePrice} returns this
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.setExpectedTradeYield = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.DeemTradePrice} returns this
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.clearExpectedTradeYield = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.DeemTradePrice.prototype.hasExpectedTradeYield = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.ForeignerOrderLimit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.ForeignerOrderLimit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ForeignerOrderLimit.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    foreignerBuyPossibleQty: jspb.Message.getFieldWithDefault(msg, 3, 0),
    foreignerOrderLimitQty: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.ForeignerOrderLimit}
 */
proto.proto.mdds.v1.ForeignerOrderLimit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.ForeignerOrderLimit;
  return proto.proto.mdds.v1.ForeignerOrderLimit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.ForeignerOrderLimit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.ForeignerOrderLimit}
 */
proto.proto.mdds.v1.ForeignerOrderLimit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setForeignerBuyPossibleQty(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setForeignerOrderLimitQty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.ForeignerOrderLimit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.ForeignerOrderLimit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ForeignerOrderLimit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getForeignerBuyPossibleQty();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getForeignerOrderLimitQty();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.ForeignerOrderLimit} returns this
*/
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.ForeignerOrderLimit} returns this
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ForeignerOrderLimit} returns this
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ForeignerOrderLimit} returns this
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint64 foreigner_buy_possible_qty = 3;
 * @return {number}
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.getForeignerBuyPossibleQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ForeignerOrderLimit} returns this
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.setForeignerBuyPossibleQty = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 foreigner_order_limit_qty = 4;
 * @return {number}
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.getForeignerOrderLimitQty = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ForeignerOrderLimit} returns this
 */
proto.proto.mdds.v1.ForeignerOrderLimit.prototype.setForeignerOrderLimitQty = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.PriceLimitExpansion.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.PriceLimitExpansion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.PriceLimitExpansion.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    transactTime: jspb.Message.getFieldWithDefault(msg, 4, ""),
    highLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    lowLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    pleUpperLimitStep: jspb.Message.getFieldWithDefault(msg, 7, 0),
    pleLowerLimitStep: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion}
 */
proto.proto.mdds.v1.PriceLimitExpansion.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.PriceLimitExpansion;
  return proto.proto.mdds.v1.PriceLimitExpansion.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.PriceLimitExpansion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion}
 */
proto.proto.mdds.v1.PriceLimitExpansion.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactTime(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighLimitPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowLimitPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPleUpperLimitStep(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPleLowerLimitStep(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.PriceLimitExpansion.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.PriceLimitExpansion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.PriceLimitExpansion.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTransactTime();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHighLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getLowLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
*/
proto.proto.mdds.v1.PriceLimitExpansion.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string transact_time = 4;
 * @return {string}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.getTransactTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.setTransactTime = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double high_limit_price = 5;
 * @return {number}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.getHighLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.setHighLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double low_limit_price = 6;
 * @return {number}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.getLowLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.setLowLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int64 ple_upper_limit_step = 7;
 * @return {number}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.getPleUpperLimitStep = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.setPleUpperLimitStep = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.clearPleUpperLimitStep = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.hasPleUpperLimitStep = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional int64 ple_lower_limit_step = 8;
 * @return {number}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.getPleLowerLimitStep = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.setPleLowerLimitStep = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.PriceLimitExpansion} returns this
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.clearPleLowerLimitStep = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.PriceLimitExpansion.prototype.hasPleLowerLimitStep = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.ETFiNav.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.ETFiNav.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.ETFiNav} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ETFiNav.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    transactTime: jspb.Message.getFieldWithDefault(msg, 3, ""),
    iNavValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.ETFiNav}
 */
proto.proto.mdds.v1.ETFiNav.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.ETFiNav;
  return proto.proto.mdds.v1.ETFiNav.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.ETFiNav} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.ETFiNav}
 */
proto.proto.mdds.v1.ETFiNav.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setINavValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.ETFiNav.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.ETFiNav.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.ETFiNav} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ETFiNav.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTransactTime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getINavValue();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.ETFiNav.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.ETFiNav} returns this
*/
proto.proto.mdds.v1.ETFiNav.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.ETFiNav} returns this
 */
proto.proto.mdds.v1.ETFiNav.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.ETFiNav.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.ETFiNav.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFiNav} returns this
 */
proto.proto.mdds.v1.ETFiNav.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.proto.mdds.v1.ETFiNav.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFiNav} returns this
 */
proto.proto.mdds.v1.ETFiNav.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string transact_time = 3;
 * @return {string}
 */
proto.proto.mdds.v1.ETFiNav.prototype.getTransactTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFiNav} returns this
 */
proto.proto.mdds.v1.ETFiNav.prototype.setTransactTime = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double i_nav_value = 4;
 * @return {number}
 */
proto.proto.mdds.v1.ETFiNav.prototype.getINavValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ETFiNav} returns this
 */
proto.proto.mdds.v1.ETFiNav.prototype.setINavValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.ETFiIndex.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.ETFiIndex.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.ETFiIndex} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ETFiIndex.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    transactTime: jspb.Message.getFieldWithDefault(msg, 3, ""),
    valueIndexes: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.ETFiIndex}
 */
proto.proto.mdds.v1.ETFiIndex.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.ETFiIndex;
  return proto.proto.mdds.v1.ETFiIndex.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.ETFiIndex} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.ETFiIndex}
 */
proto.proto.mdds.v1.ETFiIndex.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactTime(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValueIndexes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.ETFiIndex.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.ETFiIndex.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.ETFiIndex} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ETFiIndex.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTransactTime();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getValueIndexes();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.ETFiIndex.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.ETFiIndex} returns this
*/
proto.proto.mdds.v1.ETFiIndex.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.ETFiIndex} returns this
 */
proto.proto.mdds.v1.ETFiIndex.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.ETFiIndex.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.ETFiIndex.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFiIndex} returns this
 */
proto.proto.mdds.v1.ETFiIndex.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.proto.mdds.v1.ETFiIndex.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFiIndex} returns this
 */
proto.proto.mdds.v1.ETFiIndex.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string transact_time = 3;
 * @return {string}
 */
proto.proto.mdds.v1.ETFiIndex.prototype.getTransactTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFiIndex} returns this
 */
proto.proto.mdds.v1.ETFiIndex.prototype.setTransactTime = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double value_indexes = 4;
 * @return {number}
 */
proto.proto.mdds.v1.ETFiIndex.prototype.getValueIndexes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ETFiIndex} returns this
 */
proto.proto.mdds.v1.ETFiIndex.prototype.setValueIndexes = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.ETFTrackingError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.ETFTrackingError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ETFTrackingError.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tradeDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    trackingError: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    disparateRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.ETFTrackingError}
 */
proto.proto.mdds.v1.ETFTrackingError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.ETFTrackingError;
  return proto.proto.mdds.v1.ETFTrackingError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.ETFTrackingError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.ETFTrackingError}
 */
proto.proto.mdds.v1.ETFTrackingError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradeDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTrackingError(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDisparateRatio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.ETFTrackingError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.ETFTrackingError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ETFTrackingError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTradeDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getTrackingError();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getDisparateRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.ETFTrackingError} returns this
*/
proto.proto.mdds.v1.ETFTrackingError.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.ETFTrackingError} returns this
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFTrackingError} returns this
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFTrackingError} returns this
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string trade_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.getTradeDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFTrackingError} returns this
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.setTradeDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double tracking_error = 4;
 * @return {number}
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.getTrackingError = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ETFTrackingError} returns this
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.setTrackingError = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double disparate_ratio = 5;
 * @return {number}
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.getDisparateRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ETFTrackingError} returns this
 */
proto.proto.mdds.v1.ETFTrackingError.prototype.setDisparateRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalNumberReports: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rank: jspb.Message.getFieldWithDefault(msg, 3, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mdEntrySize: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity;
  return proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalNumberReports(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRank(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMdEntrySize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalNumberReports();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMdEntrySize();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} returns this
*/
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 total_number_reports = 2;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.getTotalNumberReports = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.setTotalNumberReports = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 rank = 3;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional uint64 md_entry_size = 5;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.getMdEntrySize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithTradingQuantity.prototype.setMdEntrySize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalNumberReports: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rank: jspb.Message.getFieldWithDefault(msg, 3, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    mdEntryPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice;
  return proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalNumberReports(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRank(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMdEntryPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalNumberReports();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMdEntryPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} returns this
*/
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 total_number_reports = 2;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.getTotalNumberReports = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.setTotalNumberReports = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 rank = 3;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double md_entry_price = 5;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.getMdEntryPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithCurrentPrice.prototype.setMdEntryPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalNumberReports: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rank: jspb.Message.getFieldWithDefault(msg, 3, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    priceFluctuationRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice;
  return proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalNumberReports(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRank(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceFluctuationRatio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalNumberReports();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPriceFluctuationRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} returns this
*/
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 total_number_reports = 2;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.getTotalNumberReports = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.setTotalNumberReports = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 rank = 3;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double price_fluctuation_ratio = 5;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.getPriceFluctuationRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithHighRatioOfPrice.prototype.setPriceFluctuationRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    totalNumberReports: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rank: jspb.Message.getFieldWithDefault(msg, 3, 0),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    priceFluctuationRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice;
  return proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalNumberReports(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRank(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceFluctuationRatio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotalNumberReports();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getRank();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPriceFluctuationRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} returns this
*/
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 total_number_reports = 2;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.getTotalNumberReports = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.setTotalNumberReports = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint32 rank = 3;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.getRank = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.setRank = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double price_fluctuation_ratio = 5;
 * @return {number}
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.getPriceFluctuationRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice} returns this
 */
proto.proto.mdds.v1.TopNSymbolsWithLowRatioOfPrice.prototype.setPriceFluctuationRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.TradingResultOfForeignInvestor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    transactTime: jspb.Message.getFieldWithDefault(msg, 5, ""),
    foreignInvestorTypeCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    sellVolume: jspb.Message.getFieldWithDefault(msg, 7, 0),
    sellTradedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    buyVolume: jspb.Message.getFieldWithDefault(msg, 9, 0),
    buyTradedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    totalSellVolume: jspb.Message.getFieldWithDefault(msg, 11, 0),
    totalSellTradedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    totalBuyVolume: jspb.Message.getFieldWithDefault(msg, 13, 0),
    totalBuyTradedAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.TradingResultOfForeignInvestor;
  return proto.proto.mdds.v1.TradingResultOfForeignInvestor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingSessionId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactTime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setForeignInvestorTypeCode(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellVolume(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSellTradedAmount(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyVolume(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBuyTradedAmount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalSellVolume(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalSellTradedAmount(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalBuyVolume(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalBuyTradedAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.TradingResultOfForeignInvestor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTransactTime();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getForeignInvestorTypeCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSellVolume();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getSellTradedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getBuyVolume();
  if (f !== 0) {
    writer.writeUint64(
      9,
      f
    );
  }
  f = message.getBuyTradedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getTotalSellVolume();
  if (f !== 0) {
    writer.writeUint64(
      11,
      f
    );
  }
  f = message.getTotalSellTradedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getTotalBuyVolume();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
  f = message.getTotalBuyTradedAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
*/
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string board_id = 2;
 * @return {string}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string trading_session_id = 3;
 * @return {string}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getTradingSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string transact_time = 5;
 * @return {string}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getTransactTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setTransactTime = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string foreign_investor_type_code = 6;
 * @return {string}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getForeignInvestorTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setForeignInvestorTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint64 sell_volume = 7;
 * @return {number}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getSellVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setSellVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional double sell_traded_amount = 8;
 * @return {number}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getSellTradedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setSellTradedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional uint64 buy_volume = 9;
 * @return {number}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getBuyVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setBuyVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional double buy_traded_amount = 10;
 * @return {number}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getBuyTradedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setBuyTradedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional uint64 total_sell_volume = 11;
 * @return {number}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getTotalSellVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setTotalSellVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional double total_sell_traded_amount = 12;
 * @return {number}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getTotalSellTradedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setTotalSellTradedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional uint64 total_buy_volume = 13;
 * @return {number}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getTotalBuyVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setTotalBuyVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional double total_buy_traded_amount = 14;
 * @return {number}
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.getTotalBuyTradedAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TradingResultOfForeignInvestor} returns this
 */
proto.proto.mdds.v1.TradingResultOfForeignInvestor.prototype.setTotalBuyTradedAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.Disclosure.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.Disclosure.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.Disclosure} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Disclosure.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    securityExchange: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbolName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    disclosureId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    totalMsgNo: jspb.Message.getFieldWithDefault(msg, 6, 0),
    currentMsgNo: jspb.Message.getFieldWithDefault(msg, 7, 0),
    languageCategory: jspb.Message.getFieldWithDefault(msg, 8, ""),
    dataCategory: jspb.Message.getFieldWithDefault(msg, 9, ""),
    publicInformationDate: jspb.Message.getFieldWithDefault(msg, 10, ""),
    transmissionDate: jspb.Message.getFieldWithDefault(msg, 11, ""),
    processType: jspb.Message.getFieldWithDefault(msg, 12, ""),
    headline: jspb.Message.getFieldWithDefault(msg, 13, ""),
    body: jspb.Message.getFieldWithDefault(msg, 14, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.Disclosure}
 */
proto.proto.mdds.v1.Disclosure.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.Disclosure;
  return proto.proto.mdds.v1.Disclosure.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.Disclosure} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.Disclosure}
 */
proto.proto.mdds.v1.Disclosure.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityExchange(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisclosureId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalMsgNo(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setCurrentMsgNo(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setLanguageCategory(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDataCategory(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPublicInformationDate(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransmissionDate(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setProcessType(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setHeadline(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.Disclosure.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.Disclosure.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.Disclosure} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Disclosure.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisclosureId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTotalMsgNo();
  if (f !== 0) {
    writer.writeUint64(
      6,
      f
    );
  }
  f = message.getCurrentMsgNo();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getLanguageCategory();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDataCategory();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPublicInformationDate();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTransmissionDate();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getProcessType();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getHeadline();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.Disclosure.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
*/
proto.proto.mdds.v1.Disclosure.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Disclosure.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string security_exchange = 2;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getSecurityExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setSecurityExchange = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.clearSecurityExchange = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Disclosure.prototype.hasSecurityExchange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol_name = 4;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setSymbolName = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.clearSymbolName = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Disclosure.prototype.hasSymbolName = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string disclosure_id = 5;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getDisclosureId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setDisclosureId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 total_msg_no = 6;
 * @return {number}
 */
proto.proto.mdds.v1.Disclosure.prototype.getTotalMsgNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setTotalMsgNo = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint64 current_msg_no = 7;
 * @return {number}
 */
proto.proto.mdds.v1.Disclosure.prototype.getCurrentMsgNo = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setCurrentMsgNo = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string language_category = 8;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getLanguageCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setLanguageCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string data_category = 9;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getDataCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setDataCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string public_information_date = 10;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getPublicInformationDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setPublicInformationDate = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string transmission_date = 11;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getTransmissionDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setTransmissionDate = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string process_type = 12;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getProcessType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setProcessType = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string headline = 13;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getHeadline = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setHeadline = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string body = 14;
 * @return {string}
 */
proto.proto.mdds.v1.Disclosure.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Disclosure} returns this
 */
proto.proto.mdds.v1.Disclosure.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.Timestamp.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.Timestamp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.Timestamp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Timestamp.toObject = function(includeInstance, msg) {
  var f, obj = {
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    transactTime: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.Timestamp}
 */
proto.proto.mdds.v1.Timestamp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.Timestamp;
  return proto.proto.mdds.v1.Timestamp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.Timestamp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.Timestamp}
 */
proto.proto.mdds.v1.Timestamp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1000:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.Timestamp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.Timestamp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.Timestamp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Timestamp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      1000,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTransactTime();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp sending_time = 1000;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.Timestamp.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1000));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.Timestamp} returns this
*/
proto.proto.mdds.v1.Timestamp.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 1000, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Timestamp} returns this
 */
proto.proto.mdds.v1.Timestamp.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Timestamp.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 1000) != null;
};


/**
 * optional string transact_time = 1;
 * @return {string}
 */
proto.proto.mdds.v1.Timestamp.prototype.getTransactTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Timestamp} returns this
 */
proto.proto.mdds.v1.Timestamp.prototype.setTransactTime = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.DelistedInstrument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.DelistedInstrument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.DelistedInstrument.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    marketId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    symbolShortCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    symbolName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    symbolAbbreviation: jspb.Message.getFieldWithDefault(msg, 9, ""),
    symbolEnglishName: jspb.Message.getFieldWithDefault(msg, 10, ""),
    symbolEnglishAbbreviation: jspb.Message.getFieldWithDefault(msg, 11, ""),
    listingDate: jspb.Message.getFieldWithDefault(msg, 12, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.DelistedInstrument}
 */
proto.proto.mdds.v1.DelistedInstrument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.DelistedInstrument;
  return proto.proto.mdds.v1.DelistedInstrument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.DelistedInstrument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.DelistedInstrument}
 */
proto.proto.mdds.v1.DelistedInstrument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolShortCode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolAbbreviation(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolEnglishName(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolEnglishAbbreviation(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setListingDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.DelistedInstrument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.DelistedInstrument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.DelistedInstrument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBusinessDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSymbolShortCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSymbolName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSymbolAbbreviation();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSymbolEnglishName();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSymbolEnglishAbbreviation();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getListingDate();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string business_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getBusinessDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setBusinessDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string market_id = 4;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string product_id = 6;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string symbol_short_code = 7;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getSymbolShortCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setSymbolShortCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string symbol_name = 8;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setSymbolName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string symbol_abbreviation = 9;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getSymbolAbbreviation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setSymbolAbbreviation = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string symbol_english_name = 10;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getSymbolEnglishName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setSymbolEnglishName = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string symbol_english_abbreviation = 11;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getSymbolEnglishAbbreviation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setSymbolEnglishAbbreviation = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string listing_date = 12;
 * @return {string}
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.getListingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.DelistedInstrument} returns this
 */
proto.proto.mdds.v1.DelistedInstrument.prototype.setListingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.CouponPaymentDate.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.CouponPaymentDate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.CouponPaymentDate.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    marketId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    interestPaymentDate: jspb.Message.getFieldWithDefault(msg, 6, ""),
    realInterestPaymentDate: jspb.Message.getFieldWithDefault(msg, 7, ""),
    exInterestDate: jspb.Message.getFieldWithDefault(msg, 8, ""),
    interestPaymentAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    principalPaymentAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    couponRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.CouponPaymentDate}
 */
proto.proto.mdds.v1.CouponPaymentDate.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.CouponPaymentDate;
  return proto.proto.mdds.v1.CouponPaymentDate.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.CouponPaymentDate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.CouponPaymentDate}
 */
proto.proto.mdds.v1.CouponPaymentDate.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterestPaymentDate(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRealInterestPaymentDate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setExInterestDate(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setInterestPaymentAmount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrincipalPaymentAmount(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCouponRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.CouponPaymentDate.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.CouponPaymentDate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.CouponPaymentDate.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBusinessDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getInterestPaymentDate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRealInterestPaymentDate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getExInterestDate();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getInterestPaymentAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getPrincipalPaymentAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getCouponRate();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string business_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getBusinessDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setBusinessDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string market_id = 4;
 * @return {string}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string interest_payment_date = 6;
 * @return {string}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getInterestPaymentDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setInterestPaymentDate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string real_interest_payment_date = 7;
 * @return {string}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getRealInterestPaymentDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setRealInterestPaymentDate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string ex_interest_date = 8;
 * @return {string}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getExInterestDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setExInterestDate = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional double interest_payment_amount = 9;
 * @return {number}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getInterestPaymentAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setInterestPaymentAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double principal_payment_amount = 10;
 * @return {number}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getPrincipalPaymentAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setPrincipalPaymentAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double coupon_rate = 11;
 * @return {number}
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.getCouponRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.CouponPaymentDate} returns this
 */
proto.proto.mdds.v1.CouponPaymentDate.prototype.setCouponRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.ChangeOfContract.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.ChangeOfContract} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ChangeOfContract.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    marketId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    repoBaseSymbolCode: jspb.Message.getFieldWithDefault(msg, 6, ""),
    tradeNumber: jspb.Message.getFieldWithDefault(msg, 7, 0),
    firstTradingDate: jspb.Message.getFieldWithDefault(msg, 8, ""),
    secondTradingDate: jspb.Message.getFieldWithDefault(msg, 9, ""),
    settlementDate: jspb.Message.getFieldWithDefault(msg, 10, ""),
    repoRealPeriod: jspb.Message.getFieldWithDefault(msg, 11, 0),
    tradePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    tradeQuantity: jspb.Message.getFieldWithDefault(msg, 13, 0),
    tradeValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
    repurchaseAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    repoContractChangeReason: jspb.Message.getFieldWithDefault(msg, 16, ""),
    memberNumber: jspb.Message.getFieldWithDefault(msg, 17, ""),
    traderId: jspb.Message.getFieldWithDefault(msg, 18, ""),
    orderId: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.ChangeOfContract}
 */
proto.proto.mdds.v1.ChangeOfContract.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.ChangeOfContract;
  return proto.proto.mdds.v1.ChangeOfContract.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.ChangeOfContract} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.ChangeOfContract}
 */
proto.proto.mdds.v1.ChangeOfContract.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepoBaseSymbolCode(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTradeNumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstTradingDate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondTradingDate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlementDate(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRepoRealPeriod(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradePrice(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTradeQuantity(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTradeValue(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRepurchaseAmount(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepoContractChangeReason(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberNumber(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setTraderId(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.ChangeOfContract.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.ChangeOfContract} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ChangeOfContract.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRepoBaseSymbolCode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getTradeNumber();
  if (f !== 0) {
    writer.writeUint64(
      7,
      f
    );
  }
  f = message.getFirstTradingDate();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSecondTradingDate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSettlementDate();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getRepoRealPeriod();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getTradePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getTradeQuantity();
  if (f !== 0) {
    writer.writeUint64(
      13,
      f
    );
  }
  f = message.getTradeValue();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getRepurchaseAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getRepoContractChangeReason();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getMemberNumber();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getTraderId();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string market_id = 3;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string board_id = 4;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string repo_base_symbol_code = 6;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getRepoBaseSymbolCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setRepoBaseSymbolCode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional uint64 trade_number = 7;
 * @return {number}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getTradeNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setTradeNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string first_trading_date = 8;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getFirstTradingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setFirstTradingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string second_trading_date = 9;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getSecondTradingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setSecondTradingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string settlement_date = 10;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getSettlementDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setSettlementDate = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional uint32 repo_real_period = 11;
 * @return {number}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getRepoRealPeriod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setRepoRealPeriod = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional double trade_price = 12;
 * @return {number}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getTradePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setTradePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional uint64 trade_quantity = 13;
 * @return {number}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getTradeQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setTradeQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional double trade_value = 14;
 * @return {number}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getTradeValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setTradeValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double repurchase_amount = 15;
 * @return {number}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getRepurchaseAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setRepurchaseAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional string repo_contract_change_reason = 16;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getRepoContractChangeReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setRepoContractChangeReason = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string member_number = 17;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getMemberNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setMemberNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string trader_id = 18;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getTraderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setTraderId = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string order_id = 19;
 * @return {string}
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ChangeOfContract} returns this
 */
proto.proto.mdds.v1.ChangeOfContract.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.InstrumentDerivatives.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.InstrumentDerivatives} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.InstrumentDerivatives.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    marketId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    securityExchange: jspb.Message.getFieldWithDefault(msg, 7, ""),
    productGroupId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    symbolShortCode: jspb.Message.getFieldWithDefault(msg, 9, ""),
    securityGroupId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    tradingCurrencyId: jspb.Message.getFieldWithDefault(msg, 11, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    tickerCode: jspb.Message.getFieldWithDefault(msg, 13, ""),
    symbolName: jspb.Message.getFieldWithDefault(msg, 14, ""),
    symbolAbbreviation: jspb.Message.getFieldWithDefault(msg, 15, ""),
    symbolEnglishName: jspb.Message.getFieldWithDefault(msg, 16, ""),
    symbolEnglishAbbreviation: jspb.Message.getFieldWithDefault(msg, 17, ""),
    listingDate: jspb.Message.getFieldWithDefault(msg, 18, ""),
    tradingCurrencyIsoCode: jspb.Message.getFieldWithDefault(msg, 19, ""),
    settlementMultiplier: jspb.Message.getFloatingPointFieldWithDefault(msg, 20, 0.0),
    priceIntegerSubpartValidCipher: jspb.Message.getFieldWithDefault(msg, 21, 0),
    priceDecimalSubpartValidCipher: jspb.Message.getFieldWithDefault(msg, 22, 0),
    closingPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
    closingPriceTypeCode: jspb.Message.getFieldWithDefault(msg, 24, ""),
    firstTradingDate: jspb.Message.getFieldWithDefault(msg, 25, ""),
    referencePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0),
    upperLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0),
    lowerLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
    marketMakingPossible: jspb.Message.getBooleanFieldWithDefault(msg, 29, false),
    halt: jspb.Message.getBooleanFieldWithDefault(msg, 30, false),
    liquidationTrading: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
    underlyingId: jspb.Message.getFieldWithDefault(msg, 32, ""),
    expirationMonth: jspb.Message.getFieldWithDefault(msg, 33, ""),
    lastTradingDate: jspb.Message.getFieldWithDefault(msg, 34, ""),
    expirationDate: jspb.Message.getFieldWithDefault(msg, 35, ""),
    finalSettlementDate: jspb.Message.getFieldWithDefault(msg, 36, ""),
    lastSettlementMethodCode: jspb.Message.getFieldWithDefault(msg, 37, ""),
    exerciseTypeCode: jspb.Message.getFieldWithDefault(msg, 38, ""),
    adjustmentTypeCode: jspb.Message.getFieldWithDefault(msg, 39, ""),
    underlyingSymbolCode: jspb.Message.getFieldWithDefault(msg, 40, ""),
    remainDays: jspb.Message.getFieldWithDefault(msg, 41, 0),
    settlementPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 42, 0.0),
    rightsTypeCode: jspb.Message.getFieldWithDefault(msg, 43, ""),
    atmTypeCode: jspb.Message.getFieldWithDefault(msg, 44, ""),
    exercisePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 45, 0.0),
    spreadCompositionCode: jspb.Message.getFieldWithDefault(msg, 46, ""),
    spreadCompositionCode1: jspb.Message.getFieldWithDefault(msg, 47, ""),
    spreadCompositionCode2: jspb.Message.getFieldWithDefault(msg, 48, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives}
 */
proto.proto.mdds.v1.InstrumentDerivatives.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.InstrumentDerivatives;
  return proto.proto.mdds.v1.InstrumentDerivatives.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.InstrumentDerivatives} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives}
 */
proto.proto.mdds.v1.InstrumentDerivatives.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityExchange(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductGroupId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolShortCode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityGroupId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingCurrencyId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTickerCode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolName(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolAbbreviation(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolEnglishName(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolEnglishAbbreviation(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setListingDate(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingCurrencyIsoCode(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSettlementMultiplier(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPriceIntegerSubpartValidCipher(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPriceDecimalSubpartValidCipher(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClosingPrice(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosingPriceTypeCode(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstTradingDate(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReferencePrice(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUpperLimitPrice(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowerLimitPrice(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarketMakingPossible(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHalt(value);
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLiquidationTrading(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingId(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpirationMonth(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastTradingDate(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setExpirationDate(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setFinalSettlementDate(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastSettlementMethodCode(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setExerciseTypeCode(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjustmentTypeCode(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingSymbolCode(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRemainDays(value);
      break;
    case 42:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSettlementPrice(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setRightsTypeCode(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setAtmTypeCode(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExercisePrice(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpreadCompositionCode(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpreadCompositionCode1(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.setSpreadCompositionCode2(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.InstrumentDerivatives.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.InstrumentDerivatives} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.InstrumentDerivatives.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBusinessDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSecurityExchange();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getProductGroupId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSymbolShortCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSecurityGroupId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTradingCurrencyId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTickerCode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getSymbolName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSymbolAbbreviation();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSymbolEnglishName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSymbolEnglishAbbreviation();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getListingDate();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getTradingCurrencyIsoCode();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getSettlementMultiplier();
  if (f !== 0.0) {
    writer.writeDouble(
      20,
      f
    );
  }
  f = message.getPriceIntegerSubpartValidCipher();
  if (f !== 0) {
    writer.writeUint32(
      21,
      f
    );
  }
  f = message.getPriceDecimalSubpartValidCipher();
  if (f !== 0) {
    writer.writeUint32(
      22,
      f
    );
  }
  f = message.getClosingPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getClosingPriceTypeCode();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getFirstTradingDate();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getReferencePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getUpperLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = message.getLowerLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      28,
      f
    );
  }
  f = message.getMarketMakingPossible();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
  f = message.getHalt();
  if (f) {
    writer.writeBool(
      30,
      f
    );
  }
  f = message.getLiquidationTrading();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = message.getUnderlyingId();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getExpirationMonth();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getLastTradingDate();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getExpirationDate();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getFinalSettlementDate();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getLastSettlementMethodCode();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getExerciseTypeCode();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getAdjustmentTypeCode();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getUnderlyingSymbolCode();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getRemainDays();
  if (f !== 0) {
    writer.writeUint32(
      41,
      f
    );
  }
  f = message.getSettlementPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      42,
      f
    );
  }
  f = message.getRightsTypeCode();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getAtmTypeCode();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getExercisePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      45,
      f
    );
  }
  f = message.getSpreadCompositionCode();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
  f = message.getSpreadCompositionCode1();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getSpreadCompositionCode2();
  if (f.length > 0) {
    writer.writeString(
      48,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string business_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getBusinessDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setBusinessDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string market_id = 4;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string board_id = 6;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string security_exchange = 7;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSecurityExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSecurityExchange = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string product_group_id = 8;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getProductGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setProductGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string symbol_short_code = 9;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSymbolShortCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSymbolShortCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string security_group_id = 10;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSecurityGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSecurityGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string trading_currency_id = 11;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getTradingCurrencyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setTradingCurrencyId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string product_id = 12;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string ticker_code = 13;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getTickerCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setTickerCode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string symbol_name = 14;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSymbolName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string symbol_abbreviation = 15;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSymbolAbbreviation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSymbolAbbreviation = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string symbol_english_name = 16;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSymbolEnglishName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSymbolEnglishName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string symbol_english_abbreviation = 17;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSymbolEnglishAbbreviation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSymbolEnglishAbbreviation = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string listing_date = 18;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getListingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setListingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string trading_currency_iso_code = 19;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getTradingCurrencyIsoCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setTradingCurrencyIsoCode = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional double settlement_multiplier = 20;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSettlementMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 20, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSettlementMultiplier = function(value) {
  return jspb.Message.setProto3FloatField(this, 20, value);
};


/**
 * optional uint32 price_integer_subpart_valid_cipher = 21;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getPriceIntegerSubpartValidCipher = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setPriceIntegerSubpartValidCipher = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional uint32 price_decimal_subpart_valid_cipher = 22;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getPriceDecimalSubpartValidCipher = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setPriceDecimalSubpartValidCipher = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional double closing_price = 23;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getClosingPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setClosingPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional string closing_price_type_code = 24;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getClosingPriceTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setClosingPriceTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string first_trading_date = 25;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getFirstTradingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setFirstTradingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional double reference_price = 26;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getReferencePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setReferencePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional double upper_limit_price = 27;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getUpperLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setUpperLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional double lower_limit_price = 28;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getLowerLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setLowerLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional bool market_making_possible = 29;
 * @return {boolean}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getMarketMakingPossible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setMarketMakingPossible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


/**
 * optional bool halt = 30;
 * @return {boolean}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getHalt = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 30, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setHalt = function(value) {
  return jspb.Message.setProto3BooleanField(this, 30, value);
};


/**
 * optional bool liquidation_trading = 31;
 * @return {boolean}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getLiquidationTrading = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setLiquidationTrading = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * optional string underlying_id = 32;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getUnderlyingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setUnderlyingId = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string expiration_month = 33;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getExpirationMonth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setExpirationMonth = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string last_trading_date = 34;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getLastTradingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setLastTradingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string expiration_date = 35;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getExpirationDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setExpirationDate = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string final_settlement_date = 36;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getFinalSettlementDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setFinalSettlementDate = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string last_settlement_method_code = 37;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getLastSettlementMethodCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setLastSettlementMethodCode = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string exercise_type_code = 38;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getExerciseTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setExerciseTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string adjustment_type_code = 39;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getAdjustmentTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setAdjustmentTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string underlying_symbol_code = 40;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getUnderlyingSymbolCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setUnderlyingSymbolCode = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional uint32 remain_days = 41;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getRemainDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setRemainDays = function(value) {
  return jspb.Message.setProto3IntField(this, 41, value);
};


/**
 * optional double settlement_price = 42;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSettlementPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 42, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSettlementPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 42, value);
};


/**
 * optional string rights_type_code = 43;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getRightsTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setRightsTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional string atm_type_code = 44;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getAtmTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setAtmTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional double exercise_price = 45;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getExercisePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 45, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setExercisePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 45, value);
};


/**
 * optional string spread_composition_code = 46;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSpreadCompositionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSpreadCompositionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 46, value);
};


/**
 * optional string spread_composition_code_1 = 47;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSpreadCompositionCode1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSpreadCompositionCode1 = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional string spread_composition_code_2 = 48;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.getSpreadCompositionCode2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentDerivatives} returns this
 */
proto.proto.mdds.v1.InstrumentDerivatives.prototype.setSpreadCompositionCode2 = function(value) {
  return jspb.Message.setProto3StringField(this, 48, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.InstrumentSBR.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.InstrumentSBR} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.InstrumentSBR.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    marketId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    securityExchange: jspb.Message.getFieldWithDefault(msg, 7, ""),
    productGroupId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    symbolShortCode: jspb.Message.getFieldWithDefault(msg, 9, ""),
    securityGroupId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    tradingCurrencyId: jspb.Message.getFieldWithDefault(msg, 11, ""),
    productId: jspb.Message.getFieldWithDefault(msg, 12, ""),
    tickerCode: jspb.Message.getFieldWithDefault(msg, 13, ""),
    symbolName: jspb.Message.getFieldWithDefault(msg, 14, ""),
    symbolAbbreviation: jspb.Message.getFieldWithDefault(msg, 15, ""),
    symbolEnglishName: jspb.Message.getFieldWithDefault(msg, 16, ""),
    symbolEnglishAbbreviation: jspb.Message.getFieldWithDefault(msg, 17, ""),
    listingDate: jspb.Message.getFieldWithDefault(msg, 18, ""),
    tradingCurrencyIsoCode: jspb.Message.getFieldWithDefault(msg, 19, ""),
    priceIntegerSubpartValidCipher: jspb.Message.getFieldWithDefault(msg, 20, 0),
    priceDecimalSubpartValidCipher: jspb.Message.getFieldWithDefault(msg, 21, 0),
    closingPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
    closingPriceTypeCode: jspb.Message.getFieldWithDefault(msg, 23, ""),
    firstTradingDate: jspb.Message.getFieldWithDefault(msg, 24, ""),
    vwap: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
    referencePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0),
    upperLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0),
    lowerLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
    marketMakingPossible: jspb.Message.getBooleanFieldWithDefault(msg, 29, false),
    halt: jspb.Message.getBooleanFieldWithDefault(msg, 30, false),
    liquidationTrading: jspb.Message.getBooleanFieldWithDefault(msg, 31, false),
    parValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 32, 0.0),
    issuedDate: jspb.Message.getFieldWithDefault(msg, 33, ""),
    listedShares: jspb.Message.getFieldWithDefault(msg, 34, 0),
    delistedDate: jspb.Message.getFieldWithDefault(msg, 35, ""),
    representativeSymbolCode: jspb.Message.getFieldWithDefault(msg, 36, ""),
    stockKindCode: jspb.Message.getFieldWithDefault(msg, 37, ""),
    priceChangeTypeCode: jspb.Message.getFieldWithDefault(msg, 38, ""),
    offTypeCode: jspb.Message.getFieldWithDefault(msg, 39, ""),
    targetStockSymbolCode: jspb.Message.getFieldWithDefault(msg, 40, ""),
    valuationPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 41, 0.0),
    lowestOrderPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 42, 0.0),
    highestOrderPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 43, 0.0),
    redemptionDate: jspb.Message.getFieldWithDefault(msg, 44, ""),
    bondClassificationCode: jspb.Message.getFieldWithDefault(msg, 45, ""),
    issuerId: jspb.Message.getFieldWithDefault(msg, 46, ""),
    sectorTypeCode: jspb.Message.getFieldWithDefault(msg, 47, ""),
    closingPriceYield: jspb.Message.getFloatingPointFieldWithDefault(msg, 48, 0.0),
    couponRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 49, 0.0),
    couponPaymentMethodCode: jspb.Message.getFieldWithDefault(msg, 50, ""),
    interestPaymentCalculationMonths: jspb.Message.getFieldWithDefault(msg, 51, 0),
    discountRateBond: jspb.Message.getBooleanFieldWithDefault(msg, 52, false),
    firstInterestPaymentDate: jspb.Message.getFieldWithDefault(msg, 53, ""),
    interestPaymentTypeCode: jspb.Message.getFieldWithDefault(msg, 54, ""),
    exInterestDate: jspb.Message.getFieldWithDefault(msg, 55, ""),
    accruedInterest: jspb.Message.getFloatingPointFieldWithDefault(msg, 56, 0.0),
    indexCalculationInstitutionCode: jspb.Message.getFieldWithDefault(msg, 57, ""),
    indexMarketClassificationId: jspb.Message.getFieldWithDefault(msg, 58, ""),
    indexSequence: jspb.Message.getFieldWithDefault(msg, 59, ""),
    indexLeverageInverseTypeCode: jspb.Message.getFieldWithDefault(msg, 60, ""),
    lastSettlementMethodCode: jspb.Message.getFieldWithDefault(msg, 61, ""),
    lastTradingDate: jspb.Message.getFieldWithDefault(msg, 62, ""),
    rightsTypeCode: jspb.Message.getFieldWithDefault(msg, 63, ""),
    exercisePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 64, 0.0),
    issuingMarketParticipantNumber: jspb.Message.getFieldWithDefault(msg, 65, ""),
    elwConversionRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 66, 0.0),
    elwPaymentAgentName: jspb.Message.getFieldWithDefault(msg, 67, ""),
    elwPaymentDate: jspb.Message.getFieldWithDefault(msg, 68, ""),
    subscriptionRightsDelistingDate: jspb.Message.getFieldWithDefault(msg, 69, ""),
    annualBaseDays: jspb.Message.getFieldWithDefault(msg, 70, 0),
    repoBaseSymbolCode: jspb.Message.getFieldWithDefault(msg, 71, ""),
    repoPeriod: jspb.Message.getFieldWithDefault(msg, 72, 0),
    repoRealPeriod: jspb.Message.getFieldWithDefault(msg, 73, 0),
    repoHaircutRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 74, 0.0),
    marketValuePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 75, 0.0),
    settlementDate: jspb.Message.getFieldWithDefault(msg, 76, ""),
    foreignBuySidePossibleQuantity: jspb.Message.getFieldWithDefault(msg, 77, 0),
    foreignerHoldingShares: jspb.Message.getFieldWithDefault(msg, 78, 0),
    foreignerOrderLimitQuantity: jspb.Message.getFieldWithDefault(msg, 79, 0),
    symbolAdministrativeStatusCode: jspb.Message.getFieldWithDefault(msg, 80, ""),
    symbolTradingMethodStatusCode: jspb.Message.getFieldWithDefault(msg, 81, ""),
    symbolTradingSanctionStatusCode: jspb.Message.getFieldWithDefault(msg, 82, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.InstrumentSBR}
 */
proto.proto.mdds.v1.InstrumentSBR.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.InstrumentSBR;
  return proto.proto.mdds.v1.InstrumentSBR.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.InstrumentSBR} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.InstrumentSBR}
 */
proto.proto.mdds.v1.InstrumentSBR.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityExchange(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductGroupId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolShortCode(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityGroupId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingCurrencyId(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTickerCode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolName(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolAbbreviation(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolEnglishName(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolEnglishAbbreviation(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setListingDate(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingCurrencyIsoCode(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPriceIntegerSubpartValidCipher(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPriceDecimalSubpartValidCipher(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClosingPrice(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setClosingPriceTypeCode(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstTradingDate(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVwap(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReferencePrice(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUpperLimitPrice(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowerLimitPrice(value);
      break;
    case 29:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarketMakingPossible(value);
      break;
    case 30:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHalt(value);
      break;
    case 31:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLiquidationTrading(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setParValue(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssuedDate(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setListedShares(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setDelistedDate(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepresentativeSymbolCode(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setStockKindCode(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setPriceChangeTypeCode(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setOffTypeCode(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetStockSymbolCode(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValuationPrice(value);
      break;
    case 42:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowestOrderPrice(value);
      break;
    case 43:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighestOrderPrice(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setRedemptionDate(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setBondClassificationCode(value);
      break;
    case 46:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssuerId(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setSectorTypeCode(value);
      break;
    case 48:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClosingPriceYield(value);
      break;
    case 49:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCouponRate(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setCouponPaymentMethodCode(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setInterestPaymentCalculationMonths(value);
      break;
    case 52:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDiscountRateBond(value);
      break;
    case 53:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstInterestPaymentDate(value);
      break;
    case 54:
      var value = /** @type {string} */ (reader.readString());
      msg.setInterestPaymentTypeCode(value);
      break;
    case 55:
      var value = /** @type {string} */ (reader.readString());
      msg.setExInterestDate(value);
      break;
    case 56:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAccruedInterest(value);
      break;
    case 57:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexCalculationInstitutionCode(value);
      break;
    case 58:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexMarketClassificationId(value);
      break;
    case 59:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexSequence(value);
      break;
    case 60:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexLeverageInverseTypeCode(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastSettlementMethodCode(value);
      break;
    case 62:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastTradingDate(value);
      break;
    case 63:
      var value = /** @type {string} */ (reader.readString());
      msg.setRightsTypeCode(value);
      break;
    case 64:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExercisePrice(value);
      break;
    case 65:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssuingMarketParticipantNumber(value);
      break;
    case 66:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setElwConversionRatio(value);
      break;
    case 67:
      var value = /** @type {string} */ (reader.readString());
      msg.setElwPaymentAgentName(value);
      break;
    case 68:
      var value = /** @type {string} */ (reader.readString());
      msg.setElwPaymentDate(value);
      break;
    case 69:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionRightsDelistingDate(value);
      break;
    case 70:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAnnualBaseDays(value);
      break;
    case 71:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepoBaseSymbolCode(value);
      break;
    case 72:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRepoPeriod(value);
      break;
    case 73:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRepoRealPeriod(value);
      break;
    case 74:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRepoHaircutRatio(value);
      break;
    case 75:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarketValuePrice(value);
      break;
    case 76:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlementDate(value);
      break;
    case 77:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setForeignBuySidePossibleQuantity(value);
      break;
    case 78:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setForeignerHoldingShares(value);
      break;
    case 79:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setForeignerOrderLimitQuantity(value);
      break;
    case 80:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolAdministrativeStatusCode(value);
      break;
    case 81:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolTradingMethodStatusCode(value);
      break;
    case 82:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolTradingSanctionStatusCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.InstrumentSBR.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.InstrumentSBR} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.InstrumentSBR.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBusinessDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSecurityExchange();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getProductGroupId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSymbolShortCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSecurityGroupId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTradingCurrencyId();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTickerCode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getSymbolName();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getSymbolAbbreviation();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getSymbolEnglishName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getSymbolEnglishAbbreviation();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getListingDate();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getTradingCurrencyIsoCode();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getPriceIntegerSubpartValidCipher();
  if (f !== 0) {
    writer.writeUint32(
      20,
      f
    );
  }
  f = message.getPriceDecimalSubpartValidCipher();
  if (f !== 0) {
    writer.writeUint32(
      21,
      f
    );
  }
  f = message.getClosingPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getClosingPriceTypeCode();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getFirstTradingDate();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getVwap();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = message.getReferencePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getUpperLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = message.getLowerLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      28,
      f
    );
  }
  f = message.getMarketMakingPossible();
  if (f) {
    writer.writeBool(
      29,
      f
    );
  }
  f = message.getHalt();
  if (f) {
    writer.writeBool(
      30,
      f
    );
  }
  f = message.getLiquidationTrading();
  if (f) {
    writer.writeBool(
      31,
      f
    );
  }
  f = message.getParValue();
  if (f !== 0.0) {
    writer.writeDouble(
      32,
      f
    );
  }
  f = message.getIssuedDate();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getListedShares();
  if (f !== 0) {
    writer.writeUint64(
      34,
      f
    );
  }
  f = message.getDelistedDate();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getRepresentativeSymbolCode();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getStockKindCode();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getPriceChangeTypeCode();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getOffTypeCode();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getTargetStockSymbolCode();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getValuationPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      41,
      f
    );
  }
  f = message.getLowestOrderPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      42,
      f
    );
  }
  f = message.getHighestOrderPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      43,
      f
    );
  }
  f = message.getRedemptionDate();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getBondClassificationCode();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getIssuerId();
  if (f.length > 0) {
    writer.writeString(
      46,
      f
    );
  }
  f = message.getSectorTypeCode();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getClosingPriceYield();
  if (f !== 0.0) {
    writer.writeDouble(
      48,
      f
    );
  }
  f = message.getCouponRate();
  if (f !== 0.0) {
    writer.writeDouble(
      49,
      f
    );
  }
  f = message.getCouponPaymentMethodCode();
  if (f.length > 0) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getInterestPaymentCalculationMonths();
  if (f !== 0) {
    writer.writeUint32(
      51,
      f
    );
  }
  f = message.getDiscountRateBond();
  if (f) {
    writer.writeBool(
      52,
      f
    );
  }
  f = message.getFirstInterestPaymentDate();
  if (f.length > 0) {
    writer.writeString(
      53,
      f
    );
  }
  f = message.getInterestPaymentTypeCode();
  if (f.length > 0) {
    writer.writeString(
      54,
      f
    );
  }
  f = message.getExInterestDate();
  if (f.length > 0) {
    writer.writeString(
      55,
      f
    );
  }
  f = message.getAccruedInterest();
  if (f !== 0.0) {
    writer.writeDouble(
      56,
      f
    );
  }
  f = message.getIndexCalculationInstitutionCode();
  if (f.length > 0) {
    writer.writeString(
      57,
      f
    );
  }
  f = message.getIndexMarketClassificationId();
  if (f.length > 0) {
    writer.writeString(
      58,
      f
    );
  }
  f = message.getIndexSequence();
  if (f.length > 0) {
    writer.writeString(
      59,
      f
    );
  }
  f = message.getIndexLeverageInverseTypeCode();
  if (f.length > 0) {
    writer.writeString(
      60,
      f
    );
  }
  f = message.getLastSettlementMethodCode();
  if (f.length > 0) {
    writer.writeString(
      61,
      f
    );
  }
  f = message.getLastTradingDate();
  if (f.length > 0) {
    writer.writeString(
      62,
      f
    );
  }
  f = message.getRightsTypeCode();
  if (f.length > 0) {
    writer.writeString(
      63,
      f
    );
  }
  f = message.getExercisePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      64,
      f
    );
  }
  f = message.getIssuingMarketParticipantNumber();
  if (f.length > 0) {
    writer.writeString(
      65,
      f
    );
  }
  f = message.getElwConversionRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      66,
      f
    );
  }
  f = message.getElwPaymentAgentName();
  if (f.length > 0) {
    writer.writeString(
      67,
      f
    );
  }
  f = message.getElwPaymentDate();
  if (f.length > 0) {
    writer.writeString(
      68,
      f
    );
  }
  f = message.getSubscriptionRightsDelistingDate();
  if (f.length > 0) {
    writer.writeString(
      69,
      f
    );
  }
  f = message.getAnnualBaseDays();
  if (f !== 0) {
    writer.writeUint32(
      70,
      f
    );
  }
  f = message.getRepoBaseSymbolCode();
  if (f.length > 0) {
    writer.writeString(
      71,
      f
    );
  }
  f = message.getRepoPeriod();
  if (f !== 0) {
    writer.writeUint32(
      72,
      f
    );
  }
  f = message.getRepoRealPeriod();
  if (f !== 0) {
    writer.writeUint32(
      73,
      f
    );
  }
  f = message.getRepoHaircutRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      74,
      f
    );
  }
  f = message.getMarketValuePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      75,
      f
    );
  }
  f = message.getSettlementDate();
  if (f.length > 0) {
    writer.writeString(
      76,
      f
    );
  }
  f = message.getForeignBuySidePossibleQuantity();
  if (f !== 0) {
    writer.writeUint64(
      77,
      f
    );
  }
  f = message.getForeignerHoldingShares();
  if (f !== 0) {
    writer.writeUint64(
      78,
      f
    );
  }
  f = message.getForeignerOrderLimitQuantity();
  if (f !== 0) {
    writer.writeUint64(
      79,
      f
    );
  }
  f = message.getSymbolAdministrativeStatusCode();
  if (f.length > 0) {
    writer.writeString(
      80,
      f
    );
  }
  f = message.getSymbolTradingMethodStatusCode();
  if (f.length > 0) {
    writer.writeString(
      81,
      f
    );
  }
  f = message.getSymbolTradingSanctionStatusCode();
  if (f.length > 0) {
    writer.writeString(
      82,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string business_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getBusinessDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setBusinessDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string market_id = 4;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string board_id = 6;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string security_exchange = 7;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSecurityExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSecurityExchange = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string product_group_id = 8;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getProductGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setProductGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string symbol_short_code = 9;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSymbolShortCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSymbolShortCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string security_group_id = 10;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSecurityGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSecurityGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string trading_currency_id = 11;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getTradingCurrencyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setTradingCurrencyId = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string product_id = 12;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string ticker_code = 13;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getTickerCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setTickerCode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string symbol_name = 14;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSymbolName = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string symbol_abbreviation = 15;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSymbolAbbreviation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSymbolAbbreviation = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string symbol_english_name = 16;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSymbolEnglishName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSymbolEnglishName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string symbol_english_abbreviation = 17;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSymbolEnglishAbbreviation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSymbolEnglishAbbreviation = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string listing_date = 18;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getListingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setListingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string trading_currency_iso_code = 19;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getTradingCurrencyIsoCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setTradingCurrencyIsoCode = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional uint32 price_integer_subpart_valid_cipher = 20;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getPriceIntegerSubpartValidCipher = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setPriceIntegerSubpartValidCipher = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional uint32 price_decimal_subpart_valid_cipher = 21;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getPriceDecimalSubpartValidCipher = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setPriceDecimalSubpartValidCipher = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional double closing_price = 22;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getClosingPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setClosingPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional string closing_price_type_code = 23;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getClosingPriceTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setClosingPriceTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string first_trading_date = 24;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getFirstTradingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setFirstTradingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional double vwap = 25;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getVwap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setVwap = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional double reference_price = 26;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getReferencePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setReferencePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional double upper_limit_price = 27;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getUpperLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setUpperLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional double lower_limit_price = 28;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getLowerLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setLowerLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional bool market_making_possible = 29;
 * @return {boolean}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getMarketMakingPossible = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 29, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setMarketMakingPossible = function(value) {
  return jspb.Message.setProto3BooleanField(this, 29, value);
};


/**
 * optional bool halt = 30;
 * @return {boolean}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getHalt = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 30, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setHalt = function(value) {
  return jspb.Message.setProto3BooleanField(this, 30, value);
};


/**
 * optional bool liquidation_trading = 31;
 * @return {boolean}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getLiquidationTrading = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 31, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setLiquidationTrading = function(value) {
  return jspb.Message.setProto3BooleanField(this, 31, value);
};


/**
 * optional double par_value = 32;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getParValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setParValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 32, value);
};


/**
 * optional string issued_date = 33;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getIssuedDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setIssuedDate = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional uint64 listed_shares = 34;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getListedShares = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setListedShares = function(value) {
  return jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional string delisted_date = 35;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getDelistedDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setDelistedDate = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string representative_symbol_code = 36;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getRepresentativeSymbolCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setRepresentativeSymbolCode = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional string stock_kind_code = 37;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getStockKindCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setStockKindCode = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string price_change_type_code = 38;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getPriceChangeTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setPriceChangeTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string off_type_code = 39;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getOffTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setOffTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string target_stock_symbol_code = 40;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getTargetStockSymbolCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setTargetStockSymbolCode = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional double valuation_price = 41;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getValuationPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 41, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setValuationPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 41, value);
};


/**
 * optional double lowest_order_price = 42;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getLowestOrderPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 42, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setLowestOrderPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 42, value);
};


/**
 * optional double highest_order_price = 43;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getHighestOrderPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 43, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setHighestOrderPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 43, value);
};


/**
 * optional string redemption_date = 44;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getRedemptionDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setRedemptionDate = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional string bond_classification_code = 45;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getBondClassificationCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setBondClassificationCode = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional string issuer_id = 46;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getIssuerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 46, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setIssuerId = function(value) {
  return jspb.Message.setProto3StringField(this, 46, value);
};


/**
 * optional string sector_type_code = 47;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSectorTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSectorTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional double closing_price_yield = 48;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getClosingPriceYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 48, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setClosingPriceYield = function(value) {
  return jspb.Message.setProto3FloatField(this, 48, value);
};


/**
 * optional double coupon_rate = 49;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getCouponRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 49, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setCouponRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 49, value);
};


/**
 * optional string coupon_payment_method_code = 50;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getCouponPaymentMethodCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setCouponPaymentMethodCode = function(value) {
  return jspb.Message.setProto3StringField(this, 50, value);
};


/**
 * optional uint32 interest_payment_calculation_months = 51;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getInterestPaymentCalculationMonths = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setInterestPaymentCalculationMonths = function(value) {
  return jspb.Message.setProto3IntField(this, 51, value);
};


/**
 * optional bool discount_rate_bond = 52;
 * @return {boolean}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getDiscountRateBond = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 52, false));
};


/**
 * @param {boolean} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setDiscountRateBond = function(value) {
  return jspb.Message.setProto3BooleanField(this, 52, value);
};


/**
 * optional string first_interest_payment_date = 53;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getFirstInterestPaymentDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 53, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setFirstInterestPaymentDate = function(value) {
  return jspb.Message.setProto3StringField(this, 53, value);
};


/**
 * optional string interest_payment_type_code = 54;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getInterestPaymentTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 54, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setInterestPaymentTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 54, value);
};


/**
 * optional string ex_interest_date = 55;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getExInterestDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 55, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setExInterestDate = function(value) {
  return jspb.Message.setProto3StringField(this, 55, value);
};


/**
 * optional double accrued_interest = 56;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getAccruedInterest = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 56, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setAccruedInterest = function(value) {
  return jspb.Message.setProto3FloatField(this, 56, value);
};


/**
 * optional string index_calculation_institution_code = 57;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getIndexCalculationInstitutionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 57, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setIndexCalculationInstitutionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 57, value);
};


/**
 * optional string index_market_classification_id = 58;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getIndexMarketClassificationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 58, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setIndexMarketClassificationId = function(value) {
  return jspb.Message.setProto3StringField(this, 58, value);
};


/**
 * optional string index_sequence = 59;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getIndexSequence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 59, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setIndexSequence = function(value) {
  return jspb.Message.setProto3StringField(this, 59, value);
};


/**
 * optional string index_leverage_inverse_type_code = 60;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getIndexLeverageInverseTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 60, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setIndexLeverageInverseTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 60, value);
};


/**
 * optional string last_settlement_method_code = 61;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getLastSettlementMethodCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setLastSettlementMethodCode = function(value) {
  return jspb.Message.setProto3StringField(this, 61, value);
};


/**
 * optional string last_trading_date = 62;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getLastTradingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 62, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setLastTradingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 62, value);
};


/**
 * optional string rights_type_code = 63;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getRightsTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 63, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setRightsTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 63, value);
};


/**
 * optional double exercise_price = 64;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getExercisePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 64, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setExercisePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 64, value);
};


/**
 * optional string issuing_market_participant_number = 65;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getIssuingMarketParticipantNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 65, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setIssuingMarketParticipantNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 65, value);
};


/**
 * optional double elw_conversion_ratio = 66;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getElwConversionRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 66, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setElwConversionRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 66, value);
};


/**
 * optional string elw_payment_agent_name = 67;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getElwPaymentAgentName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 67, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setElwPaymentAgentName = function(value) {
  return jspb.Message.setProto3StringField(this, 67, value);
};


/**
 * optional string elw_payment_date = 68;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getElwPaymentDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 68, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setElwPaymentDate = function(value) {
  return jspb.Message.setProto3StringField(this, 68, value);
};


/**
 * optional string subscription_rights_delisting_date = 69;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSubscriptionRightsDelistingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 69, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSubscriptionRightsDelistingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 69, value);
};


/**
 * optional uint32 annual_base_days = 70;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getAnnualBaseDays = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 70, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setAnnualBaseDays = function(value) {
  return jspb.Message.setProto3IntField(this, 70, value);
};


/**
 * optional string repo_base_symbol_code = 71;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getRepoBaseSymbolCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 71, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setRepoBaseSymbolCode = function(value) {
  return jspb.Message.setProto3StringField(this, 71, value);
};


/**
 * optional uint32 repo_period = 72;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getRepoPeriod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 72, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setRepoPeriod = function(value) {
  return jspb.Message.setProto3IntField(this, 72, value);
};


/**
 * optional uint32 repo_real_period = 73;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getRepoRealPeriod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 73, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setRepoRealPeriod = function(value) {
  return jspb.Message.setProto3IntField(this, 73, value);
};


/**
 * optional double repo_haircut_ratio = 74;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getRepoHaircutRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 74, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setRepoHaircutRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 74, value);
};


/**
 * optional double market_value_price = 75;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getMarketValuePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 75, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setMarketValuePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 75, value);
};


/**
 * optional string settlement_date = 76;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSettlementDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 76, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSettlementDate = function(value) {
  return jspb.Message.setProto3StringField(this, 76, value);
};


/**
 * optional uint64 foreign_buy_side_possible_quantity = 77;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getForeignBuySidePossibleQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 77, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setForeignBuySidePossibleQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 77, value);
};


/**
 * optional uint64 foreigner_holding_shares = 78;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getForeignerHoldingShares = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 78, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setForeignerHoldingShares = function(value) {
  return jspb.Message.setProto3IntField(this, 78, value);
};


/**
 * optional uint64 foreigner_order_limit_quantity = 79;
 * @return {number}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getForeignerOrderLimitQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 79, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setForeignerOrderLimitQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 79, value);
};


/**
 * optional string symbol_administrative_status_code = 80;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSymbolAdministrativeStatusCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 80, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSymbolAdministrativeStatusCode = function(value) {
  return jspb.Message.setProto3StringField(this, 80, value);
};


/**
 * optional string symbol_trading_method_status_code = 81;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSymbolTradingMethodStatusCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 81, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSymbolTradingMethodStatusCode = function(value) {
  return jspb.Message.setProto3StringField(this, 81, value);
};


/**
 * optional string symbol_trading_sanction_status_code = 82;
 * @return {string}
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.getSymbolTradingSanctionStatusCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 82, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.InstrumentSBR} returns this
 */
proto.proto.mdds.v1.InstrumentSBR.prototype.setSymbolTradingSanctionStatusCode = function(value) {
  return jspb.Message.setProto3StringField(this, 82, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.TradingSchedule.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.TradingSchedule.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.TradingSchedule} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TradingSchedule.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    marketId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    productGroupId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    boardId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    boardEventId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    boardEventStartTime: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.TradingSchedule}
 */
proto.proto.mdds.v1.TradingSchedule.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.TradingSchedule;
  return proto.proto.mdds.v1.TradingSchedule.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.TradingSchedule} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.TradingSchedule}
 */
proto.proto.mdds.v1.TradingSchedule.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductGroupId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardEventId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBoardEventStartTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.TradingSchedule.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.TradingSchedule.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.TradingSchedule} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TradingSchedule.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBusinessDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getProductGroupId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBoardId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBoardEventId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBoardEventStartTime();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.TradingSchedule.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingSchedule} returns this
 */
proto.proto.mdds.v1.TradingSchedule.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.TradingSchedule.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TradingSchedule} returns this
 */
proto.proto.mdds.v1.TradingSchedule.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string business_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.TradingSchedule.prototype.getBusinessDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingSchedule} returns this
 */
proto.proto.mdds.v1.TradingSchedule.prototype.setBusinessDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string market_id = 4;
 * @return {string}
 */
proto.proto.mdds.v1.TradingSchedule.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingSchedule} returns this
 */
proto.proto.mdds.v1.TradingSchedule.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string product_group_id = 5;
 * @return {string}
 */
proto.proto.mdds.v1.TradingSchedule.prototype.getProductGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingSchedule} returns this
 */
proto.proto.mdds.v1.TradingSchedule.prototype.setProductGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string board_id = 6;
 * @return {string}
 */
proto.proto.mdds.v1.TradingSchedule.prototype.getBoardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingSchedule} returns this
 */
proto.proto.mdds.v1.TradingSchedule.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string board_event_id = 7;
 * @return {string}
 */
proto.proto.mdds.v1.TradingSchedule.prototype.getBoardEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingSchedule} returns this
 */
proto.proto.mdds.v1.TradingSchedule.prototype.setBoardEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string board_event_start_time = 8;
 * @return {string}
 */
proto.proto.mdds.v1.TradingSchedule.prototype.getBoardEventStartTime = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TradingSchedule} returns this
 */
proto.proto.mdds.v1.TradingSchedule.prototype.setBoardEventStartTime = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.Holiday.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.Holiday.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.Holiday} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Holiday.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    businessCalendarDayId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    holidayDate: jspb.Message.getFieldWithDefault(msg, 5, ""),
    holidayName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    holidayTypeCode: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.Holiday}
 */
proto.proto.mdds.v1.Holiday.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.Holiday;
  return proto.proto.mdds.v1.Holiday.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.Holiday} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.Holiday}
 */
proto.proto.mdds.v1.Holiday.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessCalendarDayId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolidayDate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolidayName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setHolidayTypeCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.Holiday.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.Holiday.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.Holiday} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Holiday.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBusinessDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBusinessCalendarDayId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getHolidayDate();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getHolidayName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getHolidayTypeCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.Holiday.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Holiday} returns this
 */
proto.proto.mdds.v1.Holiday.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.Holiday.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Holiday} returns this
 */
proto.proto.mdds.v1.Holiday.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string business_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.Holiday.prototype.getBusinessDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Holiday} returns this
 */
proto.proto.mdds.v1.Holiday.prototype.setBusinessDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string business_calendar_day_id = 4;
 * @return {string}
 */
proto.proto.mdds.v1.Holiday.prototype.getBusinessCalendarDayId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Holiday} returns this
 */
proto.proto.mdds.v1.Holiday.prototype.setBusinessCalendarDayId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string holiday_date = 5;
 * @return {string}
 */
proto.proto.mdds.v1.Holiday.prototype.getHolidayDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Holiday} returns this
 */
proto.proto.mdds.v1.Holiday.prototype.setHolidayDate = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string holiday_name = 6;
 * @return {string}
 */
proto.proto.mdds.v1.Holiday.prototype.getHolidayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Holiday} returns this
 */
proto.proto.mdds.v1.Holiday.prototype.setHolidayName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string holiday_type_code = 7;
 * @return {string}
 */
proto.proto.mdds.v1.Holiday.prototype.getHolidayTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Holiday} returns this
 */
proto.proto.mdds.v1.Holiday.prototype.setHolidayTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.MemberTrader.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.MemberTrader.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.MemberTrader} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MemberTrader.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    memberId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    traderNumber: jspb.Message.getFieldWithDefault(msg, 5, ""),
    traderName: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.MemberTrader}
 */
proto.proto.mdds.v1.MemberTrader.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.MemberTrader;
  return proto.proto.mdds.v1.MemberTrader.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.MemberTrader} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.MemberTrader}
 */
proto.proto.mdds.v1.MemberTrader.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTraderNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setTraderName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.MemberTrader.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.MemberTrader.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.MemberTrader} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MemberTrader.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBusinessDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMemberId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTraderNumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTraderName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.MemberTrader.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MemberTrader} returns this
 */
proto.proto.mdds.v1.MemberTrader.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.MemberTrader.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MemberTrader} returns this
 */
proto.proto.mdds.v1.MemberTrader.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string business_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.MemberTrader.prototype.getBusinessDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MemberTrader} returns this
 */
proto.proto.mdds.v1.MemberTrader.prototype.setBusinessDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string member_id = 4;
 * @return {string}
 */
proto.proto.mdds.v1.MemberTrader.prototype.getMemberId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MemberTrader} returns this
 */
proto.proto.mdds.v1.MemberTrader.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string trader_number = 5;
 * @return {string}
 */
proto.proto.mdds.v1.MemberTrader.prototype.getTraderNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MemberTrader} returns this
 */
proto.proto.mdds.v1.MemberTrader.prototype.setTraderNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string trader_name = 6;
 * @return {string}
 */
proto.proto.mdds.v1.MemberTrader.prototype.getTraderName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MemberTrader} returns this
 */
proto.proto.mdds.v1.MemberTrader.prototype.setTraderName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.MarketMakingContract.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.MarketMakingContract} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MarketMakingContract.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    marketId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    marketMakingContractCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    memberId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    marketMakingStartingDate: jspb.Message.getFieldWithDefault(msg, 7, ""),
    marketMakingEndingDate: jspb.Message.getFieldWithDefault(msg, 8, ""),
    marketMakingPermissionDirectionCode: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.MarketMakingContract}
 */
proto.proto.mdds.v1.MarketMakingContract.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.MarketMakingContract;
  return proto.proto.mdds.v1.MarketMakingContract.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.MarketMakingContract} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.MarketMakingContract}
 */
proto.proto.mdds.v1.MarketMakingContract.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketMakingContractCode(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMemberId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketMakingStartingDate(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketMakingEndingDate(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketMakingPermissionDirectionCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.MarketMakingContract.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.MarketMakingContract} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MarketMakingContract.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBusinessDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMarketMakingContractCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMemberId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMarketMakingStartingDate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getMarketMakingEndingDate();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getMarketMakingPermissionDirectionCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakingContract} returns this
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketMakingContract} returns this
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string business_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.getBusinessDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakingContract} returns this
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.setBusinessDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string market_id = 4;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakingContract} returns this
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string market_making_contract_code = 5;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.getMarketMakingContractCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakingContract} returns this
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.setMarketMakingContractCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string member_id = 6;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.getMemberId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakingContract} returns this
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.setMemberId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string market_making_starting_date = 7;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.getMarketMakingStartingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakingContract} returns this
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.setMarketMakingStartingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string market_making_ending_date = 8;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.getMarketMakingEndingDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakingContract} returns this
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.setMarketMakingEndingDate = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string market_making_permission_direction_code = 9;
 * @return {string}
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.getMarketMakingPermissionDirectionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketMakingContract} returns this
 */
proto.proto.mdds.v1.MarketMakingContract.prototype.setMarketMakingPermissionDirectionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.ETFIndexComposition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.ETFIndexComposition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ETFIndexComposition.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    indexCalculationInstitutionCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    indexMarketClassificationId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    indexSequence: jspb.Message.getFieldWithDefault(msg, 6, ""),
    indexLeverageInverseTypeCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    indexName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    indexEnglishName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    indexAssetClassificationId1: jspb.Message.getFieldWithDefault(msg, 10, ""),
    indexAssetClassificationId2: jspb.Message.getFieldWithDefault(msg, 11, ""),
    marketIndexClass: jspb.Message.getFieldWithDefault(msg, 12, ""),
    indexTypeCode: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.ETFIndexComposition}
 */
proto.proto.mdds.v1.ETFIndexComposition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.ETFIndexComposition;
  return proto.proto.mdds.v1.ETFIndexComposition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.ETFIndexComposition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.ETFIndexComposition}
 */
proto.proto.mdds.v1.ETFIndexComposition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexCalculationInstitutionCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexMarketClassificationId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexSequence(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexLeverageInverseTypeCode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexEnglishName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexAssetClassificationId1(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexAssetClassificationId2(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketIndexClass(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexTypeCode(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.ETFIndexComposition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.ETFIndexComposition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ETFIndexComposition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBusinessDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIndexCalculationInstitutionCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIndexMarketClassificationId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIndexSequence();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIndexLeverageInverseTypeCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getIndexName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getIndexEnglishName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getIndexAssetClassificationId1();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getIndexAssetClassificationId2();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getMarketIndexClass();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getIndexTypeCode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string business_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getBusinessDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setBusinessDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string index_calculation_institution_code = 4;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getIndexCalculationInstitutionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setIndexCalculationInstitutionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string index_market_classification_id = 5;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getIndexMarketClassificationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setIndexMarketClassificationId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string index_sequence = 6;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getIndexSequence = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setIndexSequence = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string index_leverage_inverse_type_code = 7;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getIndexLeverageInverseTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setIndexLeverageInverseTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string index_name = 8;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getIndexName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setIndexName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string index_english_name = 9;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getIndexEnglishName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setIndexEnglishName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string index_asset_classification_id_1 = 10;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getIndexAssetClassificationId1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setIndexAssetClassificationId1 = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string index_asset_classification_id_2 = 11;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getIndexAssetClassificationId2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setIndexAssetClassificationId2 = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string market_index_class = 12;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getMarketIndexClass = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setMarketIndexClass = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string index_type_code = 13;
 * @return {string}
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.getIndexTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ETFIndexComposition} returns this
 */
proto.proto.mdds.v1.ETFIndexComposition.prototype.setIndexTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.ELWUnderlyingAssets.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.ELWUnderlyingAssets} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sequenceNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
    businessDate: jspb.Message.getFieldWithDefault(msg, 3, ""),
    marketId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 5, ""),
    marketIndexClass: jspb.Message.getFieldWithDefault(msg, 6, ""),
    industryIndexCode: jspb.Message.getFieldWithDefault(msg, 7, ""),
    compositionSymbolMarketId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    compositionSymbolCode: jspb.Message.getFieldWithDefault(msg, 9, ""),
    underlyingAssetCompositionRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.ELWUnderlyingAssets;
  return proto.proto.mdds.v1.ELWUnderlyingAssets.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.ELWUnderlyingAssets} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTransactionCode(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSequenceNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBusinessDate(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketIndexClass(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndustryIndexCode(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompositionSymbolMarketId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompositionSymbolCode(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUnderlyingAssetCompositionRatio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.ELWUnderlyingAssets.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.ELWUnderlyingAssets} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSequenceNumber();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getBusinessDate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMarketIndexClass();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getIndustryIndexCode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCompositionSymbolMarketId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCompositionSymbolCode();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getUnderlyingAssetCompositionRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
};


/**
 * optional string transaction_code = 1;
 * @return {string}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.getTransactionCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets} returns this
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.setTransactionCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional uint64 sequence_number = 2;
 * @return {number}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.getSequenceNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets} returns this
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.setSequenceNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string business_date = 3;
 * @return {string}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.getBusinessDate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets} returns this
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.setBusinessDate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string market_id = 4;
 * @return {string}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets} returns this
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string symbol = 5;
 * @return {string}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets} returns this
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string market_index_class = 6;
 * @return {string}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.getMarketIndexClass = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets} returns this
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.setMarketIndexClass = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string industry_index_code = 7;
 * @return {string}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.getIndustryIndexCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets} returns this
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.setIndustryIndexCode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string composition_symbol_market_id = 8;
 * @return {string}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.getCompositionSymbolMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets} returns this
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.setCompositionSymbolMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string composition_symbol_code = 9;
 * @return {string}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.getCompositionSymbolCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets} returns this
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.setCompositionSymbolCode = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional double underlying_asset_composition_ratio = 10;
 * @return {number}
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.getUnderlyingAssetCompositionRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ELWUnderlyingAssets} returns this
 */
proto.proto.mdds.v1.ELWUnderlyingAssets.prototype.setUnderlyingAssetCompositionRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.mdds.v1.ListSectorVolatility.repeatedFields_ = [1,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.ListSectorVolatility.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.ListSectorVolatility} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ListSectorVolatility.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.proto.mdds.v1.SectorVolatility.toObject, includeInstance),
    time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    priceVolatilityKeyList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    priceVolatilityValueList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 4)) == null ? undefined : f,
    matchPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    volume: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    marketCap: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    totalStocks: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.ListSectorVolatility}
 */
proto.proto.mdds.v1.ListSectorVolatility.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.ListSectorVolatility;
  return proto.proto.mdds.v1.ListSectorVolatility.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.ListSectorVolatility} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.ListSectorVolatility}
 */
proto.proto.mdds.v1.ListSectorVolatility.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.mdds.v1.SectorVolatility;
      reader.readMessage(value,proto.proto.mdds.v1.SectorVolatility.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addPriceVolatilityKey(value);
      break;
    case 4:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPriceVolatilityValue(values[i]);
      }
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVolume(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarketCap(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalStocks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.ListSectorVolatility.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.ListSectorVolatility} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ListSectorVolatility.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.mdds.v1.SectorVolatility.serializeBinaryToWriter
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPriceVolatilityKeyList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getPriceVolatilityValueList();
  if (f.length > 0) {
    writer.writePackedDouble(
      4,
      f
    );
  }
  f = message.getMatchPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getVolume();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getMarketCap();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getTotalStocks();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
};


/**
 * repeated SectorVolatility data = 1;
 * @return {!Array<!proto.proto.mdds.v1.SectorVolatility>}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.getDataList = function() {
  return /** @type{!Array<!proto.proto.mdds.v1.SectorVolatility>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.mdds.v1.SectorVolatility, 1));
};


/**
 * @param {!Array<!proto.proto.mdds.v1.SectorVolatility>} value
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
*/
proto.proto.mdds.v1.ListSectorVolatility.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.mdds.v1.SectorVolatility=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.SectorVolatility}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.mdds.v1.SectorVolatility, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional google.protobuf.Timestamp time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
*/
proto.proto.mdds.v1.ListSectorVolatility.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.hasTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string price_volatility_key = 3;
 * @return {!Array<string>}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.getPriceVolatilityKeyList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.setPriceVolatilityKeyList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.addPriceVolatilityKey = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.clearPriceVolatilityKeyList = function() {
  return this.setPriceVolatilityKeyList([]);
};


/**
 * repeated double price_volatility_value = 4;
 * @return {!Array<number>}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.getPriceVolatilityValueList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.setPriceVolatilityValueList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.addPriceVolatilityValue = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.clearPriceVolatilityValueList = function() {
  return this.setPriceVolatilityValueList([]);
};


/**
 * optional double match_price = 5;
 * @return {number}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.getMatchPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.setMatchPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double volume = 6;
 * @return {number}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.getVolume = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.setVolume = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double market_cap = 7;
 * @return {number}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.getMarketCap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.setMarketCap = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional int32 total_stocks = 8;
 * @return {number}
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.getTotalStocks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.ListSectorVolatility} returns this
 */
proto.proto.mdds.v1.ListSectorVolatility.prototype.setTotalStocks = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.mdds.v1.SectorVolatility.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.SectorVolatility.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.SectorVolatility} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SectorVolatility.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    slug: jspb.Message.getFieldWithDefault(msg, 2, ""),
    name: jspb.Message.getFieldWithDefault(msg, 3, ""),
    priceVolatilityKeyList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    priceVolatilityValueList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 5)) == null ? undefined : f,
    matchPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    volume: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    marketCap: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    totalStocks: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.SectorVolatility}
 */
proto.proto.mdds.v1.SectorVolatility.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.SectorVolatility;
  return proto.proto.mdds.v1.SectorVolatility.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.SectorVolatility} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.SectorVolatility}
 */
proto.proto.mdds.v1.SectorVolatility.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addPriceVolatilityKey(value);
      break;
    case 5:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedDouble() : [reader.readDouble()]);
      for (var i = 0; i < values.length; i++) {
        msg.addPriceVolatilityValue(values[i]);
      }
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVolume(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarketCap(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalStocks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.SectorVolatility.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.SectorVolatility} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SectorVolatility.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPriceVolatilityKeyList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getPriceVolatilityValueList();
  if (f.length > 0) {
    writer.writePackedDouble(
      5,
      f
    );
  }
  f = message.getMatchPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getVolume();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getMarketCap();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getTotalStocks();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slug = 2;
 * @return {string}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * repeated string price_volatility_key = 4;
 * @return {!Array<string>}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.getPriceVolatilityKeyList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.setPriceVolatilityKeyList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.addPriceVolatilityKey = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.clearPriceVolatilityKeyList = function() {
  return this.setPriceVolatilityKeyList([]);
};


/**
 * repeated double price_volatility_value = 5;
 * @return {!Array<number>}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.getPriceVolatilityValueList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 5));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.setPriceVolatilityValueList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.addPriceVolatilityValue = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.clearPriceVolatilityValueList = function() {
  return this.setPriceVolatilityValueList([]);
};


/**
 * optional double match_price = 6;
 * @return {number}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.getMatchPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.setMatchPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double volume = 7;
 * @return {number}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.getVolume = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.setVolume = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double market_cap = 8;
 * @return {number}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.getMarketCap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.setMarketCap = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional int32 total_stocks = 9;
 * @return {number}
 */
proto.proto.mdds.v1.SectorVolatility.prototype.getTotalStocks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.SectorVolatility} returns this
 */
proto.proto.mdds.v1.SectorVolatility.prototype.setTotalStocks = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.mdds.v1.ListStockVolatility.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.ListStockVolatility.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.ListStockVolatility.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.ListStockVolatility} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ListStockVolatility.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.proto.mdds.v1.StockVolatility.toObject, includeInstance),
    time: (f = msg.getTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.ListStockVolatility}
 */
proto.proto.mdds.v1.ListStockVolatility.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.ListStockVolatility;
  return proto.proto.mdds.v1.ListStockVolatility.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.ListStockVolatility} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.ListStockVolatility}
 */
proto.proto.mdds.v1.ListStockVolatility.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.mdds.v1.StockVolatility;
      reader.readMessage(value,proto.proto.mdds.v1.StockVolatility.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.ListStockVolatility.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.ListStockVolatility.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.ListStockVolatility} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.ListStockVolatility.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.proto.mdds.v1.StockVolatility.serializeBinaryToWriter
    );
  }
  f = message.getTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated StockVolatility data = 1;
 * @return {!Array<!proto.proto.mdds.v1.StockVolatility>}
 */
proto.proto.mdds.v1.ListStockVolatility.prototype.getDataList = function() {
  return /** @type{!Array<!proto.proto.mdds.v1.StockVolatility>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.mdds.v1.StockVolatility, 1));
};


/**
 * @param {!Array<!proto.proto.mdds.v1.StockVolatility>} value
 * @return {!proto.proto.mdds.v1.ListStockVolatility} returns this
*/
proto.proto.mdds.v1.ListStockVolatility.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.proto.mdds.v1.StockVolatility=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.StockVolatility}
 */
proto.proto.mdds.v1.ListStockVolatility.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.proto.mdds.v1.StockVolatility, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.ListStockVolatility} returns this
 */
proto.proto.mdds.v1.ListStockVolatility.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional google.protobuf.Timestamp time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.ListStockVolatility.prototype.getTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.ListStockVolatility} returns this
*/
proto.proto.mdds.v1.ListStockVolatility.prototype.setTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.ListStockVolatility} returns this
 */
proto.proto.mdds.v1.ListStockVolatility.prototype.clearTime = function() {
  return this.setTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.ListStockVolatility.prototype.hasTime = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.StockVolatility.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.StockVolatility.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.StockVolatility} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.StockVolatility.toObject = function(includeInstance, msg) {
  var f, obj = {
    symbol: jspb.Message.getFieldWithDefault(msg, 1, ""),
    priceChangePrevSession: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    matchPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    volume: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    marketCap: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    highLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    referencePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    lowLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    changed: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    closePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    expectedTradePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    symbolMatchPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.StockVolatility}
 */
proto.proto.mdds.v1.StockVolatility.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.StockVolatility;
  return proto.proto.mdds.v1.StockVolatility.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.StockVolatility} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.StockVolatility}
 */
proto.proto.mdds.v1.StockVolatility.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriceChangePrevSession(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchPrice(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVolume(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMarketCap(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighLimitPrice(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReferencePrice(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowLimitPrice(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChanged(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClosePrice(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExpectedTradePrice(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSymbolMatchPrice(value);
      break;
    case 13:
      var value = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.StockVolatility.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.StockVolatility.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.StockVolatility} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.StockVolatility.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPriceChangePrevSession();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getMatchPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getVolume();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMarketCap();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getHighLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getReferencePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getLowLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getChanged();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getClosePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getExpectedTradePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getSymbolMatchPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
};


/**
 * optional string symbol = 1;
 * @return {string}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional double price_change_prev_session = 2;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getPriceChangePrevSession = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setPriceChangePrevSession = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double match_price = 3;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getMatchPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setMatchPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double volume = 4;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getVolume = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setVolume = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double market_cap = 5;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getMarketCap = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setMarketCap = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double high_limit_price = 6;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getHighLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setHighLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double reference_price = 7;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getReferencePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setReferencePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double low_limit_price = 8;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getLowLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setLowLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double changed = 9;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getChanged = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setChanged = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double close_price = 10;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getClosePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setClosePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double expected_trade_price = 11;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getExpectedTradePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setExpectedTradePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double symbol_match_price = 12;
 * @return {number}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getSymbolMatchPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setSymbolMatchPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional TradingSessionID trading_session_id = 13;
 * @return {!proto.proto.mdds.v1.TradingSessionID}
 */
proto.proto.mdds.v1.StockVolatility.prototype.getTradingSessionId = function() {
  return /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TradingSessionID} value
 * @return {!proto.proto.mdds.v1.StockVolatility} returns this
 */
proto.proto.mdds.v1.StockVolatility.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.StockInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.StockInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.StockInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.StockInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    isin: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    tradingTime: (f = msg.getTradingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    productId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    productGrpId: jspb.Message.getFieldWithDefault(msg, 7, 0),
    securityGroupId: jspb.Message.getFieldWithDefault(msg, 8, 0),
    referencePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    highLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
    lowLimitPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    highestPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
    lowestPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    openPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
    closePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
    averagePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
    buyForeignQuantity: jspb.Message.getFieldWithDefault(msg, 17, 0),
    sellForeignQuantity: jspb.Message.getFieldWithDefault(msg, 18, 0),
    securityStatus: jspb.Message.getFieldWithDefault(msg, 19, 0),
    foreignerOrderLimitQuantity: jspb.Message.getFieldWithDefault(msg, 20, 0),
    expectedTradePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 21, 0.0),
    expectedTradeQuantity: jspb.Message.getFieldWithDefault(msg, 22, 0),
    openInterestQuantity: jspb.Message.getFieldWithDefault(msg, 23, 0),
    totalVolumeTraded: jspb.Message.getFieldWithDefault(msg, 24, 0),
    grossTradeAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
    sellTotalOrderQuantity: jspb.Message.getFieldWithDefault(msg, 26, 0),
    buyTotalOrderQuantity: jspb.Message.getFieldWithDefault(msg, 27, 0),
    matchPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
    matchQuantity: jspb.Message.getFieldWithDefault(msg, 29, 0),
    matchValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 30, 0.0),
    changedValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 31, 0.0),
    changedRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 32, 0.0),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 33, 0),
    bidQuantity: jspb.Message.getFieldWithDefault(msg, 34, 0),
    offerQuantity: jspb.Message.getFieldWithDefault(msg, 35, 0),
    lastTradingDate: (f = msg.getLastTradingDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    symbolType: jspb.Message.getFieldWithDefault(msg, 37, ""),
    putOrCall: jspb.Message.getFieldWithDefault(msg, 38, 0),
    exerciseStyle: jspb.Message.getFieldWithDefault(msg, 39, 0),
    maturityDate: (f = msg.getMaturityDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    issuer: jspb.Message.getFieldWithDefault(msg, 41, ""),
    issueDate: (f = msg.getIssueDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    contractMultiplier: jspb.Message.getFloatingPointFieldWithDefault(msg, 43, 0.0),
    strikePrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 44, 0.0),
    listedShares: jspb.Message.getFieldWithDefault(msg, 45, 0),
    settlementMethod: jspb.Message.getFieldWithDefault(msg, 46, 0),
    firstTradingDate: (f = msg.getFirstTradingDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    finalSettlementDate: (f = msg.getFinalSettlementDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    listingDate: (f = msg.getListingDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    couponRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 50, 0.0),
    yield: jspb.Message.getFloatingPointFieldWithDefault(msg, 51, 0.0),
    symbolAdminStatusCode: jspb.Message.getFieldWithDefault(msg, 52, 0),
    symbolTradingMethodStatusCode: jspb.Message.getFieldWithDefault(msg, 53, 0),
    symbolTradingSanctionStatusCode: jspb.Message.getFieldWithDefault(msg, 54, 0),
    boardIdOriginal: jspb.Message.getFieldWithDefault(msg, 55, 0),
    sectorTypeCode: jspb.Message.getFieldWithDefault(msg, 56, 0),
    redumptionDate: (f = msg.getRedumptionDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    buyForeignValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 58, 0.0),
    sellForeignValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 59, 0.0),
    foreignerBuyPossibleQuantity: jspb.Message.getFieldWithDefault(msg, 60, 0),
    symbolName: jspb.Message.getFieldWithDefault(msg, 61, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.StockInfo}
 */
proto.proto.mdds.v1.StockInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.StockInfo;
  return proto.proto.mdds.v1.StockInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.StockInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.StockInfo}
 */
proto.proto.mdds.v1.StockInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.mdds.v1.MarketID} */ (reader.readEnum());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTradingTime(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 7:
      var value = /** @type {!proto.proto.mdds.v1.ProductGrpID} */ (reader.readEnum());
      msg.setProductGrpId(value);
      break;
    case 8:
      var value = /** @type {!proto.proto.mdds.v1.SecurityGroupID} */ (reader.readEnum());
      msg.setSecurityGroupId(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setReferencePrice(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighLimitPrice(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowLimitPrice(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighestPrice(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowestPrice(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setOpenPrice(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setClosePrice(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAveragePrice(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyForeignQuantity(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellForeignQuantity(value);
      break;
    case 19:
      var value = /** @type {!proto.proto.mdds.v1.SISecurityStatus} */ (reader.readEnum());
      msg.setSecurityStatus(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setForeignerOrderLimitQuantity(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExpectedTradePrice(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setExpectedTradeQuantity(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOpenInterestQuantity(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalVolumeTraded(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGrossTradeAmount(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setSellTotalOrderQuantity(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBuyTotalOrderQuantity(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchPrice(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMatchQuantity(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchValue(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChangedValue(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChangedRatio(value);
      break;
    case 33:
      var value = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBidQuantity(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setOfferQuantity(value);
      break;
    case 36:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastTradingDate(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolType(value);
      break;
    case 38:
      var value = /** @type {!proto.proto.mdds.v1.PutOrCall} */ (reader.readEnum());
      msg.setPutOrCall(value);
      break;
    case 39:
      var value = /** @type {!proto.proto.mdds.v1.SIExerciseStyle} */ (reader.readEnum());
      msg.setExerciseStyle(value);
      break;
    case 40:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setMaturityDate(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssuer(value);
      break;
    case 42:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setIssueDate(value);
      break;
    case 43:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setContractMultiplier(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStrikePrice(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setListedShares(value);
      break;
    case 46:
      var value = /** @type {!proto.proto.mdds.v1.SettleMethod} */ (reader.readEnum());
      msg.setSettlementMethod(value);
      break;
    case 47:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFirstTradingDate(value);
      break;
    case 48:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFinalSettlementDate(value);
      break;
    case 49:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setListingDate(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCouponRate(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYield(value);
      break;
    case 52:
      var value = /** @type {!proto.proto.mdds.v1.SymbolAdminStatusCode} */ (reader.readEnum());
      msg.setSymbolAdminStatusCode(value);
      break;
    case 53:
      var value = /** @type {!proto.proto.mdds.v1.SymbolTradingMethodStatusCode} */ (reader.readEnum());
      msg.setSymbolTradingMethodStatusCode(value);
      break;
    case 54:
      var value = /** @type {!proto.proto.mdds.v1.SymbolTradingSanctionStatusCode} */ (reader.readEnum());
      msg.setSymbolTradingSanctionStatusCode(value);
      break;
    case 55:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardIdOriginal(value);
      break;
    case 56:
      var value = /** @type {!proto.proto.mdds.v1.SectorTypeCode} */ (reader.readEnum());
      msg.setSectorTypeCode(value);
      break;
    case 57:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRedumptionDate(value);
      break;
    case 58:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBuyForeignValue(value);
      break;
    case 59:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSellForeignValue(value);
      break;
    case 60:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setForeignerBuyPossibleQuantity(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.StockInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.StockInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.StockInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.StockInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIsin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTradingTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getProductGrpId();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSecurityGroupId();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getReferencePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getHighLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getLowLimitPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getHighestPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getLowestPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getOpenPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getClosePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getAveragePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getBuyForeignQuantity();
  if (f !== 0) {
    writer.writeUint64(
      17,
      f
    );
  }
  f = message.getSellForeignQuantity();
  if (f !== 0) {
    writer.writeUint64(
      18,
      f
    );
  }
  f = message.getSecurityStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getForeignerOrderLimitQuantity();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getExpectedTradePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      21,
      f
    );
  }
  f = message.getExpectedTradeQuantity();
  if (f !== 0) {
    writer.writeUint64(
      22,
      f
    );
  }
  f = message.getOpenInterestQuantity();
  if (f !== 0) {
    writer.writeUint64(
      23,
      f
    );
  }
  f = message.getTotalVolumeTraded();
  if (f !== 0) {
    writer.writeUint64(
      24,
      f
    );
  }
  f = message.getGrossTradeAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeUint64(
      26,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeUint64(
      27,
      f
    );
  }
  f = message.getMatchPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      28,
      f
    );
  }
  f = message.getMatchQuantity();
  if (f !== 0) {
    writer.writeUint64(
      29,
      f
    );
  }
  f = message.getMatchValue();
  if (f !== 0.0) {
    writer.writeDouble(
      30,
      f
    );
  }
  f = message.getChangedValue();
  if (f !== 0.0) {
    writer.writeDouble(
      31,
      f
    );
  }
  f = message.getChangedRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      32,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f !== 0.0) {
    writer.writeEnum(
      33,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 34));
  if (f != null) {
    writer.writeUint64(
      34,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 35));
  if (f != null) {
    writer.writeUint64(
      35,
      f
    );
  }
  f = message.getLastTradingDate();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSymbolType();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.PutOrCall} */ (jspb.Message.getField(message, 38));
  if (f != null) {
    writer.writeEnum(
      38,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SIExerciseStyle} */ (jspb.Message.getField(message, 39));
  if (f != null) {
    writer.writeEnum(
      39,
      f
    );
  }
  f = message.getMaturityDate();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 41));
  if (f != null) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getIssueDate();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContractMultiplier();
  if (f !== 0.0) {
    writer.writeDouble(
      43,
      f
    );
  }
  f = message.getStrikePrice();
  if (f !== 0.0) {
    writer.writeDouble(
      44,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 45));
  if (f != null) {
    writer.writeUint64(
      45,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SettleMethod} */ (jspb.Message.getField(message, 46));
  if (f != null) {
    writer.writeEnum(
      46,
      f
    );
  }
  f = message.getFirstTradingDate();
  if (f != null) {
    writer.writeMessage(
      47,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFinalSettlementDate();
  if (f != null) {
    writer.writeMessage(
      48,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getListingDate();
  if (f != null) {
    writer.writeMessage(
      49,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 50));
  if (f != null) {
    writer.writeDouble(
      50,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 51));
  if (f != null) {
    writer.writeDouble(
      51,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SymbolAdminStatusCode} */ (jspb.Message.getField(message, 52));
  if (f != null) {
    writer.writeEnum(
      52,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SymbolTradingMethodStatusCode} */ (jspb.Message.getField(message, 53));
  if (f != null) {
    writer.writeEnum(
      53,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SymbolTradingSanctionStatusCode} */ (jspb.Message.getField(message, 54));
  if (f != null) {
    writer.writeEnum(
      54,
      f
    );
  }
  f = message.getBoardIdOriginal();
  if (f !== 0.0) {
    writer.writeEnum(
      55,
      f
    );
  }
  f = /** @type {!proto.proto.mdds.v1.SectorTypeCode} */ (jspb.Message.getField(message, 56));
  if (f != null) {
    writer.writeEnum(
      56,
      f
    );
  }
  f = message.getRedumptionDate();
  if (f != null) {
    writer.writeMessage(
      57,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBuyForeignValue();
  if (f !== 0.0) {
    writer.writeDouble(
      58,
      f
    );
  }
  f = message.getSellForeignValue();
  if (f !== 0.0) {
    writer.writeDouble(
      59,
      f
    );
  }
  f = message.getForeignerBuyPossibleQuantity();
  if (f !== 0) {
    writer.writeUint64(
      60,
      f
    );
  }
  f = message.getSymbolName();
  if (f.length > 0) {
    writer.writeString(
      61,
      f
    );
  }
};


/**
 * optional MarketID market_id = 1;
 * @return {!proto.proto.mdds.v1.MarketID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getMarketId = function() {
  return /** @type {!proto.proto.mdds.v1.MarketID} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional BoardID board_id = 2;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBoardId = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string isin = 3;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getIsin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setIsin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp trading_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getTradingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setTradingTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearTradingTime = function() {
  return this.setTradingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasTradingTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string product_id = 6;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional ProductGrpID product_grp_id = 7;
 * @return {!proto.proto.mdds.v1.ProductGrpID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getProductGrpId = function() {
  return /** @type {!proto.proto.mdds.v1.ProductGrpID} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.proto.mdds.v1.ProductGrpID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setProductGrpId = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional SecurityGroupID security_group_id = 8;
 * @return {!proto.proto.mdds.v1.SecurityGroupID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSecurityGroupId = function() {
  return /** @type {!proto.proto.mdds.v1.SecurityGroupID} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SecurityGroupID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSecurityGroupId = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional double reference_price = 9;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getReferencePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setReferencePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double high_limit_price = 10;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getHighLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setHighLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double low_limit_price = 11;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getLowLimitPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setLowLimitPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double highest_price = 12;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getHighestPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setHighestPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double lowest_price = 13;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getLowestPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setLowestPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double open_price = 14;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getOpenPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setOpenPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double close_price = 15;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getClosePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setClosePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double average_price = 16;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getAveragePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setAveragePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional uint64 buy_foreign_quantity = 17;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBuyForeignQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBuyForeignQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional uint64 sell_foreign_quantity = 18;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSellForeignQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSellForeignQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional SISecurityStatus security_status = 19;
 * @return {!proto.proto.mdds.v1.SISecurityStatus}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSecurityStatus = function() {
  return /** @type {!proto.proto.mdds.v1.SISecurityStatus} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SISecurityStatus} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSecurityStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional int64 foreigner_order_limit_quantity = 20;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getForeignerOrderLimitQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setForeignerOrderLimitQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional double expected_trade_price = 21;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getExpectedTradePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 21, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setExpectedTradePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 21, value);
};


/**
 * optional uint64 expected_trade_quantity = 22;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getExpectedTradeQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setExpectedTradeQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional uint64 open_interest_quantity = 23;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getOpenInterestQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setOpenInterestQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional uint64 total_volume_traded = 24;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getTotalVolumeTraded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setTotalVolumeTraded = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional double gross_trade_amount = 25;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getGrossTradeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setGrossTradeAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional uint64 sell_total_order_quantity = 26;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSellTotalOrderQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSellTotalOrderQuantity = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSellTotalOrderQuantity = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSellTotalOrderQuantity = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional uint64 buy_total_order_quantity = 27;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBuyTotalOrderQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBuyTotalOrderQuantity = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearBuyTotalOrderQuantity = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasBuyTotalOrderQuantity = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional double match_price = 28;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getMatchPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setMatchPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional uint64 match_quantity = 29;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getMatchQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setMatchQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional double match_value = 30;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getMatchValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setMatchValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 30, value);
};


/**
 * optional double changed_value = 31;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getChangedValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 31, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setChangedValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 31, value);
};


/**
 * optional double changed_ratio = 32;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getChangedRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 32, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setChangedRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 32, value);
};


/**
 * optional TradingSessionID trading_session_id = 33;
 * @return {!proto.proto.mdds.v1.TradingSessionID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getTradingSessionId = function() {
  return /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TradingSessionID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3EnumField(this, 33, value);
};


/**
 * optional uint64 bid_quantity = 34;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBidQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBidQuantity = function(value) {
  return jspb.Message.setField(this, 34, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearBidQuantity = function() {
  return jspb.Message.setField(this, 34, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasBidQuantity = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional uint64 offer_quantity = 35;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getOfferQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setOfferQuantity = function(value) {
  return jspb.Message.setField(this, 35, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearOfferQuantity = function() {
  return jspb.Message.setField(this, 35, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasOfferQuantity = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional google.protobuf.Timestamp last_trading_date = 36;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getLastTradingDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 36));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setLastTradingDate = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearLastTradingDate = function() {
  return this.setLastTradingDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasLastTradingDate = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional string symbol_type = 37;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbolType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbolType = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional PutOrCall put_or_call = 38;
 * @return {!proto.proto.mdds.v1.PutOrCall}
 */
proto.proto.mdds.v1.StockInfo.prototype.getPutOrCall = function() {
  return /** @type {!proto.proto.mdds.v1.PutOrCall} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/**
 * @param {!proto.proto.mdds.v1.PutOrCall} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setPutOrCall = function(value) {
  return jspb.Message.setField(this, 38, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearPutOrCall = function() {
  return jspb.Message.setField(this, 38, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasPutOrCall = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional SIExerciseStyle exercise_style = 39;
 * @return {!proto.proto.mdds.v1.SIExerciseStyle}
 */
proto.proto.mdds.v1.StockInfo.prototype.getExerciseStyle = function() {
  return /** @type {!proto.proto.mdds.v1.SIExerciseStyle} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SIExerciseStyle} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setExerciseStyle = function(value) {
  return jspb.Message.setField(this, 39, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearExerciseStyle = function() {
  return jspb.Message.setField(this, 39, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasExerciseStyle = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional google.protobuf.Timestamp maturity_date = 40;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getMaturityDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 40));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setMaturityDate = function(value) {
  return jspb.Message.setWrapperField(this, 40, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearMaturityDate = function() {
  return this.setMaturityDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasMaturityDate = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional string issuer = 41;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setIssuer = function(value) {
  return jspb.Message.setField(this, 41, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearIssuer = function() {
  return jspb.Message.setField(this, 41, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasIssuer = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * optional google.protobuf.Timestamp issue_date = 42;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getIssueDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 42));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setIssueDate = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearIssueDate = function() {
  return this.setIssueDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasIssueDate = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional double contract_multiplier = 43;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getContractMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 43, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setContractMultiplier = function(value) {
  return jspb.Message.setProto3FloatField(this, 43, value);
};


/**
 * optional double strike_price = 44;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getStrikePrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 44, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setStrikePrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 44, value);
};


/**
 * optional uint64 listed_shares = 45;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getListedShares = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setListedShares = function(value) {
  return jspb.Message.setField(this, 45, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearListedShares = function() {
  return jspb.Message.setField(this, 45, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasListedShares = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional SettleMethod settlement_method = 46;
 * @return {!proto.proto.mdds.v1.SettleMethod}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSettlementMethod = function() {
  return /** @type {!proto.proto.mdds.v1.SettleMethod} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SettleMethod} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSettlementMethod = function(value) {
  return jspb.Message.setField(this, 46, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSettlementMethod = function() {
  return jspb.Message.setField(this, 46, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSettlementMethod = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional google.protobuf.Timestamp first_trading_date = 47;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getFirstTradingDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 47));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setFirstTradingDate = function(value) {
  return jspb.Message.setWrapperField(this, 47, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearFirstTradingDate = function() {
  return this.setFirstTradingDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasFirstTradingDate = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional google.protobuf.Timestamp final_settlement_date = 48;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getFinalSettlementDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 48));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setFinalSettlementDate = function(value) {
  return jspb.Message.setWrapperField(this, 48, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearFinalSettlementDate = function() {
  return this.setFinalSettlementDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasFinalSettlementDate = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional google.protobuf.Timestamp listing_date = 49;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getListingDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 49));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setListingDate = function(value) {
  return jspb.Message.setWrapperField(this, 49, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearListingDate = function() {
  return this.setListingDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasListingDate = function() {
  return jspb.Message.getField(this, 49) != null;
};


/**
 * optional double coupon_rate = 50;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getCouponRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 50, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setCouponRate = function(value) {
  return jspb.Message.setField(this, 50, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearCouponRate = function() {
  return jspb.Message.setField(this, 50, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasCouponRate = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional double yield = 51;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 51, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setYield = function(value) {
  return jspb.Message.setField(this, 51, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearYield = function() {
  return jspb.Message.setField(this, 51, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasYield = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional SymbolAdminStatusCode symbol_admin_status_code = 52;
 * @return {!proto.proto.mdds.v1.SymbolAdminStatusCode}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbolAdminStatusCode = function() {
  return /** @type {!proto.proto.mdds.v1.SymbolAdminStatusCode} */ (jspb.Message.getFieldWithDefault(this, 52, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SymbolAdminStatusCode} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbolAdminStatusCode = function(value) {
  return jspb.Message.setField(this, 52, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSymbolAdminStatusCode = function() {
  return jspb.Message.setField(this, 52, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSymbolAdminStatusCode = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional SymbolTradingMethodStatusCode symbol_trading_method_status_code = 53;
 * @return {!proto.proto.mdds.v1.SymbolTradingMethodStatusCode}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbolTradingMethodStatusCode = function() {
  return /** @type {!proto.proto.mdds.v1.SymbolTradingMethodStatusCode} */ (jspb.Message.getFieldWithDefault(this, 53, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SymbolTradingMethodStatusCode} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbolTradingMethodStatusCode = function(value) {
  return jspb.Message.setField(this, 53, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSymbolTradingMethodStatusCode = function() {
  return jspb.Message.setField(this, 53, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSymbolTradingMethodStatusCode = function() {
  return jspb.Message.getField(this, 53) != null;
};


/**
 * optional SymbolTradingSanctionStatusCode symbol_trading_sanction_status_code = 54;
 * @return {!proto.proto.mdds.v1.SymbolTradingSanctionStatusCode}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbolTradingSanctionStatusCode = function() {
  return /** @type {!proto.proto.mdds.v1.SymbolTradingSanctionStatusCode} */ (jspb.Message.getFieldWithDefault(this, 54, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SymbolTradingSanctionStatusCode} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbolTradingSanctionStatusCode = function(value) {
  return jspb.Message.setField(this, 54, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSymbolTradingSanctionStatusCode = function() {
  return jspb.Message.setField(this, 54, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSymbolTradingSanctionStatusCode = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * optional BoardID board_id_original = 55;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBoardIdOriginal = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBoardIdOriginal = function(value) {
  return jspb.Message.setProto3EnumField(this, 55, value);
};


/**
 * optional SectorTypeCode sector_type_code = 56;
 * @return {!proto.proto.mdds.v1.SectorTypeCode}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSectorTypeCode = function() {
  return /** @type {!proto.proto.mdds.v1.SectorTypeCode} */ (jspb.Message.getFieldWithDefault(this, 56, 0));
};


/**
 * @param {!proto.proto.mdds.v1.SectorTypeCode} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSectorTypeCode = function(value) {
  return jspb.Message.setField(this, 56, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearSectorTypeCode = function() {
  return jspb.Message.setField(this, 56, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasSectorTypeCode = function() {
  return jspb.Message.getField(this, 56) != null;
};


/**
 * optional google.protobuf.Timestamp redumption_date = 57;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.StockInfo.prototype.getRedumptionDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 57));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
*/
proto.proto.mdds.v1.StockInfo.prototype.setRedumptionDate = function(value) {
  return jspb.Message.setWrapperField(this, 57, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.clearRedumptionDate = function() {
  return this.setRedumptionDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.StockInfo.prototype.hasRedumptionDate = function() {
  return jspb.Message.getField(this, 57) != null;
};


/**
 * optional double buy_foreign_value = 58;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getBuyForeignValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 58, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setBuyForeignValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 58, value);
};


/**
 * optional double sell_foreign_value = 59;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSellForeignValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 59, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSellForeignValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 59, value);
};


/**
 * optional uint64 foreigner_buy_possible_quantity = 60;
 * @return {number}
 */
proto.proto.mdds.v1.StockInfo.prototype.getForeignerBuyPossibleQuantity = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 60, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setForeignerBuyPossibleQuantity = function(value) {
  return jspb.Message.setProto3IntField(this, 60, value);
};


/**
 * optional string symbol_name = 61;
 * @return {string}
 */
proto.proto.mdds.v1.StockInfo.prototype.getSymbolName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.StockInfo} returns this
 */
proto.proto.mdds.v1.StockInfo.prototype.setSymbolName = function(value) {
  return jspb.Message.setProto3StringField(this, 61, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.BoardEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.BoardEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.BoardEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.BoardEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    eventId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 5, 0),
    tscProdGrpId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    boardIdOriginal: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.BoardEvent}
 */
proto.proto.mdds.v1.BoardEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.BoardEvent;
  return proto.proto.mdds.v1.BoardEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.BoardEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.BoardEvent}
 */
proto.proto.mdds.v1.BoardEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.mdds.v1.MarketID} */ (reader.readEnum());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {!proto.proto.mdds.v1.BoardEventID} */ (reader.readEnum());
      msg.setEventId(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 5:
      var value = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 6:
      var value = /** @type {!proto.proto.mdds.v1.TscProdGrpId} */ (reader.readEnum());
      msg.setTscProdGrpId(value);
      break;
    case 7:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardIdOriginal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.BoardEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.BoardEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.BoardEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.BoardEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEventId();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getTscProdGrpId();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getBoardIdOriginal();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional MarketID market_id = 1;
 * @return {!proto.proto.mdds.v1.MarketID}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getMarketId = function() {
  return /** @type {!proto.proto.mdds.v1.MarketID} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketID} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional BoardID board_id = 2;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getBoardId = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional BoardEventID event_id = 3;
 * @return {!proto.proto.mdds.v1.BoardEventID}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getEventId = function() {
  return /** @type {!proto.proto.mdds.v1.BoardEventID} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardEventID} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setEventId = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp sending_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
*/
proto.proto.mdds.v1.BoardEvent.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.BoardEvent.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional TradingSessionID trading_session_id = 5;
 * @return {!proto.proto.mdds.v1.TradingSessionID}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getTradingSessionId = function() {
  return /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TradingSessionID} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.clearTradingSessionId = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.BoardEvent.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional TscProdGrpId tsc_prod_grp_id = 6;
 * @return {!proto.proto.mdds.v1.TscProdGrpId}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getTscProdGrpId = function() {
  return /** @type {!proto.proto.mdds.v1.TscProdGrpId} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TscProdGrpId} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setTscProdGrpId = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional BoardID board_id_original = 7;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.BoardEvent.prototype.getBoardIdOriginal = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.BoardEvent} returns this
 */
proto.proto.mdds.v1.BoardEvent.prototype.setBoardIdOriginal = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.SymbolBoardEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.SymbolBoardEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SymbolBoardEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    boardEvent: (f = msg.getBoardEvent()) && proto.proto.mdds.v1.BoardEvent.toObject(includeInstance, f),
    symbol: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.SymbolBoardEvent}
 */
proto.proto.mdds.v1.SymbolBoardEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.SymbolBoardEvent;
  return proto.proto.mdds.v1.SymbolBoardEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.SymbolBoardEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.SymbolBoardEvent}
 */
proto.proto.mdds.v1.SymbolBoardEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.mdds.v1.BoardEvent;
      reader.readMessage(value,proto.proto.mdds.v1.BoardEvent.deserializeBinaryFromReader);
      msg.setBoardEvent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.SymbolBoardEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.SymbolBoardEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.SymbolBoardEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBoardEvent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.mdds.v1.BoardEvent.serializeBinaryToWriter
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional BoardEvent board_event = 1;
 * @return {?proto.proto.mdds.v1.BoardEvent}
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.getBoardEvent = function() {
  return /** @type{?proto.proto.mdds.v1.BoardEvent} */ (
    jspb.Message.getWrapperField(this, proto.proto.mdds.v1.BoardEvent, 1));
};


/**
 * @param {?proto.proto.mdds.v1.BoardEvent|undefined} value
 * @return {!proto.proto.mdds.v1.SymbolBoardEvent} returns this
*/
proto.proto.mdds.v1.SymbolBoardEvent.prototype.setBoardEvent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.SymbolBoardEvent} returns this
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.clearBoardEvent = function() {
  return this.setBoardEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.hasBoardEvent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string symbol = 2;
 * @return {string}
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.SymbolBoardEvent} returns this
 */
proto.proto.mdds.v1.SymbolBoardEvent.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.MarketIndex.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.MarketIndex.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.MarketIndex} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MarketIndex.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    marketIndexClass: jspb.Message.getFieldWithDefault(msg, 3, 0),
    indexTypeCode: jspb.Message.getFieldWithDefault(msg, 4, ""),
    currencyCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    transactTime: (f = msg.getTransactTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    valueIndexes: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    totalVolumeTraded: jspb.Message.getFieldWithDefault(msg, 8, 0),
    grossTradeAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    contauctAccTrdVol: jspb.Message.getFieldWithDefault(msg, 10, 0),
    contauctAccTrdVal: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    blkTrdAccTrdVol: jspb.Message.getFieldWithDefault(msg, 12, 0),
    blkTrdAccTrdVal: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
    fluctuationUpperLimitIssueCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
    fluctuationUpIssueCount: jspb.Message.getFieldWithDefault(msg, 15, 0),
    fluctuationSteadinessIssueCount: jspb.Message.getFieldWithDefault(msg, 16, 0),
    fluctuationDownIssueCount: jspb.Message.getFieldWithDefault(msg, 17, 0),
    fluctuationLowerLimitIssueCount: jspb.Message.getFieldWithDefault(msg, 18, 0),
    fluctuationUpIssueVolume: jspb.Message.getFieldWithDefault(msg, 19, 0),
    fluctuationSteadinessIssueVolume: jspb.Message.getFieldWithDefault(msg, 20, 0),
    fluctuationDownIssueVolume: jspb.Message.getFieldWithDefault(msg, 21, 0),
    highestValueIndexes: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
    lowestValueIndexes: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
    changedValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
    changedRatio: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
    priorValueIndexes: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0),
    indexName: jspb.Message.getFieldWithDefault(msg, 27, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.MarketIndex}
 */
proto.proto.mdds.v1.MarketIndex.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.MarketIndex;
  return proto.proto.mdds.v1.MarketIndex.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.MarketIndex} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.MarketIndex}
 */
proto.proto.mdds.v1.MarketIndex.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.mdds.v1.MarketID} */ (reader.readEnum());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 3:
      var value = /** @type {!proto.proto.mdds.v1.MarketIndexClass} */ (reader.readEnum());
      msg.setMarketIndexClass(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexTypeCode(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrencyCode(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValueIndexes(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalVolumeTraded(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGrossTradeAmount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setContauctAccTrdVol(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setContauctAccTrdVal(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setBlkTrdAccTrdVol(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setBlkTrdAccTrdVal(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationUpperLimitIssueCount(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationUpIssueCount(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationSteadinessIssueCount(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationDownIssueCount(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setFluctuationLowerLimitIssueCount(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFluctuationUpIssueVolume(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFluctuationSteadinessIssueVolume(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setFluctuationDownIssueVolume(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHighestValueIndexes(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setLowestValueIndexes(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChangedValue(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setChangedRatio(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPriorValueIndexes(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndexName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.MarketIndex.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.MarketIndex.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.MarketIndex} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.MarketIndex.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMarketIndexClass();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getIndexTypeCode();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCurrencyCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getValueIndexes();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getTotalVolumeTraded();
  if (f !== 0) {
    writer.writeUint64(
      8,
      f
    );
  }
  f = message.getGrossTradeAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getContauctAccTrdVol();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getContauctAccTrdVal();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getBlkTrdAccTrdVol();
  if (f !== 0) {
    writer.writeUint64(
      12,
      f
    );
  }
  f = message.getBlkTrdAccTrdVal();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getFluctuationUpperLimitIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      14,
      f
    );
  }
  f = message.getFluctuationUpIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      15,
      f
    );
  }
  f = message.getFluctuationSteadinessIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      16,
      f
    );
  }
  f = message.getFluctuationDownIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      17,
      f
    );
  }
  f = message.getFluctuationLowerLimitIssueCount();
  if (f !== 0) {
    writer.writeUint32(
      18,
      f
    );
  }
  f = message.getFluctuationUpIssueVolume();
  if (f !== 0) {
    writer.writeUint64(
      19,
      f
    );
  }
  f = message.getFluctuationSteadinessIssueVolume();
  if (f !== 0) {
    writer.writeUint64(
      20,
      f
    );
  }
  f = message.getFluctuationDownIssueVolume();
  if (f !== 0) {
    writer.writeUint64(
      21,
      f
    );
  }
  f = message.getHighestValueIndexes();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getLowestValueIndexes();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getChangedValue();
  if (f !== 0.0) {
    writer.writeDouble(
      24,
      f
    );
  }
  f = message.getChangedRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = message.getPriorValueIndexes();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getIndexName();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
};


/**
 * optional MarketID market_id = 1;
 * @return {!proto.proto.mdds.v1.MarketID}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getMarketId = function() {
  return /** @type {!proto.proto.mdds.v1.MarketID} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketID} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional TradingSessionID trading_session_id = 2;
 * @return {!proto.proto.mdds.v1.TradingSessionID}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getTradingSessionId = function() {
  return /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TradingSessionID} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional MarketIndexClass market_index_class = 3;
 * @return {!proto.proto.mdds.v1.MarketIndexClass}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getMarketIndexClass = function() {
  return /** @type {!proto.proto.mdds.v1.MarketIndexClass} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketIndexClass} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setMarketIndexClass = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string index_type_code = 4;
 * @return {string}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getIndexTypeCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setIndexTypeCode = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string currency_code = 5;
 * @return {string}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getCurrencyCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setCurrencyCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp transact_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getTransactTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
*/
proto.proto.mdds.v1.MarketIndex.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.MarketIndex.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional double value_indexes = 7;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getValueIndexes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setValueIndexes = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional uint64 total_volume_traded = 8;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getTotalVolumeTraded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setTotalVolumeTraded = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double gross_trade_amount = 9;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getGrossTradeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setGrossTradeAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional uint64 contauct_acc_trd_vol = 10;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getContauctAccTrdVol = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setContauctAccTrdVol = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double contauct_acc_trd_val = 11;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getContauctAccTrdVal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setContauctAccTrdVal = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional uint64 blk_trd_acc_trd_vol = 12;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getBlkTrdAccTrdVol = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setBlkTrdAccTrdVol = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional double blk_trd_acc_trd_val = 13;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getBlkTrdAccTrdVal = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setBlkTrdAccTrdVal = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional uint32 fluctuation_upper_limit_issue_count = 14;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationUpperLimitIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationUpperLimitIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional uint32 fluctuation_up_issue_count = 15;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationUpIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationUpIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional uint32 fluctuation_steadiness_issue_count = 16;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationSteadinessIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationSteadinessIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional uint32 fluctuation_down_issue_count = 17;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationDownIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationDownIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional uint32 fluctuation_lower_limit_issue_count = 18;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationLowerLimitIssueCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationLowerLimitIssueCount = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional uint64 fluctuation_up_issue_volume = 19;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationUpIssueVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationUpIssueVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional uint64 fluctuation_steadiness_issue_volume = 20;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationSteadinessIssueVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationSteadinessIssueVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional uint64 fluctuation_down_issue_volume = 21;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getFluctuationDownIssueVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setFluctuationDownIssueVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional double highest_value_indexes = 22;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getHighestValueIndexes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setHighestValueIndexes = function(value) {
  return jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional double lowest_value_indexes = 23;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getLowestValueIndexes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setLowestValueIndexes = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional double changed_value = 24;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getChangedValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 24, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setChangedValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 24, value);
};


/**
 * optional double changed_ratio = 25;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getChangedRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setChangedRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional double prior_value_indexes = 26;
 * @return {number}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getPriorValueIndexes = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setPriorValueIndexes = function(value) {
  return jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional string index_name = 27;
 * @return {string}
 */
proto.proto.mdds.v1.MarketIndex.prototype.getIndexName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.MarketIndex} returns this
 */
proto.proto.mdds.v1.MarketIndex.prototype.setIndexName = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.Tick.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.Tick.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.Tick} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Tick.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    isin: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    matchPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    matchQtty: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    boardIdOriginal: jspb.Message.getFieldWithDefault(msg, 8, 0),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    totalVolumeTraded: jspb.Message.getFieldWithDefault(msg, 10, 0),
    grossTradeAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
    side: jspb.Message.getFieldWithDefault(msg, 12, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.Tick}
 */
proto.proto.mdds.v1.Tick.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.Tick;
  return proto.proto.mdds.v1.Tick.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.Tick} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.Tick}
 */
proto.proto.mdds.v1.Tick.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.mdds.v1.MarketID} */ (reader.readEnum());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchPrice(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMatchQtty(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 8:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardIdOriginal(value);
      break;
    case 9:
      var value = /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTotalVolumeTraded(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGrossTradeAmount(value);
      break;
    case 12:
      var value = /** @type {!proto.proto.mdds.v1.Tick.Side} */ (reader.readEnum());
      msg.setSide(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.Tick.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.Tick.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.Tick} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.Tick.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIsin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMatchPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getMatchQtty();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBoardIdOriginal();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getTradingSessionId();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getTotalVolumeTraded();
  if (f !== 0) {
    writer.writeUint64(
      10,
      f
    );
  }
  f = message.getGrossTradeAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.proto.mdds.v1.Tick.Side = {
  SIDE_UNSPECIFIED: 0,
  SIDE_BUY: 1,
  SIDE_SELL: 2
};

/**
 * optional MarketID market_id = 1;
 * @return {!proto.proto.mdds.v1.MarketID}
 */
proto.proto.mdds.v1.Tick.prototype.getMarketId = function() {
  return /** @type {!proto.proto.mdds.v1.MarketID} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketID} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional BoardID board_id = 2;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.Tick.prototype.getBoardId = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string isin = 3;
 * @return {string}
 */
proto.proto.mdds.v1.Tick.prototype.getIsin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setIsin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.Tick.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double match_price = 5;
 * @return {number}
 */
proto.proto.mdds.v1.Tick.prototype.getMatchPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setMatchPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double match_qtty = 6;
 * @return {number}
 */
proto.proto.mdds.v1.Tick.prototype.getMatchQtty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setMatchQtty = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp sending_time = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.Tick.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
*/
proto.proto.mdds.v1.Tick.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.Tick.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional BoardID board_id_original = 8;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.Tick.prototype.getBoardIdOriginal = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setBoardIdOriginal = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional TradingSessionID trading_session_id = 9;
 * @return {!proto.proto.mdds.v1.TradingSessionID}
 */
proto.proto.mdds.v1.Tick.prototype.getTradingSessionId = function() {
  return /** @type {!proto.proto.mdds.v1.TradingSessionID} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.proto.mdds.v1.TradingSessionID} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional uint64 total_volume_traded = 10;
 * @return {number}
 */
proto.proto.mdds.v1.Tick.prototype.getTotalVolumeTraded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setTotalVolumeTraded = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double gross_trade_amount = 11;
 * @return {number}
 */
proto.proto.mdds.v1.Tick.prototype.getGrossTradeAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setGrossTradeAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional Side side = 12;
 * @return {!proto.proto.mdds.v1.Tick.Side}
 */
proto.proto.mdds.v1.Tick.prototype.getSide = function() {
  return /** @type {!proto.proto.mdds.v1.Tick.Side} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.proto.mdds.v1.Tick.Side} value
 * @return {!proto.proto.mdds.v1.Tick} returns this
 */
proto.proto.mdds.v1.Tick.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.proto.mdds.v1.TopPrice.repeatedFields_ = [6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.TopPrice.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.TopPrice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.TopPrice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopPrice.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    boardId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    isin: jspb.Message.getFieldWithDefault(msg, 3, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 4, ""),
    sendingTime: (f = msg.getSendingTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    bidList: jspb.Message.toObjectList(msg.getBidList(),
    proto.proto.mdds.v1.OrderMini.toObject, includeInstance),
    offerList: jspb.Message.toObjectList(msg.getOfferList(),
    proto.proto.mdds.v1.OrderMini.toObject, includeInstance),
    totalOfferQtty: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
    totalBidQtty: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    boardIdOriginal: jspb.Message.getFieldWithDefault(msg, 10, 0),
    symbolType: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.TopPrice}
 */
proto.proto.mdds.v1.TopPrice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.TopPrice;
  return proto.proto.mdds.v1.TopPrice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.TopPrice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.TopPrice}
 */
proto.proto.mdds.v1.TopPrice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.proto.mdds.v1.MarketID} */ (reader.readEnum());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setIsin(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendingTime(value);
      break;
    case 6:
      var value = new proto.proto.mdds.v1.OrderMini;
      reader.readMessage(value,proto.proto.mdds.v1.OrderMini.deserializeBinaryFromReader);
      msg.addBid(value);
      break;
    case 7:
      var value = new proto.proto.mdds.v1.OrderMini;
      reader.readMessage(value,proto.proto.mdds.v1.OrderMini.deserializeBinaryFromReader);
      msg.addOffer(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalOfferQtty(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalBidQtty(value);
      break;
    case 10:
      var value = /** @type {!proto.proto.mdds.v1.BoardID} */ (reader.readEnum());
      msg.setBoardIdOriginal(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbolType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.TopPrice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.TopPrice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.TopPrice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.TopPrice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getBoardId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getIsin();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSendingTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBidList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.proto.mdds.v1.OrderMini.serializeBinaryToWriter
    );
  }
  f = message.getOfferList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.proto.mdds.v1.OrderMini.serializeBinaryToWriter
    );
  }
  f = message.getTotalOfferQtty();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getTotalBidQtty();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getBoardIdOriginal();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getSymbolType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional MarketID market_id = 1;
 * @return {!proto.proto.mdds.v1.MarketID}
 */
proto.proto.mdds.v1.TopPrice.prototype.getMarketId = function() {
  return /** @type {!proto.proto.mdds.v1.MarketID} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.proto.mdds.v1.MarketID} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional BoardID board_id = 2;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.TopPrice.prototype.getBoardId = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setBoardId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string isin = 3;
 * @return {string}
 */
proto.proto.mdds.v1.TopPrice.prototype.getIsin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setIsin = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string symbol = 4;
 * @return {string}
 */
proto.proto.mdds.v1.TopPrice.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional google.protobuf.Timestamp sending_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.proto.mdds.v1.TopPrice.prototype.getSendingTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
*/
proto.proto.mdds.v1.TopPrice.prototype.setSendingTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.clearSendingTime = function() {
  return this.setSendingTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.mdds.v1.TopPrice.prototype.hasSendingTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * repeated OrderMini bid = 6;
 * @return {!Array<!proto.proto.mdds.v1.OrderMini>}
 */
proto.proto.mdds.v1.TopPrice.prototype.getBidList = function() {
  return /** @type{!Array<!proto.proto.mdds.v1.OrderMini>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.mdds.v1.OrderMini, 6));
};


/**
 * @param {!Array<!proto.proto.mdds.v1.OrderMini>} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
*/
proto.proto.mdds.v1.TopPrice.prototype.setBidList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.proto.mdds.v1.OrderMini=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.OrderMini}
 */
proto.proto.mdds.v1.TopPrice.prototype.addBid = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.proto.mdds.v1.OrderMini, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.clearBidList = function() {
  return this.setBidList([]);
};


/**
 * repeated OrderMini offer = 7;
 * @return {!Array<!proto.proto.mdds.v1.OrderMini>}
 */
proto.proto.mdds.v1.TopPrice.prototype.getOfferList = function() {
  return /** @type{!Array<!proto.proto.mdds.v1.OrderMini>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.proto.mdds.v1.OrderMini, 7));
};


/**
 * @param {!Array<!proto.proto.mdds.v1.OrderMini>} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
*/
proto.proto.mdds.v1.TopPrice.prototype.setOfferList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.proto.mdds.v1.OrderMini=} opt_value
 * @param {number=} opt_index
 * @return {!proto.proto.mdds.v1.OrderMini}
 */
proto.proto.mdds.v1.TopPrice.prototype.addOffer = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.proto.mdds.v1.OrderMini, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.clearOfferList = function() {
  return this.setOfferList([]);
};


/**
 * optional double total_offer_qtty = 8;
 * @return {number}
 */
proto.proto.mdds.v1.TopPrice.prototype.getTotalOfferQtty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setTotalOfferQtty = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double total_bid_qtty = 9;
 * @return {number}
 */
proto.proto.mdds.v1.TopPrice.prototype.getTotalBidQtty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setTotalBidQtty = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional BoardID board_id_original = 10;
 * @return {!proto.proto.mdds.v1.BoardID}
 */
proto.proto.mdds.v1.TopPrice.prototype.getBoardIdOriginal = function() {
  return /** @type {!proto.proto.mdds.v1.BoardID} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.proto.mdds.v1.BoardID} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setBoardIdOriginal = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string symbol_type = 11;
 * @return {string}
 */
proto.proto.mdds.v1.TopPrice.prototype.getSymbolType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.mdds.v1.TopPrice} returns this
 */
proto.proto.mdds.v1.TopPrice.prototype.setSymbolType = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.mdds.v1.OrderMini.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.mdds.v1.OrderMini.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.mdds.v1.OrderMini} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.OrderMini.toObject = function(includeInstance, msg) {
  var f, obj = {
    price: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    qtty: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.mdds.v1.OrderMini}
 */
proto.proto.mdds.v1.OrderMini.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.mdds.v1.OrderMini;
  return proto.proto.mdds.v1.OrderMini.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.mdds.v1.OrderMini} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.mdds.v1.OrderMini}
 */
proto.proto.mdds.v1.OrderMini.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPrice(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setQtty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.mdds.v1.OrderMini.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.mdds.v1.OrderMini.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.mdds.v1.OrderMini} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.mdds.v1.OrderMini.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getQtty();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional double price = 1;
 * @return {number}
 */
proto.proto.mdds.v1.OrderMini.prototype.getPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.OrderMini} returns this
 */
proto.proto.mdds.v1.OrderMini.prototype.setPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double qtty = 2;
 * @return {number}
 */
proto.proto.mdds.v1.OrderMini.prototype.getQtty = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.proto.mdds.v1.OrderMini} returns this
 */
proto.proto.mdds.v1.OrderMini.prototype.setQtty = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * @enum {number}
 */
proto.proto.mdds.v1.MarketIndexClass = {
  MARKET_INDEX_CLASS_UNSPECIFIED: 0,
  MARKET_INDEX_CLASS_HSX: 1,
  MARKET_INDEX_CLASS_HNX: 2,
  MARKET_INDEX_CLASS_COMPOSITE: 3,
  MARKET_INDEX_CLASS_UPX: 4
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.MarketID = {
  MARKET_ID_UNSPECIFIED: 0,
  MARKET_ID_BDO: 1,
  MARKET_ID_BDX: 2,
  MARKET_ID_DVX: 3,
  MARKET_ID_HCX: 4,
  MARKET_ID_RPO: 5,
  MARKET_ID_STO: 6,
  MARKET_ID_STX: 7,
  MARKET_ID_UPX: 8
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.BoardID = {
  BOARD_ID_UNSPECIFIED: 0,
  BOARD_ID_AL: 1,
  BOARD_ID_G1: 2,
  BOARD_ID_G2: 3,
  BOARD_ID_G3: 4,
  BOARD_ID_G4: 5,
  BOARD_ID_G7: 6,
  BOARD_ID_G8: 7,
  BOARD_ID_R1: 8,
  BOARD_ID_T1: 9,
  BOARD_ID_T2: 10,
  BOARD_ID_T3: 11,
  BOARD_ID_T4: 12,
  BOARD_ID_T6: 13
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.BoardEventID = {
  BOARD_EVENT_ID_UNSPECIFIED: 0,
  BOARD_EVENT_ID_AA1: 1,
  BOARD_EVENT_ID_AB1: 2,
  BOARD_EVENT_ID_AB2: 3,
  BOARD_EVENT_ID_AC2: 4,
  BOARD_EVENT_ID_AD1: 5,
  BOARD_EVENT_ID_AD2: 6,
  BOARD_EVENT_ID_AE1: 7,
  BOARD_EVENT_ID_AE8: 8,
  BOARD_EVENT_ID_AF1: 9,
  BOARD_EVENT_ID_AF6: 10,
  BOARD_EVENT_ID_AF7: 11,
  BOARD_EVENT_ID_AF8: 12,
  BOARD_EVENT_ID_AQ3: 13,
  BOARD_EVENT_ID_AT6: 14,
  BOARD_EVENT_ID_AW8: 15,
  BOARD_EVENT_ID_AW9: 16,
  BOARD_EVENT_ID_AX1: 17,
  BOARD_EVENT_ID_BB1: 18,
  BOARD_EVENT_ID_BC1: 19,
  BOARD_EVENT_ID_BE9: 20,
  BOARD_EVENT_ID_BF9: 21,
  BOARD_EVENT_ID_CC1: 22,
  BOARD_EVENT_ID_CD1: 23,
  BOARD_EVENT_ID_CD3: 24,
  BOARD_EVENT_ID_DB2: 25,
  BOARD_EVENT_ID_DC2: 26,
  BOARD_EVENT_ID_EI1: 27,
  BOARD_EVENT_ID_EI8: 28,
  BOARD_EVENT_ID_EI9: 29,
  BOARD_EVENT_ID_GT1: 30
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.ProductGrpID = {
  PRODUCT_GRP_ID_UNSPECIFIED: 0,
  PRODUCT_GRP_ID_BDO: 1,
  PRODUCT_GRP_ID_BDX: 2,
  PRODUCT_GRP_ID_FBX: 3,
  PRODUCT_GRP_ID_FIO: 4,
  PRODUCT_GRP_ID_HCX: 5,
  PRODUCT_GRP_ID_RPO: 6,
  PRODUCT_GRP_ID_STO: 7,
  PRODUCT_GRP_ID_STX: 8,
  PRODUCT_GRP_ID_UPX: 9
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SISecurityStatus = {
  SI_SECURITY_STATUS_UNSPECIFIED: 0,
  SI_SECURITY_STATUS_HALT: 1,
  SI_SECURITY_STATUS_NO_HALT: 2
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.TradingSessionID = {
  TRADING_SESSION_ID_UNSPECIFIED: 0,
  TRADING_SESSION_ID_01: 1,
  TRADING_SESSION_ID_10: 2,
  TRADING_SESSION_ID_11: 3,
  TRADING_SESSION_ID_20: 4,
  TRADING_SESSION_ID_21: 5,
  TRADING_SESSION_ID_30: 6,
  TRADING_SESSION_ID_40: 7,
  TRADING_SESSION_ID_50: 8,
  TRADING_SESSION_ID_51: 9,
  TRADING_SESSION_ID_60: 10,
  TRADING_SESSION_ID_70: 11,
  TRADING_SESSION_ID_80: 12,
  TRADING_SESSION_ID_90: 13,
  TRADING_SESSION_ID_99: 14
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.PutOrCall = {
  PUT_OR_CALL_UNSPECIFIED: 0,
  PUT_OR_CALL_PUT: 1,
  PUT_OR_CALL_CALL: 2
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SIExerciseStyle = {
  SI_EXERCISE_STYLE_UNSPECIFIED: 0,
  SI_EXERCISE_STYLE_AMERICAN: 1,
  SI_EXERCISE_STYLE_EUROPEAN: 2,
  SI_EXERCISE_STYLE_BERMUDA_STYLE: 3,
  SI_EXERCISE_STYLE_ETC: 4
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SettleMethod = {
  SETTLE_METHOD_UNSPECIFIED: 0,
  SETTLE_METHOD_CASH: 1,
  SETTLE_METHOD_ASSET: 2,
  SETTLE_METHOD_CASH_ASSET: 3,
  SETTLE_METHOD_NONE: 4
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SymbolAdminStatusCode = {
  SYMBOL_ADMIN_STATUS_CODE_UNSPECIFIED: 0,
  SYMBOL_ADMIN_STATUS_CODE_CR: 1,
  SYMBOL_ADMIN_STATUS_CODE_CTR: 2,
  SYMBOL_ADMIN_STATUS_CODE_NRM: 3,
  SYMBOL_ADMIN_STATUS_CODE_RES: 4,
  SYMBOL_ADMIN_STATUS_CODE_WFR: 5,
  SYMBOL_ADMIN_STATUS_CODE_WID: 6,
  SYMBOL_ADMIN_STATUS_CODE_WOV: 7
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SymbolTradingMethodStatusCode = {
  SYMBOL_TRADING_METHOD_STATUS_CODE_UNSPECIFIED: 0,
  SYMBOL_TRADING_METHOD_STATUS_CODE_NRM: 1,
  SYMBOL_TRADING_METHOD_STATUS_CODE_NWE: 2,
  SYMBOL_TRADING_METHOD_STATUS_CODE_NWN: 3,
  SYMBOL_TRADING_METHOD_STATUS_CODE_SLS: 4,
  SYMBOL_TRADING_METHOD_STATUS_CODE_SNE: 5
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SymbolTradingSanctionStatusCode = {
  SYMBOL_TRADING_SANCTION_STATUS_CODE_UNSPECIFIED: 0,
  SYMBOL_TRADING_SANCTION_STATUS_CODE_NRM: 1,
  SYMBOL_TRADING_SANCTION_STATUS_CODE_SUS: 2,
  SYMBOL_TRADING_SANCTION_STATUS_CODE_DTL: 3,
  SYMBOL_TRADING_SANCTION_STATUS_CODE_TFR: 4
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.TscProdGrpId = {
  TSC_PROD_GRP_ID_UNSPECIFIED: 0,
  TSC_PROD_GRP_ID_BDO: 1,
  TSC_PROD_GRP_ID_BDX: 2,
  TSC_PROD_GRP_ID_FBX: 3,
  TSC_PROD_GRP_ID_FIO: 4,
  TSC_PROD_GRP_ID_HCX: 5,
  TSC_PROD_GRP_ID_RPO: 6,
  TSC_PROD_GRP_ID_STO: 7,
  TSC_PROD_GRP_ID_STX: 8,
  TSC_PROD_GRP_ID_UPX: 9
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SecurityGroupID = {
  SECURITY_GROUP_ID_UNSPECIFIED: 0,
  SECURITY_GROUP_ID_BS: 1,
  SECURITY_GROUP_ID_EF: 2,
  SECURITY_GROUP_ID_EW: 3,
  SECURITY_GROUP_ID_FU: 4,
  SECURITY_GROUP_ID_MF: 5,
  SECURITY_GROUP_ID_SR: 6,
  SECURITY_GROUP_ID_ST: 7,
  SECURITY_GROUP_ID_BT: 8,
  SECURITY_GROUP_ID_BG: 9,
  SECURITY_GROUP_ID_DR: 10
};

/**
 * @enum {number}
 */
proto.proto.mdds.v1.SectorTypeCode = {
  SECTOR_TYPE_CODE_UNSPECIFIED: 0,
  SECTOR_TYPE_CODE_PREMIER: 1,
  SECTOR_TYPE_CODE_STANDARD: 2,
  SECTOR_TYPE_CODE_ALTERNATIVE: 3
};

goog.object.extend(exports, proto.proto.mdds.v1);
